import React from 'react';

export const SessionExpireSvg = () => (
  <svg
    width='200'
    height='201'
    fill='none'
    viewBox='0 0 200 200'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='200' height='200' rx='100' fill='#F0F2FA' />
    <g filter='url(#ai)'>
      <path d='m105.6 37.675h-13.11v8.5324h13.11v-8.5324z' fill='#F0EDFA' />
    </g>
    <g filter='url(#x)'>
      <path
        d='m55.906 54.671-7.1142 7.1106 5.1739 5.1713 7.1143-7.1106-5.174-5.1713z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#w)'>
      <path
        d='m139.1 59.318 7.114 7.1106 4.635-4.6327-7.114-7.1106-4.635 4.6327z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#v)'>
      <path
        d='m100 171c34.794 0 63-28.206 63-63 0-34.794-28.206-63-63-63-34.794 0-63 28.206-63 63 0 34.794 28.206 63 63 63z'
        fill='url(#o)'
      />
    </g>
    <g filter='url(#u)'>
      <path
        d='m148.48 107.54c-0.914 26.359-22.561 47.538-49.238 47.538-26.677 0-48.324-21.179-49.238-47.538 0.9146-26.359 22.561-47.537 49.238-47.537 26.677-0.1523 48.324 21.026 49.238 47.537z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#t)'>
      <circle cx='99.459' cy='107.46' r='17.459' fill='#D92D20' />
    </g>
    <path
      d='m96.968 97.484h4.9105l-1.309 13.641h-2.292l-1.3095-13.641z'
      fill='#fff'
    />
    <ellipse cx='99.424' cy='115.49' rx='2.4554' ry='2.1825' fill='#fff' />
    <g filter='url(#s)'>
      <path
        d='m144.64 109.78h-5.241c-0.89 0-1.583-1.067-1.583-2.438s0.693-2.438 1.583-2.438h5.241c0.89 0 1.583 1.067 1.583 2.438s-0.791 2.438-1.583 2.438z'
        fill='url(#i)'
      />
    </g>
    <g filter='url(#r)'>
      <path
        d='m59.738 109.78h-5.2416c-0.89 0-1.5823-1.067-1.5823-2.438s0.6923-2.438 1.5823-2.438h5.2416c0.8901 0 1.5824 1.067 1.5824 2.438s-0.7912 2.438-1.5824 2.438z'
        fill='url(#h)'
      />
    </g>
    <g filter='url(#q)'>
      <path
        d='m99.906 151.98c-1.372 0-2.4391-0.692-2.4391-1.582v-5.242c0-0.89 1.0671-1.582 2.4391-1.582 1.3719 0 2.4389 0.692 2.4389 1.582v3.542c0 1.131-0.044 2.445-1.052 2.959-0.399 0.204-0.88 0.323-1.3869 0.323z'
        fill='url(#g)'
      />
    </g>
    <g filter='url(#p)'>
      <path
        d='m99.906 70.438c-1.372 0-2.4391-0.7005-2.4391-1.6012v-5.2039c0-0.9007 1.0671-1.6012 2.4391-1.6012 1.3719 0 2.4389 0.7005 2.4389 1.6012v3.4169c0 1.2552-0.113 2.7093-1.281 3.1701-0.349 0.1376-0.745 0.2181-1.1579 0.2181z'
        fill='url(#f)'
      />
    </g>
    <g filter='url(#ah)'>
      <path
        d='m111.85 25.638v8.2277c0 3.1996-2.592 5.6374-5.64 5.6374h-14.025c-3.2013 0-5.6403-2.5902-5.6403-5.6374v-8.2277c0-3.1997 2.5914-5.6375 5.6403-5.6375h14.025c3.201 0 5.64 2.5902 5.64 5.6375z'
        fill='url(#e)'
      />
    </g>
    <g filter='url(#ag)'>
      <path
        d='m88.676 34.779c-0.4574 0-0.7622-0.3047-0.7622-0.7618v-9.4466c0-0.4571 0.3048-0.7618 0.7622-0.7618 0.4573 0 0.7622 0.3047 0.7622 0.7618v8.3023c0 0.7579-0.0043 1.9061-0.7622 1.9061z'
        fill='url(#d)'
      />
    </g>
    <g filter='url(#af)'>
      <path
        d='m92.184 34.779c-0.4573 0-0.7622-0.3047-0.7622-0.7618v-9.4466c0-0.4571 0.3049-0.7618 0.7622-0.7618 0.4574 0 0.7622 0.3047 0.7622 0.7618v9.4466c0 0.4571-0.3048 0.7618-0.7622 0.7618z'
        fill='url(#c)'
      />
    </g>
    <g filter='url(#ae)'>
      <path
        d='m95.841 34.779c-0.4573 0-0.7622-0.3047-0.7622-0.7618v-9.4466c0-0.4571 0.3049-0.7618 0.7622-0.7618s0.7622 0.3047 0.7622 0.7618v8.3023c0 0.7579-0.0043 1.9061-0.7622 1.9061z'
        fill='url(#b)'
      />
    </g>
    <g filter='url(#ad)'>
      <path
        d='m99.348 34.779c-0.4573 0-0.7622-0.3047-0.7622-0.7618v-9.4466c0-0.4571 0.3049-0.7618 0.7622-0.7618s0.7625 0.3047 0.7625 0.7618v9.4466c0 0.4571-0.3052 0.7618-0.7625 0.7618z'
        fill='url(#a)'
      />
    </g>
    <g filter='url(#ac)'>
      <path
        d='m103.01 34.779c-0.457 0-0.762-0.3047-0.762-0.7618v-9.4466c0-0.4571 0.305-0.7618 0.762-0.7618s0.762 0.3047 0.762 0.7618v8.3023c0 0.7579-4e-3 1.9061-0.762 1.9061z'
        fill='url(#n)'
      />
    </g>
    <g filter='url(#ab)'>
      <path
        d='m106.51 34.779c-0.457 0-0.762-0.3047-0.762-0.7618v-9.4466c0-0.4571 0.305-0.7618 0.762-0.7618s0.762 0.3047 0.762 0.7618v9.4466c0 0.4571-0.457 0.7618-0.762 0.7618z'
        fill='url(#m)'
      />
    </g>
    <g filter='url(#aa)'>
      <path
        d='m110.02 34.779c-0.458 0-0.763-0.3047-0.763-0.7618v-9.4466c0-0.4571 0.305-0.7618 0.763-0.7618 0.457 0 0.762 0.3047 0.762 0.7618v9.4466c0 0.4571-0.305 0.7618-0.762 0.7618z'
        fill='url(#l)'
      />
    </g>
    <g filter='url(#z)'>
      <path
        d='m57.274 55.348-7.6221 7.6182c-1.6768 1.6761-4.4207 1.6761-6.25 0l-4.4208-4.4185c-1.6768-1.676-1.6768-4.4186 0-6.247l7.622-7.6182c1.6769-1.676 4.4208-1.676 6.2501 0l4.4208 4.4186c1.6768 1.8284 1.6768 4.5709 0 6.2469z'
        fill='url(#k)'
      />
    </g>
    <g filter='url(#y)'>
      <path
        d='m142.34 55.348 7.622 7.6182c1.677 1.6761 4.421 1.6761 6.25 0l4.421-4.4185c1.677-1.676 1.677-4.4186 0-6.247l-7.622-7.6182c-1.677-1.676-4.421-1.676-6.25 0l-4.421 4.4186c-1.677 1.8284-1.677 4.5709 0 6.2469z'
        fill='url(#j)'
      />
    </g>
    <path
      d='m181.54 159.08c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.053c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.88 35.753c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m47.885 185.75c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m192.88 161c1.104 0 2-0.896 2-2 0-1.105-0.896-2-2-2-1.105 0-2 0.895-2 2 0 1.104 0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.513 30.301c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.012 30.3c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <defs>
      <filter
        id='ai'
        x='92.489'
        y='32.675'
        width='18.11'
        height='13.532'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='x'
        x='48.791'
        y='49.671'
        width='17.288'
        height='17.282'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='w'
        x='139.1'
        y='49.685'
        width='16.749'
        height='16.743'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='v'
        x='37'
        y='40'
        width='131'
        height='131'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='5' dy='-5' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='u'
        x='50'
        y='53'
        width='106.48'
        height='102.08'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='4' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.27 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='t'
        x='82'
        y='85'
        width='39.918'
        height='39.918'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.596078 0 0 0 0 0.121569 0 0 0 0 0.0862745 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='s'
        x='137.82'
        y='103.9'
        width='8.4064'
        height='5.8757'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='-2' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='r'
        x='52.914'
        y='104.9'
        width='8.4064'
        height='4.8757'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='q'
        x='97.467'
        y='143.57'
        width='6.878'
        height='8.4063'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='3' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='p'
        x='97.467'
        y='62.032'
        width='6.878'
        height='8.4063'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ah'
        x='80.542'
        y='14'
        width='31.305'
        height='25.503'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-10' dy='-6' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ag'
        x='87.914'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='af'
        x='91.422'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ae'
        x='95.078'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ad'
        x='98.585'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ac'
        x='102.24'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='ab'
        x='105.75'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='aa'
        x='109.26'
        y='23.809'
        width='2.5244'
        height='11.97'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='z'
        x='31.724'
        y='37.426'
        width='26.808'
        height='26.798'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-10' dy='-6' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <filter
        id='y'
        x='135.08'
        y='37.426'
        width='26.808'
        height='26.798'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-10' dy='-6' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_1294_76181' />
      </filter>
      <linearGradient
        id='o'
        x1='100'
        x2='160.38'
        y1='44.842'
        y2='170.84'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='i'
        x1='142.02'
        x2='143.35'
        y1='104.9'
        y2='110.09'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='57.117'
        x2='58.443'
        y1='104.9'
        y2='110.09'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='99.906'
        x2='104.49'
        y1='143.57'
        y2='149.6'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='99.906'
        x2='104.49'
        y1='62.032'
        y2='68.063'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='99.194'
        x2='106.99'
        y1='20'
        y2='41.102'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='88.676'
        x2='92.235'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='92.184'
        x2='95.743'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='95.841'
        x2='99.4'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='99.348'
        x2='102.91'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='103.01'
        x2='106.57'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='m'
        x1='106.51'
        x2='110.07'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='110.02'
        x2='113.58'
        y1='23.809'
        y2='24.93'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='48.128'
        x2='58.09'
        y1='43.426'
        y2='64.228'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='151.48'
        x2='161.44'
        y1='43.426'
        y2='64.228'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyLinkedSvg = () => (
  <svg
    width='170'
    height='170'
    fill='none'
    viewBox='0 0 171 170'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='170' height='170' rx='85' fill='#F0F2FA' />
    <path
      d='m139.18 96.267c-1.131 4.7827-2.827 9.8467-4.805 14.068-5.37 10.409-13.849 18.568-24.307 23.914-10.74 5.345-23.458 7.596-36.176 4.783-29.959-6.19-49.178-35.45-42.96-65.272 6.2179-29.822 35.329-49.235 65.288-42.764 10.74 2.2507 20.066 7.5963 27.98 14.911 13.284 13.505 18.654 32.355 14.98 50.361z'
      fill='url(#j)'
    />
    <circle
      cx='84.575'
      cy='138.12'
      r='17.85'
      fill='url(#i)'
      stroke='#F0F2FA'
      strokeWidth='2.55'
    />
    <path
      d='m82.211 128.66h4.662l-1.2432 12.95h-2.1756l-1.2432-12.95z'
      fill='#fff'
    />
    <ellipse cx='84.542' cy='145.75' rx='2.331' ry='2.072' fill='#fff' />
    <path
      d='m88.427 84.464c0.9106 0.9207 2.0087 1.6349 3.2196 2.094s2.5064 0.6524 3.7986 0.5668 2.5509-0.4481 3.6907-1.0629c1.1401-0.6148 2.1341-1.4676 2.9151-2.5005l4.624-6.111c1.396-1.9129 1.985-4.2975 1.639-6.6403-0.345-2.3427-1.597-4.4561-3.485-5.885s-4.262-2.0589-6.6108-1.7544c-2.3483 0.3046-4.4832 1.5193-5.9447 3.3825l-2.6535 3.4858'
      stroke='url(#h)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='5.1'
    />
    <path
      d='m85.392 78.117c-0.5711-1.1623-1.3854-2.1882-2.3878-3.0082-1.0025-0.8199-2.1695-1.4146-3.422-1.7438-1.2525-0.3293-2.5611-0.3853-3.8372-0.1643-1.276 0.221-2.4896 0.7139-3.5584 1.4451l-6.3254 4.3261c-1.9311 1.3706-3.2467 3.4448-3.6633 5.7759s0.099 4.7326 1.4358 6.6873c1.3368 1.9546 3.3879 3.306 5.7114 3.7631 2.3235 0.457 4.7336-0.0168 6.7112-1.3194l3.6055-2.4659'
      stroke='url(#g)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='5.1'
    />
    <path
      d='m73.2 61.357 2.3703 1.41'
      stroke='url(#f)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m82.14 61.606-0.9603-3.7803'
      stroke='url(#e)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m89.778 58.1-1.41 2.3702'
      stroke='url(#d)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m98.718 97.854-2.4318-1.3011'
      stroke='url(#c)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m89.776 98.011 1.1307 3.7324'
      stroke='url(#b)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m82.305 101.86 1.301-2.4317'
      stroke='url(#a)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m156.92 134.37c1.662 0 3.01-1.347 3.01-3.009s-1.348-3.009-3.01-3.009c-1.663 0-3.011 1.347-3.011 3.009s1.348 3.009 3.011 3.009z'
      fill='#fff'
    />
    <path
      d='m152.54 17.64c1.174 0 2.126-0.9513 2.126-2.125 0-1.1736-0.952-2.125-2.126-2.125s-2.126 0.9514-2.126 2.125c0 1.1737 0.952 2.125 2.126 2.125z'
      fill='#D7D9DB'
    />
    <path
      d='m142.76 30.39c3.287 0 5.952-2.6639 5.952-5.95 0-3.286-2.665-5.95-5.952-5.95-3.288 0-5.953 2.664-5.953 5.95 0 3.2861 2.665 5.95 5.953 5.95z'
      fill='#fff'
    />
    <path
      d='m32.215 157.89c3.2874 0 5.9524-2.664 5.9524-5.95s-2.665-5.95-5.9524-5.95c-3.2875 0-5.9525 2.664-5.9525 5.95s2.665 5.95 5.9525 5.95z'
      fill='#fff'
    />
    <path
      d='m164.02 138.55c0.939 0 1.7-0.761 1.7-1.7s-0.761-1.7-1.7-1.7c-0.94 0-1.701 0.761-1.701 1.7s0.761 1.7 1.701 1.7z'
      fill='#D7D9DB'
    />
    <path
      d='m30.198 25.756c2.4189 0 4.3798-1.9601 4.3798-4.378 0-2.4178-1.9609-4.3779-4.3798-4.3779-2.4188 0-4.3797 1.9601-4.3797 4.3779 0 2.4179 1.9609 4.378 4.3797 4.378z'
      fill='#fff'
    />
    <path
      d='m18.591 22.95c1.1741 0 2.1259-0.9514 2.1259-2.125s-0.9518-2.125-2.1259-2.125-2.1259 0.9514-2.1259 2.125 0.9518 2.125 2.1259 2.125z'
      fill='#D7D9DB'
    />
    <path
      d='m28.394 164.05c0.9393 0 1.7007-0.761 1.7007-1.7s-0.7614-1.7-1.7007-1.7-1.7007 0.761-1.7007 1.7 0.7614 1.7 1.7007 1.7z'
      fill='#D7D9DB'
    />
    <defs>
      <radialGradient
        id='j'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(85.035 85) rotate(92.8) scale(101.35 101.4)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.42872' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='i'
        x1='84.575'
        x2='70.901'
        y1='121.55'
        y2='148.07'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='96.402'
        x2='99.608'
        y1='63.422'
        y2='86.571'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='75.459'
        x2='71.148'
        y1='72.568'
        y2='95.537'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='74.145'
        x2='74.625'
        y1='61.117'
        y2='63.008'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='81.664'
        x2='82.625'
        y1='57.703'
        y2='61.483'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='88.833'
        x2='89.313'
        y1='58.34'
        y2='60.23'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='97.784'
        x2='97.219'
        y1='98.136'
        y2='96.27'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='90.428'
        x2='89.297'
        y1='101.89'
        y2='98.156'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='83.238'
        x2='82.672'
        y1='101.58'
        y2='99.711'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyLinkedSearchSvg = () => (
  <svg
    width='171'
    height='170'
    fill='none'
    viewBox='0 0 171 170'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='170' height='170' rx='85' fill='#F0F2FA' />
    <path
      d='m139.18 96.267c-1.131 4.7827-2.827 9.8467-4.805 14.068-5.37 10.409-13.849 18.568-24.307 23.914-10.74 5.345-23.458 7.596-36.176 4.783-29.959-6.19-49.178-35.45-42.96-65.272 6.2179-29.822 35.329-49.235 65.288-42.764 10.74 2.2507 20.066 7.5963 27.98 14.911 13.284 13.505 18.654 32.355 14.98 50.361z'
      fill='url(#j)'
    />
    <circle
      cx='84.575'
      cy='138.12'
      r='17.85'
      fill='url(#i)'
      stroke='#F0F2FA'
      strokeWidth='2.55'
    />
    <path
      d='m82.211 128.66h4.662l-1.2432 12.95h-2.1756l-1.2432-12.95z'
      fill='#fff'
    />
    <ellipse cx='84.542' cy='145.75' rx='2.331' ry='2.072' fill='#fff' />
    <path
      d='m88.427 84.464c0.9106 0.9207 2.0087 1.6349 3.2196 2.094s2.5064 0.6524 3.7986 0.5668 2.5509-0.4481 3.6907-1.0629c1.1401-0.6148 2.1341-1.4676 2.9151-2.5005l4.624-6.111c1.396-1.9129 1.985-4.2975 1.639-6.6403-0.345-2.3427-1.597-4.4561-3.485-5.885s-4.262-2.0589-6.6108-1.7544c-2.3483 0.3046-4.4832 1.5193-5.9447 3.3825l-2.6535 3.4858'
      stroke='url(#h)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='5.1'
    />
    <path
      d='m85.392 78.117c-0.5711-1.1623-1.3854-2.1882-2.3878-3.0082-1.0025-0.8199-2.1695-1.4146-3.422-1.7438-1.2525-0.3293-2.5611-0.3853-3.8372-0.1643-1.276 0.221-2.4896 0.7139-3.5584 1.4451l-6.3254 4.3261c-1.9311 1.3706-3.2467 3.4448-3.6633 5.7759s0.099 4.7326 1.4358 6.6873c1.3368 1.9546 3.3879 3.306 5.7114 3.7631 2.3235 0.457 4.7336-0.0168 6.7112-1.3194l3.6055-2.4659'
      stroke='url(#g)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='5.1'
    />
    <path
      d='m73.2 61.357 2.3703 1.41'
      stroke='url(#f)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m82.14 61.606-0.9603-3.7803'
      stroke='url(#e)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m89.778 58.1-1.41 2.3702'
      stroke='url(#d)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m98.718 97.854-2.4318-1.3011'
      stroke='url(#c)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m89.776 98.011 1.1307 3.7324'
      stroke='url(#b)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m82.305 101.86 1.301-2.4317'
      stroke='url(#a)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2.55'
    />
    <path
      d='m156.92 134.37c1.662 0 3.01-1.347 3.01-3.009s-1.348-3.009-3.01-3.009c-1.663 0-3.011 1.347-3.011 3.009s1.348 3.009 3.011 3.009z'
      fill='#fff'
    />
    <path
      d='m152.54 17.64c1.174 0 2.126-0.9513 2.126-2.125 0-1.1736-0.952-2.125-2.126-2.125s-2.126 0.9514-2.126 2.125c0 1.1737 0.952 2.125 2.126 2.125z'
      fill='#D7D9DB'
    />
    <path
      d='m142.76 30.39c3.287 0 5.952-2.6639 5.952-5.95 0-3.286-2.665-5.95-5.952-5.95-3.288 0-5.953 2.664-5.953 5.95 0 3.2861 2.665 5.95 5.953 5.95z'
      fill='#fff'
    />
    <path
      d='m32.215 157.89c3.2874 0 5.9524-2.664 5.9524-5.95s-2.665-5.95-5.9524-5.95c-3.2875 0-5.9525 2.664-5.9525 5.95s2.665 5.95 5.9525 5.95z'
      fill='#fff'
    />
    <path
      d='m164.02 138.55c0.939 0 1.7-0.761 1.7-1.7s-0.761-1.7-1.7-1.7c-0.94 0-1.701 0.761-1.701 1.7s0.761 1.7 1.701 1.7z'
      fill='#D7D9DB'
    />
    <path
      d='m30.198 25.756c2.4189 0 4.3798-1.9601 4.3798-4.378 0-2.4178-1.9609-4.3779-4.3798-4.3779-2.4188 0-4.3797 1.9601-4.3797 4.3779 0 2.4179 1.9609 4.378 4.3797 4.378z'
      fill='#fff'
    />
    <path
      d='m18.591 22.95c1.1741 0 2.1259-0.9514 2.1259-2.125s-0.9518-2.125-2.1259-2.125-2.1259 0.9514-2.1259 2.125 0.9518 2.125 2.1259 2.125z'
      fill='#D7D9DB'
    />
    <path
      d='m28.394 164.05c0.9393 0 1.7007-0.761 1.7007-1.7s-0.7614-1.7-1.7007-1.7-1.7007 0.761-1.7007 1.7 0.7614 1.7 1.7007 1.7z'
      fill='#D7D9DB'
    />
    <defs>
      <radialGradient
        id='j'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(85.035 85) rotate(92.8) scale(101.35 101.4)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.42872' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='i'
        x1='84.575'
        x2='70.901'
        y1='121.55'
        y2='148.07'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='96.402'
        x2='99.608'
        y1='63.422'
        y2='86.571'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='75.459'
        x2='71.148'
        y1='72.568'
        y2='95.537'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='74.145'
        x2='74.625'
        y1='61.117'
        y2='63.008'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='81.664'
        x2='82.625'
        y1='57.703'
        y2='61.483'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='88.833'
        x2='89.313'
        y1='58.34'
        y2='60.23'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='97.784'
        x2='97.219'
        y1='98.136'
        y2='96.27'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='90.428'
        x2='89.297'
        y1='101.89'
        y2='98.156'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='83.238'
        x2='82.672'
        y1='101.58'
        y2='99.711'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyTemplateSvg = () => (
  <svg
    width='200'
    height='200'
    fill='none'
    viewBox='0 0 200 201'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m100 200.5c55.227 0 100-44.685 100-100 0-55.315-44.97-100-100-100-55.227 0-100 44.685-100 100 0 55.315 44.773 100 100 100z'
      fill='url(#d)'
    />
    <path
      d='m152.79 187.64c2.747 0 4.974-2.235 4.974-4.991 0-2.757-2.227-4.992-4.974-4.992s-4.974 2.235-4.974 4.992c0 2.756 2.227 4.991 4.974 4.991z'
      fill='#DCDAE3'
    />
    <path
      d='m157.73 17.898c1.66 0 3.006-1.3505 3.006-3.0165s-1.346-3.0165-3.006-3.0165-3.006 1.3505-3.006 3.0165 1.346 3.0165 3.006 3.0165z'
      fill='#C5B8EA'
    />
    <path
      d='m147.32 28.393c3.184 0 5.765-2.5901 5.765-5.7852 0-3.195-2.581-5.7851-5.765-5.7851-3.183 0-5.764 2.5901-5.764 5.7851 0 3.1951 2.581 5.7852 5.764 5.7852z'
      fill='#fff'
    />
    <path
      d='m39.434 171.37c3.1838 0 5.7647-2.591 5.7647-5.786s-2.5809-5.785-5.7647-5.785c-3.1837 0-5.7647 2.59-5.7647 5.785s2.581 5.786 5.7647 5.786z'
      fill='#fff'
    />
    <path
      d='m162.22 190.05c0.909 0 1.647-0.74 1.647-1.652 0-0.913-0.738-1.653-1.647-1.653-0.91 0-1.647 0.74-1.647 1.653 0 0.912 0.737 1.652 1.647 1.652z'
      fill='#C5B8EA'
    />
    <path
      d='m38.305 21.409c2.3426 0 4.2416-1.9058 4.2416-4.2566 0-2.3509-1.899-4.2566-4.2416-4.2566-2.3425 0-4.2415 1.9057-4.2415 4.2566 0 2.3508 1.899 4.2566 4.2415 4.2566z'
      fill='#C5B8EA'
    />
    <path
      d='m24.716 23.888c1.2053 0 2.1823-0.9806 2.1823-2.1901 0-1.2096-0.977-2.1901-2.1823-2.1901s-2.1824 0.9805-2.1824 2.1901c0 1.2095 0.9771 2.1901 2.1824 2.1901z'
      fill='#DCDAE3'
    />
    <path
      d='m26.674 176.53c1.8192 0 3.2941-1.48 3.2941-3.306s-1.4749-3.306-3.2941-3.306c-1.8193 0-3.2941 1.48-3.2941 3.306s1.4748 3.306 3.2941 3.306z'
      fill='#C5B8EA'
    />
    <g filter='url(#z)'>
      <path
        d='m119.27 52.781 24.566 88.307c0.803 3.051-0.964 6.101-4.014 6.904l-86.542 22.96c-3.0506 0.803-6.1012-0.963-6.904-4.014l-30.185-114c-0.8028-3.0507 0.9633-6.1013 4.0139-6.9041l62.618-16.538 36.447 23.281z'
        fill='url(#c)'
      />
    </g>
    <g filter='url(#o)'>
      <path
        d='m117.99 108.65-46.723 12.363-5.1379 1.285-15.574 4.174c-0.6423 0.161-1.124 0.964-0.8028 1.766 0.1605 0.803 0.9633 1.285 1.6055 1.124l15.574-4.174 5.1379-1.285 46.723-12.363c0.642-0.16 1.124-0.963 0.803-1.766-0.161-0.803-0.964-1.284-1.606-1.124z'
        fill='#fff'
      />
    </g>
    <g filter='url(#l)'>
      <path
        d='m114.94 97.736-17.341 4.4956-5.9407 1.606-43.833 11.72c-0.6422 0.161-1.1239 0.964-0.8028 1.767 0.1606 0.802 0.9634 1.284 1.6056 1.123l43.993-11.72 5.9407-1.606 17.34-4.496c0.642-0.16 1.124-0.9629 0.803-1.7657-0.321-0.6422-1.124-1.2845-1.766-1.1239z'
        fill='#fff'
      />
    </g>
    <g filter='url(#k)'>
      <path
        d='m112.37 86.659-4.496 1.124-4.496 1.1239-58.604 15.574c-0.6422 0.16-1.1239 0.963-0.8028 1.766 0.1606 0.803 0.9634 1.284 1.6056 1.124l58.604-15.574 4.978-1.2844 4.014-1.124c0.642-0.1605 1.123-0.9633 0.802-1.7661-0.16-0.6422-0.802-1.1239-1.605-0.9634z'
        fill='#fff'
      />
    </g>
    <g filter='url(#j)'>
      <path
        d='m85.232 143.5-3.2112 0.803c-0.6423 0.16-1.4451-0.321-1.6056-1.124-0.1606-0.803 0.1605-1.606 0.8028-1.766l3.2112-0.803c0.6422-0.161 1.445 0.321 1.6056 1.124 0.1605 0.963-0.1606 1.605-0.8028 1.766z'
        fill='#fff'
      />
    </g>
    <g filter='url(#i)'>
      <path
        d='m75.44 146.06-18.464 4.817c-0.6422 0.161-1.445-0.321-1.6056-1.124-0.1605-0.803 0.1606-1.605 0.8028-1.766l18.464-4.817c0.6422-0.16 1.445 0.321 1.6056 1.124 0.3211 0.803 0 1.606-0.8028 1.766z'
        fill='#fff'
      />
    </g>
    <g filter='url(#h)'>
      <path
        d='m110.12 75.58-14.611 3.8534-3.5323 0.9634-49.934 13.166c-0.6422 0.1606-1.1239 0.9634-0.8028 1.7662 0.1606 0.8028 0.9634 1.2844 1.6056 1.1239l49.773-13.005 3.5323-0.9633 14.451-3.8535c0.802-0.1605 1.123-0.9633 0.963-1.9267 0-0.6422-0.803-1.2844-1.445-1.1239z'
        fill='#fff'
      />
    </g>
    <g filter='url(#g)'>
      <path
        d='m75.599 51.335-41.424 10.918c-0.9634 0.3212-1.9267-0.3211-2.2478-1.2844-0.3212-0.9634 0.3211-1.9267 1.2844-2.2479l41.424-10.918c0.9633-0.3211 1.9267 0.3211 2.2478 1.2845s-0.3211 1.9267-1.2845 2.2478z'
        fill='#fff'
      />
    </g>
    <g filter='url(#f)'>
      <path
        d='m52.8 68.034-15.895 4.1745c-0.9634 0.3211-1.9268-0.3211-2.2479-1.2845-0.3211-0.9633 0.3211-1.9267 1.2845-2.2478l15.735-4.1745c0.9633-0.3211 1.9267 0.3211 2.2478 1.2844 0.3211 0.9634-0.3211 1.9267-1.1239 2.2479z'
        fill='#fff'
      />
    </g>
    <g filter='url(#e)'>
      <path
        d='m82.826 29.5 6.4224 24.405c0.9633 3.3717 4.6562 5.459 8.0279 4.4957l21.996-5.6196'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#y)'>
      <path
        d='m183.5 77.141-14.771 90.556c-0.482 3.05-3.533 5.138-6.583 4.495l-87.987-15.413c-3.0506-0.482-5.1379-3.533-4.6562-6.583l20.391-116.08c0.4817-3.0506 3.5323-5.1379 6.5829-4.4957l63.903 11.239 23.12 36.286z'
        fill='url(#b)'
      />
    </g>
    <g filter='url(#x)'>
      <path
        d='m159.57 127.92-47.526-8.349-5.138-0.964-15.895-2.729c-0.6422-0.161-1.445 0.481-1.445 1.284-0.1606 0.803 0.3211 1.606 0.9633 1.766l15.896 2.73 5.138 0.963 47.525 8.349c0.642 0.161 1.445-0.481 1.445-1.284 0.161-0.803-0.161-1.606-0.963-1.766z'
        fill='#fff'
      />
    </g>
    <g filter='url(#w)'>
      <path
        d='m161.5 116.84-17.662-3.05-5.94-1.124-44.796-7.868c-0.6422-0.16-1.445 0.482-1.445 1.285-0.1605 0.803 0.3211 1.605 0.9634 1.766l44.796 7.867 5.941 1.124 17.661 3.051c0.642 0.16 1.445-0.482 1.445-1.285 0.161-0.802-0.321-1.605-0.963-1.766z'
        fill='#fff'
      />
    </g>
    <g filter='url(#v)'>
      <path
        d='m163.75 105.6-4.657-0.803-4.656-0.803-59.728-10.436c-0.6422-0.1606-1.445 0.4817-1.445 1.2844-0.1605 0.8028 0.3211 1.6056 0.9634 1.7662l59.728 10.437 5.137 0.963 4.014 0.642c0.643 0.161 1.445-0.481 1.445-1.284 0.322-0.803 0-1.606-0.802-1.766z'
        fill='#fff'
      />
    </g>
    <g filter='url(#u)'>
      <path
        d='m115.26 145.9-3.211-0.481c-0.642-0.161-1.124-0.964-0.963-1.766 0.16-0.803 0.802-1.445 1.445-1.285l3.211 0.482c0.642 0.16 1.124 0.963 0.963 1.766-0.16 0.963-0.803 1.284-1.445 1.284z'
        fill='#fff'
      />
    </g>
    <g filter='url(#t)'>
      <path
        d='m105.46 144.14-18.785-3.211c-0.6422-0.16-1.1239-0.963-0.9633-1.766 0.1605-0.803 0.8028-1.445 1.445-1.284l18.786 3.211c0.642 0.16 1.124 0.963 0.963 1.766-0.16 0.963-0.803 1.445-1.445 1.284z'
        fill='#fff'
      />
    </g>
    <g filter='url(#s)'>
      <path
        d='m166.32 94.687-14.932-2.5689-3.693-0.6423-50.897-8.9913c-0.6422-0.1605-1.445 0.4817-1.445 1.2845-0.1605 0.8028 0.3211 1.6056 0.9634 1.7661l50.897 8.9913 18.465 3.2112c0.802 0.1606 1.445-0.4817 1.605-1.2845 0.161-0.8027-0.321-1.6055-0.963-1.7661z'
        fill='#fff'
      />
    </g>
    <g filter='url(#r)'>
      <path
        d='m145.28 58.24-42.227-7.3857c-0.963-0.1606-1.606-1.1239-1.445-2.0873 0.16-0.9633 1.124-1.6056 2.087-1.445l42.227 7.3857c0.964 0.1606 1.606 1.1239 1.445 2.0873-0.16 0.8028-1.124 1.6056-2.087 1.445z'
        fill='#fff'
      />
    </g>
    <g filter='url(#q)'>
      <path
        d='m117.51 63.698-16.217-2.8901c-0.963-0.1605-1.6051-1.1239-1.4446-2.0872 0.1606-0.9634 1.1236-1.6056 2.0876-1.4451l16.056 2.8901c0.963 0.1605 1.605 1.1239 1.445 2.0873-0.161 0.9633-1.124 1.6055-1.927 1.445z'
        fill='#fff'
      />
    </g>
    <g filter='url(#p)'>
      <path
        d='m160.86 41.382-4.335 24.887c-0.642 3.5323 1.927 6.9041 5.459 7.5463l22.157 3.8534'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#n)'>
      <path
        d='m122.52 168.79c-0.481 2.034-1.202 4.188-2.043 5.983-2.283 4.428-5.888 7.898-10.334 10.172-4.566 2.274-9.974 3.231-15.381 2.034-12.738-2.632-20.909-15.078-18.265-27.762 2.6437-12.685 15.021-20.942 27.758-18.19 4.566 0.958 8.532 3.231 11.896 6.343 5.648 5.744 7.931 13.761 6.369 21.42z'
        fill='url(#a)'
      />
    </g>
    <path
      d='m124.95 169.37 9e-3 -0.038 7e-3 -0.037c1.727-8.467-0.799-17.331-7.035-23.673l-0.042-0.043-0.043-0.04c-3.64-3.365-7.999-5.886-13.074-6.952-14.12-3.047-27.806 6.113-30.726 20.125-2.9253 14.036 6.1121 27.798 20.19 30.717 6.0301 1.33 12.013 0.251 17.018-2.241l0.024-0.012c4.883-2.497 8.881-6.332 11.418-11.252l0.022-0.042 0.02-0.043c0.925-1.973 1.698-4.294 2.212-6.469z'
      stroke='#F4F2FB'
      strokeWidth='5'
    />
    <g filter='url(#m)'>
      <path
        d='m106.9 161.97h-5.407v-5.385c0-1.077-0.841-2.034-2.0429-2.034-1.0814 0-2.0428 0.837-2.0428 2.034v5.385h-5.4074c-1.0815 0-2.0428 0.838-2.0428 2.034 0 1.197 0.8412 2.035 2.0428 2.035h5.4074v5.385c0 1.077 0.8412 2.034 2.0428 2.034 1.0819 0 2.0429-0.838 2.0429-2.034v-5.385h5.407c1.082 0 2.043-0.838 2.043-2.035 0.12-1.196-0.841-2.034-2.043-2.034z'
        fill='#fff'
      />
    </g>
    <defs>
      <filter
        id='z'
        x='16'
        y='16.5'
        width='138.03'
        height='154.65'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='o'
        x='49.647'
        y='108.62'
        width='72.048'
        height='21.774'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='l'
        x='46.917'
        y='97.711'
        width='71.887'
        height='21.768'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='k'
        x='43.867'
        y='86.628'
        width='72.208'
        height='21.774'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='j'
        x='80.375'
        y='140.58'
        width='7.7014'
        height='4.7544'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='i'
        x='55.329'
        y='143.14'
        width='23.037'
        height='8.7684'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='h'
        x='41.138'
        y='75.555'
        width='72.467'
        height='21.928'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='g'
        x='31.843'
        y='47.719'
        width='47.124'
        height='15.617'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='f'
        x='34.574'
        y='64.418'
        width='21.435'
        height='8.8739'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='e'
        x='82.826'
        y='29.5'
        width='36.447'
        height='33.136'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='y'
        x='69.437'
        y='16.5'
        width='124.07'
        height='155.81'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='x'
        x='89.537'
        y='115.86'
        width='74.038'
        height='17.142'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='w'
        x='91.625'
        y='104.78'
        width='73.869'
        height='17.142'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='v'
        x='93.231'
        y='93.537'
        width='74.442'
        height='17.142'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='u'
        x='111.05'
        y='142.35'
        width='8.6818'
        height='5.5571'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='t'
        x='85.684'
        y='137.85'
        width='24.256'
        height='8.317'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='s'
        x='95.317'
        y='82.46'
        width='74.993'
        height='17.303'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='r'
        x='101.58'
        y='47.297'
        width='48.808'
        height='12.963'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='q'
        x='99.82'
        y='57.251'
        width='22.637'
        height='8.4715'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='p'
        x='156.42'
        y='41.382'
        width='27.715'
        height='40.286'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='n'
        x='67.999'
        y='132.5'
        width='60.001'
        height='60.003'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-3' dy='-3' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.9 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <filter
        id='m'
        x='89.955'
        y='152.23'
        width='18.996'
        height='21.23'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='-2.32286' />
        <feGaussianBlur stdDeviation='4.12954' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.2 0' />
        <feBlend in2='shape' result='effect1_innerShadow_606_22957' />
      </filter>
      <linearGradient
        id='d'
        x1='66.667'
        x2='250'
        y1='-62'
        y2='400.5'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#F0EDFA' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='80.016'
        x2='152.09'
        y1='29.5'
        y2='165.46'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='126.47'
        x2='203.93'
        y1='29.5'
        y2='158.63'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='99.5'
        x2='111.81'
        y1='140.5'
        y2='181.9'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyTemplateSearchSvg = () => (
  <svg
    width='176'
    height='185'
    fill='none'
    viewBox='0 0 176 185'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m85.576 171.3c47.135 0 85.348-38.138 85.348-85.348 0-47.21-38.381-85.348-85.348-85.348-47.135 0-85.348 38.138-85.348 85.348 0 47.21 38.213 85.348 85.348 85.348z'
      fill='#F0F2FA'
    />
    <path
      d='m130.63 160.33c2.344 0 4.245-1.907 4.245-4.26s-1.901-4.26-4.245-4.26c-2.345 0-4.246 1.907-4.246 4.26s1.901 4.26 4.246 4.26z'
      fill='#DCDAE3'
    />
    <path
      d='m134.85 15.451c1.417 0 2.566-1.1527 2.566-2.5746s-1.149-2.5745-2.566-2.5745-2.565 1.1526-2.565 2.5745 1.148 2.5746 2.565 2.5746z'
      fill='#C5B8EA'
    />
    <path
      d='m125.96 24.407c2.717 0 4.92-2.2106 4.92-4.9375s-2.203-4.9375-4.92-4.9375-4.92 2.2106-4.92 4.9375 2.203 4.9375 4.92 4.9375z'
      fill='#E2D9FF'
    />
    <path
      d='m33.886 146.44c2.7173 0 4.9201-2.21 4.9201-4.937s-2.2028-4.938-4.9201-4.938-4.92 2.211-4.92 4.938 2.2027 4.937 4.92 4.937z'
      fill='#E2D9FF'
    />
    <path
      d='m138.68 162.38c0.776 0 1.406-0.632 1.406-1.411s-0.63-1.41-1.406-1.41c-0.777 0-1.406 0.631-1.406 1.41s0.629 1.411 1.406 1.411z'
      fill='#C5B8EA'
    />
    <path
      d='m32.923 18.448c1.9993 0 3.6201-1.6265 3.6201-3.6329s-1.6208-3.633-3.6201-3.633-3.6201 1.6266-3.6201 3.633 1.6208 3.6329 3.6201 3.6329z'
      fill='#C5B8EA'
    />
    <path
      d='m21.324 20.564c1.0286 0 1.8625-0.8369 1.8625-1.8692s-0.8339-1.8692-1.8625-1.8692c-1.0287 0-1.8626 0.8369-1.8626 1.8692s0.8339 1.8692 1.8626 1.8692z'
      fill='#DCDAE3'
    />
    <path
      d='m22.996 150.84c1.5527 0 2.8114-1.263 2.8114-2.821 0-1.559-1.2587-2.822-2.8114-2.822s-2.8115 1.263-2.8115 2.822c0 1.558 1.2588 2.821 2.8115 2.821z'
      fill='#C5B8EA'
    />
    <path
      d='m102.36 48.965 20.014 71.147c0.653 2.439-0.837 4.857-3.276 5.511l-69.611 18.652c-2.4386 0.654-4.9685-0.807-5.5922-3.135l-24.592-91.78c-0.6534-2.4386 0.8369-4.8576 3.2755-5.511l50.435-13.514 29.347 18.63z'
      fill='url(#au)'
    />
    <path
      d='m102.36 48.965 20.014 71.147c0.653 2.439-0.837 4.857-3.276 5.511l-69.611 18.652c-2.4386 0.654-4.9685-0.807-5.5922-3.135l-24.592-91.78c-0.6534-2.4386 0.8369-4.8576 3.2755-5.511l50.435-13.514 29.347 18.63z'
      fill='url(#aj)'
      fillOpacity='.8'
    />
    <path
      d='m86.482 44.197-50.682 13.58c-1.6053 0.4301-3.1676 0.1035-3.385-0.7077-0.2173-0.8112 0.9724-1.8751 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1676-0.1035 3.3849 0.7077 0.2174 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#y)'
    />
    <path
      d='m86.482 44.197-50.682 13.58c-1.6053 0.4301-3.1676 0.1035-3.385-0.7077-0.2173-0.8112 0.9724-1.8751 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1676-0.1035 3.3849 0.7077 0.2174 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#n)'
    />
    <path
      d='m87.065 53.728-46.601 12.487c-2.8121 0.7535-5.4089 0.7041-5.6262-0.1071-0.2174-0.8112 2.0067-2.1523 4.8188-2.9058l46.199-12.379c2.8121-0.7535 5.4088-0.7041 5.6262 0.1071 0.2173 0.8112-2.0067 2.1523-4.4171 2.7982z'
      fill='url(#f)'
    />
    <path
      d='m87.065 53.728-46.601 12.487c-2.8121 0.7535-5.4089 0.7041-5.6262-0.1071-0.2174-0.8112 2.0067-2.1523 4.8188-2.9058l46.199-12.379c2.8121-0.7535 5.4088-0.7041 5.6262 0.1071 0.2173 0.8112-2.0067 2.1523-4.4171 2.7982z'
      fill='url(#e)'
    />
    <path
      d='m91.164 61.666-50.682 13.58c-1.6053 0.4302-3.1676 0.1035-3.3849-0.7076-0.2174-0.8112 0.9723-1.8752 2.5776-2.3054l50.682-13.58c1.6053-0.4302 3.1676-0.1036 3.3849 0.7076 0.2174 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#d)'
    />
    <path
      d='m91.164 61.666-50.682 13.58c-1.6053 0.4302-3.1676 0.1035-3.3849-0.7076-0.2174-0.8112 0.9723-1.8752 2.5776-2.3054l50.682-13.58c1.6053-0.4302 3.1676-0.1036 3.3849 0.7076 0.2174 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#c)'
    />
    <path
      d='m93.586 70.712-50.682 13.58c-1.6053 0.4302-3.1676 0.1036-3.385-0.7076-0.2173-0.8112 0.9723-1.8752 2.5776-2.3053l50.682-13.58c1.6053-0.4302 3.1676-0.1035 3.3849 0.7076 0.2174 0.8112-0.9723 1.8752-2.5776 2.3054z'
      fill='url(#b)'
    />
    <path
      d='m93.586 70.712-50.682 13.58c-1.6053 0.4302-3.1676 0.1036-3.385-0.7076-0.2173-0.8112 0.9723-1.8752 2.5776-2.3053l50.682-13.58c1.6053-0.4302 3.1676-0.1035 3.3849 0.7076 0.2174 0.8112-0.9723 1.8752-2.5776 2.3054z'
      fill='url(#a)'
    />
    <path
      d='m96.008 79.75-50.682 13.58c-1.6053 0.4301-3.1675 0.1035-3.3849-0.7077-0.2174-0.8111 0.9723-1.8751 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1675-0.1035 3.3849 0.7077 0.2173 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#at)'
    />
    <path
      d='m96.008 79.75-50.682 13.58c-1.6053 0.4301-3.1675 0.1035-3.3849-0.7077-0.2174-0.8111 0.9723-1.8751 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1675-0.1035 3.3849 0.7077 0.2173 0.8112-0.9723 1.8752-2.5776 2.3053z'
      fill='url(#as)'
    />
    <path
      d='m98.431 88.789-50.682 13.58c-1.6053 0.43-3.1676 0.103-3.3849-0.708-0.2174-0.811 0.9723-1.8752 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1675-0.1035 3.3845 0.7077 0.218 0.8112-0.972 1.8752-2.5772 2.3053z'
      fill='url(#ar)'
    />
    <path
      d='m98.431 88.789-50.682 13.58c-1.6053 0.43-3.1676 0.103-3.3849-0.708-0.2174-0.811 0.9723-1.8752 2.5776-2.3053l50.682-13.58c1.6053-0.4301 3.1675-0.1035 3.3845 0.7077 0.218 0.8112-0.972 1.8752-2.5772 2.3053z'
      fill='url(#aq)'
    />
    <path
      d='m100.69 97.227-50.682 13.58c-1.6053 0.43-3.1676 0.104-3.385-0.707-0.2173-0.812 0.9723-1.876 2.5776-2.306l50.682-13.58c1.6057-0.4301 3.1677-0.1035 3.3847 0.7077 0.218 0.8112-0.972 1.8752-2.577 2.3053z'
      fill='url(#ap)'
    />
    <path
      d='m100.69 97.227-50.682 13.58c-1.6053 0.43-3.1676 0.104-3.385-0.707-0.2173-0.812 0.9723-1.876 2.5776-2.306l50.682-13.58c1.6057-0.4301 3.1677-0.1035 3.3847 0.7077 0.218 0.8112-0.972 1.8752-2.577 2.3053z'
      fill='url(#ao)'
    />
    <path
      d='m103.11 106.26-50.681 13.58c-1.6053 0.43-3.1675 0.104-3.3849-0.707-0.2174-0.812 0.9723-1.876 2.5776-2.306l50.681-13.58c1.605-0.43 3.168-0.103 3.385 0.708s-0.972 1.875-2.578 2.305z'
      fill='url(#an)'
    />
    <path
      d='m103.11 106.26-50.681 13.58c-1.6053 0.43-3.1675 0.104-3.3849-0.707-0.2174-0.812 0.9723-1.876 2.5776-2.306l50.681-13.58c1.605-0.43 3.168-0.103 3.385 0.708s-0.972 1.875-2.578 2.305z'
      fill='url(#am)'
    />
    <path
      d='m105.53 115.3-50.681 13.58c-1.6053 0.43-3.1676 0.104-3.3849-0.707-0.2174-0.812 0.9723-1.876 2.5776-2.306l50.682-13.58c1.605-0.43 3.168-0.103 3.385 0.708s-0.972 1.875-2.578 2.305z'
      fill='url(#al)'
    />
    <path
      d='m105.53 115.3-50.681 13.58c-1.6053 0.43-3.1676 0.104-3.3849-0.707-0.2174-0.812 0.9723-1.876 2.5776-2.306l50.682-13.58c1.605-0.43 3.168-0.103 3.385 0.708s-0.972 1.875-2.578 2.305z'
      fill='url(#ak)'
    />
    <path
      d='m73.01 30.333 5.2868 19.73c0.7425 2.7711 3.7751 4.3346 6.5463 3.5921l17.513-4.6927'
      fill='url(#ai)'
    />
    <path
      d='m154.74 74.098 0.121-0.4747-0.227-0.4342-16.1-30.807-0.26-0.4982-50.978-13.659c-3.0803-0.8254-6.3129 0.8781-7.1601 4.0402l-24.592 91.78c-0.8122 3.031 1.0795 6.248 4.1807 7.079l69.61 18.652c3.081 0.826 6.313-0.878 7.161-4.04l2e-3 -8e-3 2e-3 -7e-3 18.24-71.622z'
      fill='#8E76D7'
    />
    <path
      d='m154.74 74.098 0.121-0.4747-0.227-0.4342-16.1-30.807-0.26-0.4982-50.978-13.659c-3.0803-0.8254-6.3129 0.8781-7.1601 4.0402l-24.592 91.78c-0.8122 3.031 1.0795 6.248 4.1807 7.079l69.61 18.652c3.081 0.826 6.313-0.878 7.161-4.04l2e-3 -8e-3 2e-3 -7e-3 18.24-71.622z'
      fill='url(#ah)'
    />
    <path
      d='m154.74 74.098 0.121-0.4747-0.227-0.4342-16.1-30.807-0.26-0.4982-50.978-13.659c-3.0803-0.8254-6.3129 0.8781-7.1601 4.0402l-24.592 91.78c-0.8122 3.031 1.0795 6.248 4.1807 7.079l69.61 18.652c3.081 0.826 6.313-0.878 7.161-4.04l2e-3 -8e-3 2e-3 -7e-3 18.24-71.622z'
      fill='url(#ag)'
      fillOpacity='.8'
    />
    <path
      d='m154.74 74.098 0.121-0.4747-0.227-0.4342-16.1-30.807-0.26-0.4982-50.978-13.659c-3.0803-0.8254-6.3129 0.8781-7.1601 4.0402l-24.592 91.78c-0.8122 3.031 1.0795 6.248 4.1807 7.079l69.61 18.652c3.081 0.826 6.313-0.878 7.161-4.04l2e-3 -8e-3 2e-3 -7e-3 18.24-71.622z'
      stroke='#F0EDFA'
      strokeWidth='2.56044'
    />
    <path
      d='m142.13 61.707-50.682-13.58c-1.6053-0.4301-2.7949-1.4941-2.5776-2.3053 0.2174-0.8112 1.7797-1.1378 3.385-0.7076l50.682 13.58c1.605 0.4302 2.795 1.4942 2.578 2.3054-0.218 0.8111-1.78 1.1378-3.385 0.7076z'
      fill='url(#af)'
    />
    <path
      d='m142.13 61.707-50.682-13.58c-1.6053-0.4301-2.7949-1.4941-2.5776-2.3053 0.2174-0.8112 1.7797-1.1378 3.385-0.7076l50.682 13.58c1.605 0.4302 2.795 1.4942 2.578 2.3054-0.218 0.8111-1.78 1.1378-3.385 0.7076z'
      fill='url(#ae)'
    />
    <path
      d='m137.87 70.252-46.6-12.487c-2.8121-0.7535-5.0362-2.0947-4.8189-2.9059 0.2174-0.8112 2.8141-0.8606 5.6262-0.1071l46.199 12.379c2.812 0.7535 5.036 2.0947 4.819 2.9058-0.218 0.8112-2.814 0.8607-5.225 0.2148z'
      fill='url(#ad)'
    />
    <path
      d='m137.87 70.252-46.6-12.487c-2.8121-0.7535-5.0362-2.0947-4.8189-2.9059 0.2174-0.8112 2.8141-0.8606 5.6262-0.1071l46.199 12.379c2.812 0.7535 5.036 2.0947 4.819 2.9058-0.218 0.8112-2.814 0.8607-5.225 0.2148z'
      fill='url(#ac)'
    />
    <path
      d='m137.45 79.177-50.682-13.58c-1.6053-0.4302-2.795-1.4942-2.5776-2.3054 0.2173-0.8111 1.7796-1.1378 3.3849-0.7076l50.681 13.58c1.606 0.4301 2.795 1.4941 2.578 2.3053s-1.78 1.1378-3.385 0.7076z'
      fill='url(#ab)'
    />
    <path
      d='m137.45 79.177-50.682-13.58c-1.6053-0.4302-2.795-1.4942-2.5776-2.3054 0.2173-0.8111 1.7796-1.1378 3.3849-0.7076l50.681 13.58c1.606 0.4301 2.795 1.4941 2.578 2.3053s-1.78 1.1378-3.385 0.7076z'
      fill='url(#aa)'
    />
    <path
      d='m135.02 88.223-50.681-13.58c-1.6052-0.4302-2.7949-1.4942-2.5776-2.3054 0.2174-0.8111 1.7797-1.1378 3.385-0.7076l50.682 13.58c1.605 0.4301 2.794 1.4941 2.577 2.3053s-1.78 1.1378-3.385 0.7076z'
      fill='url(#z)'
    />
    <path
      d='m135.02 88.223-50.681-13.58c-1.6052-0.4302-2.7949-1.4942-2.5776-2.3054 0.2174-0.8111 1.7797-1.1378 3.385-0.7076l50.682 13.58c1.605 0.4301 2.794 1.4941 2.577 2.3053s-1.78 1.1378-3.385 0.7076z'
      fill='url(#x)'
    />
    <path
      d='m132.6 97.261-50.681-13.58c-1.6053-0.4302-2.795-1.4942-2.5776-2.3054 0.2173-0.8112 1.7796-1.1378 3.3849-0.7076l50.682 13.58c1.605 0.4302 2.795 1.4942 2.577 2.3054-0.217 0.8112-1.779 1.1378-3.385 0.7076z'
      fill='url(#w)'
    />
    <path
      d='m132.6 97.261-50.681-13.58c-1.6053-0.4302-2.795-1.4942-2.5776-2.3054 0.2173-0.8112 1.7796-1.1378 3.3849-0.7076l50.682 13.58c1.605 0.4302 2.795 1.4942 2.577 2.3054-0.217 0.8112-1.779 1.1378-3.385 0.7076z'
      fill='url(#v)'
    />
    <path
      d='m130.18 106.3-50.681-13.58c-1.6053-0.4301-2.795-1.4941-2.5776-2.3053 0.2173-0.8112 1.7796-1.1378 3.3849-0.7076l50.682 13.58c1.605 0.43 2.795 1.494 2.577 2.305-0.217 0.812-1.779 1.138-3.385 0.708z'
      fill='url(#u)'
    />
    <path
      d='m130.18 106.3-50.681-13.58c-1.6053-0.4301-2.795-1.4941-2.5776-2.3053 0.2173-0.8112 1.7796-1.1378 3.3849-0.7076l50.682 13.58c1.605 0.43 2.795 1.494 2.577 2.305-0.217 0.812-1.779 1.138-3.385 0.708z'
      fill='url(#t)'
    />
    <path
      d='m127.92 114.74-50.682-13.581c-1.6053-0.43-2.7949-1.4936-2.5776-2.3048 0.2174-0.8112 1.7797-1.1378 3.385-0.7077l50.682 13.58c1.605 0.43 2.795 1.494 2.578 2.305-0.218 0.811-1.78 1.138-3.385 0.708z'
      fill='url(#s)'
    />
    <path
      d='m127.92 114.74-50.682-13.581c-1.6053-0.43-2.7949-1.4936-2.5776-2.3048 0.2174-0.8112 1.7797-1.1378 3.385-0.7077l50.682 13.58c1.605 0.43 2.795 1.494 2.578 2.305-0.218 0.811-1.78 1.138-3.385 0.708z'
      fill='url(#r)'
    />
    <path
      d='m125.5 123.78-50.682-13.58c-1.6053-0.431-2.795-1.495-2.5776-2.306 0.2173-0.811 1.7796-1.138 3.3849-0.707l50.681 13.58c1.605 0.43 2.795 1.494 2.578 2.305-0.218 0.811-1.78 1.138-3.385 0.708z'
      fill='url(#q)'
    />
    <path
      d='m125.5 123.78-50.682-13.58c-1.6053-0.431-2.795-1.495-2.5776-2.306 0.2173-0.811 1.7796-1.138 3.3849-0.707l50.681 13.58c1.605 0.43 2.795 1.494 2.578 2.305-0.218 0.811-1.78 1.138-3.385 0.708z'
      fill='url(#p)'
    />
    <path
      d='m123.08 132.82-50.682-13.58c-1.6053-0.43-2.795-1.494-2.5776-2.306 0.2174-0.811 1.7796-1.137 3.3849-0.707l50.681 13.58c1.606 0.43 2.795 1.494 2.578 2.305s-1.78 1.138-3.385 0.708z'
      fill='url(#o)'
    />
    <path
      d='m123.08 132.82-50.682-13.58c-1.6053-0.43-2.795-1.494-2.5776-2.306 0.2174-0.811 1.7796-1.137 3.3849-0.707l50.681 13.58c1.606 0.43 2.795 1.494 2.578 2.305s-1.78 1.138-3.385 0.708z'
      fill='url(#m)'
    />
    <path
      d='m137.4 42.977-5.287 19.73c-0.742 2.7711 1.103 5.6414 3.874 6.384l17.513 4.6927'
      fill='url(#l)'
    />
    <path
      d='m94.596 157.83 0.0021 2e-3c7.1493 6.773 16.804 10.667 26.495 10.667 7.747 0 15.355-2.443 21.934-7.073l18.507 18.506c1.35 1.492 3.099 2.208 4.87 2.208 2.917 0 5.448-2.09 6.653-4.501l0.068-0.136 0.048-0.143c0.213-0.64 0.529-1.749 0.395-3.082-0.138-1.388-0.746-2.852-2.097-4.202l-18.69-18.69c7.677-11.782 8.386-26.263 1.872-38.677l-4e-3 -7e-3c-6.774-12.795-19.359-20.351-33.675-20.351-20.987 0-38.074 17.087-38.074 38.074 0 10.543 4.1503 20.237 11.695 27.405zm45.354-12.491-6e-3 7e-3c-4.71 5.916-11.34 9.159-18.614 9.159-12.075 0-24.317-9.086-24.317-24.08 0-13.18 10.675-23.962 23.961-23.962 9.249 0 17.529 5.212 21.687 13.628 4.04 8.417 3.04 18.086-2.711 25.248z'
      fill='#8E76D7'
    />
    <path
      d='m94.596 157.83 0.0021 2e-3c7.1493 6.773 16.804 10.667 26.495 10.667 7.747 0 15.355-2.443 21.934-7.073l18.507 18.506c1.35 1.492 3.099 2.208 4.87 2.208 2.917 0 5.448-2.09 6.653-4.501l0.068-0.136 0.048-0.143c0.213-0.64 0.529-1.749 0.395-3.082-0.138-1.388-0.746-2.852-2.097-4.202l-18.69-18.69c7.677-11.782 8.386-26.263 1.872-38.677l-4e-3 -7e-3c-6.774-12.795-19.359-20.351-33.675-20.351-20.987 0-38.074 17.087-38.074 38.074 0 10.543 4.1503 20.237 11.695 27.405zm45.354-12.491-6e-3 7e-3c-4.71 5.916-11.34 9.159-18.614 9.159-12.075 0-24.317-9.086-24.317-24.08 0-13.18 10.675-23.962 23.961-23.962 9.249 0 17.529 5.212 21.687 13.628 4.04 8.417 3.04 18.086-2.711 25.248z'
      fill='url(#k)'
    />
    <path
      d='m94.596 157.83 0.0021 2e-3c7.1493 6.773 16.804 10.667 26.495 10.667 7.747 0 15.355-2.443 21.934-7.073l18.507 18.506c1.35 1.492 3.099 2.208 4.87 2.208 2.917 0 5.448-2.09 6.653-4.501l0.068-0.136 0.048-0.143c0.213-0.64 0.529-1.749 0.395-3.082-0.138-1.388-0.746-2.852-2.097-4.202l-18.69-18.69c7.677-11.782 8.386-26.263 1.872-38.677l-4e-3 -7e-3c-6.774-12.795-19.359-20.351-33.675-20.351-20.987 0-38.074 17.087-38.074 38.074 0 10.543 4.1503 20.237 11.695 27.405zm45.354-12.491-6e-3 7e-3c-4.71 5.916-11.34 9.159-18.614 9.159-12.075 0-24.317-9.086-24.317-24.08 0-13.18 10.675-23.962 23.961-23.962 9.249 0 17.529 5.212 21.687 13.628 4.04 8.417 3.04 18.086-2.711 25.248z'
      fill='url(#j)'
      fillOpacity='.8'
    />
    <path
      d='m94.596 157.83 0.0021 2e-3c7.1493 6.773 16.804 10.667 26.495 10.667 7.747 0 15.355-2.443 21.934-7.073l18.507 18.506c1.35 1.492 3.099 2.208 4.87 2.208 2.917 0 5.448-2.09 6.653-4.501l0.068-0.136 0.048-0.143c0.213-0.64 0.529-1.749 0.395-3.082-0.138-1.388-0.746-2.852-2.097-4.202l-18.69-18.69c7.677-11.782 8.386-26.263 1.872-38.677l-4e-3 -7e-3c-6.774-12.795-19.359-20.351-33.675-20.351-20.987 0-38.074 17.087-38.074 38.074 0 10.543 4.1503 20.237 11.695 27.405zm45.354-12.491-6e-3 7e-3c-4.71 5.916-11.34 9.159-18.614 9.159-12.075 0-24.317-9.086-24.317-24.08 0-13.18 10.675-23.962 23.961-23.962 9.249 0 17.529 5.212 21.687 13.628 4.04 8.417 3.04 18.086-2.711 25.248z'
      stroke='#F0EDFA'
      strokeWidth='4.26741'
    />
    <path
      d='m120.57 156.8c14.612 0 26.458-11.846 26.458-26.458 0-14.613-11.846-26.458-26.458-26.458s-26.458 11.845-26.458 26.458c0 14.612 11.846 26.458 26.458 26.458z'
      fill='url(#i)'
    />
    <path
      d='m117.85 136.74c-0.127-0.506-0.127-1.012-0.127-1.644 0-2.151 0.886-4.048 3.163-5.693l1.898-1.392c1.138-0.885 1.644-1.897 1.644-3.162 0-1.772-1.265-3.543-3.922-3.543-2.783 0-4.048 2.277-4.048 4.428 0 0.506 0 0.886 0.127 1.265l-5.061-0.126c-0.126-0.506-0.253-1.139-0.253-1.771 0-4.302 3.163-8.35 9.109-8.35 6.072 0 9.362 3.922 9.362 7.844 0 3.162-1.645 5.313-3.922 6.958l-1.645 1.138c-1.391 1.012-2.15 2.277-2.15 3.795v0.253h-4.175zm2.15 2.531c1.771 0 3.163 1.391 3.163 3.162 0 1.772-1.392 3.163-3.163 3.163s-3.162-1.391-3.162-3.163c0.126-1.644 1.391-3.162 3.162-3.162z'
      fill='url(#h)'
    />
    <path
      d='m117.85 136.74c-0.127-0.506-0.127-1.012-0.127-1.644 0-2.151 0.886-4.048 3.163-5.693l1.898-1.392c1.138-0.885 1.644-1.897 1.644-3.162 0-1.772-1.265-3.543-3.922-3.543-2.783 0-4.048 2.277-4.048 4.428 0 0.506 0 0.886 0.127 1.265l-5.061-0.126c-0.126-0.506-0.253-1.139-0.253-1.771 0-4.302 3.163-8.35 9.109-8.35 6.072 0 9.362 3.922 9.362 7.844 0 3.162-1.645 5.313-3.922 6.958l-1.645 1.138c-1.391 1.012-2.15 2.277-2.15 3.795v0.253h-4.175zm2.15 2.531c1.771 0 3.163 1.391 3.163 3.162 0 1.772-1.392 3.163-3.163 3.163s-3.162-1.391-3.162-3.163c0.126-1.644 1.391-3.162 3.162-3.162z'
      fill='url(#g)'
    />
    <defs>
      <radialGradient
        id='au'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(93.452 31.31) rotate(111.33) scale(135.19 133.33)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='aj'
        x1='37.074'
        x2='84.289'
        y1='64.459'
        y2='134.95'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='y'
        x1='79.594'
        x2='63.216'
        y1='46.174'
        y2='74.359'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='62.674'
        x2='63.491'
        y1='46.743'
        y2='49.834'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='82.017'
        x2='65.638'
        y1='55.212'
        y2='83.397'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='65.097'
        x2='65.914'
        y1='55.781'
        y2='58.872'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='84.277'
        x2='67.898'
        y1='63.644'
        y2='91.829'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='67.357'
        x2='68.174'
        y1='64.213'
        y2='67.304'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='86.699'
        x2='70.32'
        y1='72.689'
        y2='100.87'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='69.779'
        x2='70.596'
        y1='73.258'
        y2='76.349'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='at'
        x1='89.12'
        x2='72.742'
        y1='81.728'
        y2='109.91'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='as'
        x1='72.2'
        x2='73.018'
        y1='82.297'
        y2='85.388'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ar'
        x1='91.543'
        x2='75.165'
        y1='90.766'
        y2='118.95'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='aq'
        x1='74.623'
        x2='75.44'
        y1='91.335'
        y2='94.426'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ap'
        x1='93.803'
        x2='77.425'
        y1='99.205'
        y2='127.39'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='ao'
        x1='76.883'
        x2='77.7'
        y1='99.773'
        y2='102.86'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='an'
        x1='96.225'
        x2='79.846'
        y1='108.24'
        y2='136.43'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='am'
        x1='79.305'
        x2='80.122'
        y1='108.81'
        y2='111.9'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='al'
        x1='98.647'
        x2='82.268'
        y1='117.28'
        y2='145.47'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='ak'
        x1='81.727'
        x2='82.544'
        y1='117.85'
        y2='120.94'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ai'
        x1='75.144'
        x2='82.559'
        y1='47.199'
        y2='31.55'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='ah'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(154.61 54.04) rotate(141.33) scale(135.19 133.33)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='ag'
        x1='89.213'
        x2='94.857'
        y1='54.559'
        y2='139.21'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='af'
        x1='135.18'
        x2='106.9'
        y1='59.976'
        y2='76.195'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='ae'
        x1='120.24'
        x2='119.4'
        y1='52.008'
        y2='55.094'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ad'
        x1='132.75'
        x2='104.48'
        y1='69.014'
        y2='85.234'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='ac'
        x1='117.82'
        x2='116.98'
        y1='61.047'
        y2='64.132'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ab'
        x1='130.49'
        x2='102.22'
        y1='77.446'
        y2='93.665'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='aa'
        x1='115.56'
        x2='114.72'
        y1='69.478'
        y2='72.564'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='z'
        x1='128.07'
        x2='99.794'
        y1='86.492'
        y2='102.71'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='x'
        x1='113.13'
        x2='112.3'
        y1='78.524'
        y2='81.61'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='125.65'
        x2='97.372'
        y1='95.53'
        y2='111.75'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='110.71'
        x2='109.87'
        y1='87.562'
        y2='90.648'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='123.23'
        x2='94.952'
        y1='104.57'
        y2='120.79'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='108.29'
        x2='107.45'
        y1='96.6'
        y2='99.686'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='120.97'
        x2='92.691'
        y1='113.01'
        y2='129.23'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='106.03'
        x2='105.19'
        y1='105.04'
        y2='108.12'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='118.54'
        x2='90.268'
        y1='122.05'
        y2='138.26'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='103.61'
        x2='102.77'
        y1='114.08'
        y2='117.16'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='116.12'
        x2='87.846'
        y1='131.08'
        y2='147.3'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='m'
        x1='101.18'
        x2='100.35'
        y1='123.12'
        y2='126.2'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='130.81'
        x2='145.06'
        y1='58.65'
        y2='48.805'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='k'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(166.2 99.608) rotate(133.56) scale(123.63 127.58)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='j'
        x1='99.142'
        x2='117.3'
        y1='113.94'
        y2='182.89'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='i'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(102.05 103.88) rotate(51.199) scale(231.9 394.34)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </radialGradient>
      <linearGradient
        id='h'
        x1='129.98'
        x2='112.34'
        y1='121.6'
        y2='145.64'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.37711' stopColor='#413BBC' />
        <stop offset='.69909' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='112.62'
        x2='119.92'
        y1='134.14'
        y2='135.64'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
export const PageNotFound404Svg = () => (
  <svg
    width='200'
    height='200'
    fill='none'
    viewBox='0 0 200 200'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='200' height='200' rx='100' fill='#F0F2FA' />
    <path
      d='m181.54 159.08c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.053c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.88 35.753c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.885 185.75c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m192.88 161c1.104 0 2-0.896 2-2 0-1.105-0.896-2-2-2-1.105 0-2 0.895-2 2 0 1.104 0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.513 30.301c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.012 30.3c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <g filter='url(#o)'>
      <path
        d='m142.5 53.345c0 16.464-13.094 30.079-29.381 31.029h-1.916c-5.429 0-10.858-1.5831-15.329-4.116-9.5806-5.3825-15.968-15.514-15.968-27.229 0-7.9155 2.8742-15.198 7.9838-20.58 5.7484-6.3324 14.052-10.448 23.313-10.448 12.136 0 22.674 6.9656 27.784 17.097 2.235 4.4327 3.513 9.182 3.513 14.248z'
        fill='url(#d)'
      />
    </g>
    <path
      d='m142.55 52.943c0 16.464-13.093 30.079-29.38 31.029-6.068-0.9499-11.816-2.533-17.245-3.7994-9.5806-5.3825-15.968-15.514-15.968-27.229 0-7.9154 2.8742-15.198 7.9838-20.58 10.539-0.3166 22.674 0.6333 35.129 2.8496 5.748 0.9498 11.177 2.2163 16.287 3.4828 1.916 4.4327 3.193 9.1819 3.193 14.248z'
      fill='#8C9098'
      opacity='.1'
    />
    <g filter='url(#m)'>
      <path
        d='m180.73 73.898c2.41-13.428-27.308-29.901-66.377-36.795-39.068-6.8931-72.694-1.5956-75.104 11.832-2.4103 13.428 27.308 29.902 66.376 36.795 39.069 6.8931 72.695 1.5956 75.105-11.832z'
        fill='url(#c)'
      />
    </g>
    <g filter='url(#l)'>
      <path
        d='m100.88 44.19c0.019-2.2733-3.6832-4.1423-8.2686-4.1746-4.5854-0.0324-8.3181 1.7843-8.3371 4.0576s3.6827 4.1423 8.2681 4.1747c4.5854 0.0323 8.3176-1.7844 8.3376-4.0577z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#k)'>
      <path
        d='m59.262 51.299c4.3959-1.2939 7.4305-4.1094 6.7779-6.2885-0.6525-2.1791-4.7451-2.8967-9.1409-1.6028-4.3959 1.294-7.4305 4.1094-6.7779 6.2885 0.6525 2.1791 4.7451 2.8967 9.1409 1.6028z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#j)'>
      <path
        d='m136.46 51.964c0.672-2.1723-2.337-5.0205-6.721-6.3616s-8.482-0.6673-9.154 1.505c-0.671 2.1723 2.338 5.0205 6.722 6.3616s8.482 0.6673 9.153-1.505z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#i)'>
      <path
        d='m168.51 68.622c1.156-1.9627-1.119-5.4135-5.08-7.7077s-8.109-2.563-9.264-0.6003c-1.155 1.9626 1.119 5.4135 5.081 7.7077 3.961 2.2942 8.108 2.5629 9.263 0.6003z'
        fill='#F0EDFA'
      />
    </g>
    <path
      d='m106.01 64.282-30.019-0.3166-42.751 79.517 132.76 12.017-26.138-80.453-33.851-10.765z'
      fill='url(#b)'
    />
    <g filter='url(#h)'>
      <path
        d='m139.67 75.865c1.081-6.0254-12.4-13.443-30.111-16.568-17.711-3.1249-32.946-0.7736-34.028 5.2518s12.4 13.443 30.11 16.568c17.712 3.1249 32.946 0.7736 34.028-5.2518z'
        fill='#F0EDFA'
      />
    </g>
    <path
      d='m33.483 105.05s-11.031 2.801-7.6886 5.041c3.3429 2.129 11.254 5.826 18.72 3.361 7.4657-2.464 0-5.937 0.1114-5.937s-11.143-2.465-11.143-2.465z'
      fill='#C3C5C9'
    />
    <g filter='url(#g)'>
      <path
        d='m20 104.15c4.0114 1.233 16.38-0.784 24.291-5.9374 6.24 7.7304 8.58 9.7464 10.808 9.9714-3.4543 3.473-14.931 9.074-21.394 1.792-7.5771 4.818-13.706-5.826-13.706-5.826z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#f)'>
      <path
        d='m144.01 114.23c4.234 0.224 15.711-4.929 21.951-11.875 8.023 5.937 10.697 7.282 13.037 6.946-2.563 4.257-10.363 13.556-21.394 14.228-8.023-4.705-13.594-9.299-13.594-9.299z'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#e)'>
      <path
        d='m107.31 114.37c-0.837-4.157-8.6873-13.988-16.969-18.301 3.7522-9.2491 4.3881-12.174 3.4797-14.356 4.7614 1.4216 15.71 6.6594 19.109 17.176-2.559 8.9419-5.62 15.482-5.62 15.482z'
        fill='#F0EDFA'
      />
    </g>
    <g fill='url(#a)' filter='url(#n)'>
      <path d='m77.994 151.65c0.5522 0 1 0.448 1 1v5.976c0 0.552-0.4478 1-1 1h-2.7992c-0.5523 0-1 0.448-1 1v5.577c0 0.552-0.4478 1-1 1h-7.1985c-0.5523 0-1-0.448-1-1v-5.577c0-0.552-0.4477-1-1-1h-17.997c-0.5523 0-1-0.448-1-1v-7.85c0-0.21 0.066-0.414 0.1888-0.584l17.609-24.431c0.3759-0.522 0.9796-0.831 1.6225-0.831h7.3744c1.1046 0 2 0.896 2 2v23.72c0 0.552 0.4477 1 1 1h3.1992zm-12.598-16.351-10.478 14.772c-0.4697 0.662 0.0038 1.579 0.8157 1.579h8.6626c0.5523 0 1-0.448 1-1v-15.351z' />
      <path d='m100.54 168c-9.5988 0-17.997-8.375-17.997-21.934s8.3986-21.934 17.997-21.934c9.598 0 17.997 8.375 17.997 21.934 0.399 13.16-7.999 21.934-17.997 21.934zm0-8.375c4.399 0 9.198-4.387 9.198-13.958 0-9.172-4.399-13.958-9.198-13.958-4.3997 0-9.1988 4.387-9.1988 13.958 0.3999 9.571 4.7991 13.958 9.1988 13.958z' />
      <path d='m155.08 151.65c0.552 0 1 0.448 1 1v5.976c0 0.552-0.448 1-1 1h-2.799c-0.553 0-1 0.448-1 1v5.577c0 0.552-0.448 1-1 1h-7.199c-0.552 0-1-0.448-1-1v-5.577c0-0.552-0.447-1-1-1h-17.996c-0.553 0-1-0.448-1-1v-7.85c0-0.21 0.066-0.414 0.188-0.584l17.909-24.846c0.188-0.261 0.49-0.416 0.811-0.416h8.887c0.552 0 1 0.448 1 1v24.72c0 0.552 0.447 1 1 1h3.199zm-12.998-13.213c0-0.974-1.252-1.373-1.815-0.578l-8.663 12.212c-0.47 0.662 4e-3 1.579 0.816 1.579h8.662c0.553 0 1-0.448 1-1v-12.213z' />
    </g>
    <defs>
      <filter
        id='o'
        x='79.908'
        y='9'
        width='72.593'
        height='75.374'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='m'
        x='39.116'
        y='21.081'
        width='151.76'
        height='67.671'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='l'
        x='84.279'
        y='40.015'
        width='18.605'
        height='8.2332'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='5' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='k'
        x='50.033'
        y='42.764'
        width='18.095'
        height='9.179'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='5' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='j'
        x='120.49'
        y='44.912'
        width='18.063'
        height='9.2463'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='5' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='i'
        x='153.87'
        y='59.001'
        width='16.946'
        height='10.934'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='5' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='h'
        x='75.473'
        y='53.914'
        width='68.26'
        height='28.585'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='10' dy='-4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='g'
        x='20'
        y='94.212'
        width='41.1'
        height='19.32'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='6' dy='-4' />
        <feGaussianBlur stdDeviation='6.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='f'
        x='144.01'
        y='98.358'
        width='40.988'
        height='25.174'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='6' dy='-4' />
        <feGaussianBlur stdDeviation='6.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='e'
        x='90.343'
        y='77.714'
        width='28.589'
        height='36.658'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='6' dy='-4' />
        <feGaussianBlur stdDeviation='6.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <filter
        id='n'
        x='45'
        y='124.13'
        width='114.08'
        height='44.868'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='3' dy='1' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0' />
        <feBlend in2='shape' result='effect1_innerShadow_6741_292363' />
      </filter>
      <linearGradient
        id='d'
        x1='111.2'
        x2='141.03'
        y1='22'
        y2='84.456'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='39.253'
        x2='113.11'
        y1='48.935'
        y2='-23.063'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='106.5'
        x2='95.5'
        y1='59.5'
        y2='150'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' stopOpacity='0.75' />
        <stop offset='1' stopColor='#F0EDFA' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='100.54'
        x2='110.4'
        y1='124.13'
        y2='176.21'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);
export const BorkenPageSvg = () => (
  <svg
    width='200'
    height='214'
    viewBox='0 0 200 214'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='14' width='200' height='200' rx='100' fill='#F0F2FA' />
    <g filter='url(#filter0_i_6741_291118)'>
      <rect
        x='95'
        width='6'
        height='33'
        rx='3'
        fill='url(#paint0_linear_6741_291118)'
      />
    </g>
    <g filter='url(#filter1_i_6741_291118)'>
      <path
        d='M112.979 13.7934C113.501 12.2102 115.228 11.3721 116.795 11.9422C118.328 12.5002 119.118 14.1953 118.56 15.7283L113.034 30.9101C112.638 31.9983 111.594 32.7138 110.436 32.69C108.617 32.6526 107.352 30.866 107.922 29.1377L112.979 13.7934Z'
        fill='url(#paint1_linear_6741_291118)'
      />
    </g>
    <g filter='url(#filter2_i_6741_291118)'>
      <path
        d='M80.2625 23.9628C79.7088 22.4415 80.4932 20.7593 82.0145 20.2056C83.5853 19.6339 85.3154 20.4894 85.8147 22.0846L88.3919 30.3192C88.9366 32.0598 87.6567 33.8356 85.8332 33.8693C84.6655 33.8909 83.6131 33.1683 83.2136 32.0709L80.2625 23.9628Z'
        fill='url(#paint2_linear_6741_291118)'
      />
    </g>
    <g filter='url(#filter3_i_6741_291118)'>
      <path
        d='M156.028 77.6198L157.274 177.925C157.274 181.352 154.47 184 151.044 184H53.2302C49.8036 184 47 181.196 47 177.925V48.961C47 45.5344 49.8036 42.8866 53.2302 42.8866H124.098L156.028 77.6198Z'
        fill='url(#paint3_linear_6741_291118)'
      />
    </g>
    <g filter='url(#filter4_i_6741_291118)'>
      <path
        d='M136.889 65.7915H65.6738C63.4181 65.7915 61.4846 64.8145 61.4846 63.6746C61.4846 62.5348 63.4181 61.5578 65.6738 61.5578H136.889C139.144 61.5578 141.078 62.5348 141.078 63.6746C141.078 64.8145 139.144 65.7915 136.889 65.7915Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter5_i_6741_291118)'>
      <path
        d='M134.304 78.4927H68.8228C64.8714 78.4927 61.4844 77.5157 61.4844 76.3758C61.4844 75.236 64.8714 74.259 68.8228 74.259H133.739C137.691 74.259 141.078 75.236 141.078 76.3758C141.078 77.5157 137.691 78.4927 134.304 78.4927Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter6_i_6741_291118)'>
      <path
        d='M136.888 90.347H65.6736C63.4179 90.347 61.4844 89.37 61.4844 88.2301C61.4844 87.0903 63.4179 86.1133 65.6736 86.1133H136.888C139.144 86.1133 141.078 87.0903 141.078 88.2301C141.078 89.37 139.144 90.347 136.888 90.347Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter7_i_6741_291118)'>
      <path
        d='M136.888 103.048H65.6736C63.4179 103.048 61.4844 102.071 61.4844 100.931C61.4844 99.7913 63.4179 98.8143 65.6736 98.8143H136.888C139.144 98.8143 141.078 99.7913 141.078 100.931C141.078 102.071 139.144 103.048 136.888 103.048Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter8_i_6741_291118)'>
      <path
        d='M136.888 115.749H65.6736C63.4179 115.749 61.4844 114.772 61.4844 113.632C61.4844 112.492 63.4179 111.515 65.6736 111.515H136.888C139.144 111.515 141.078 112.492 141.078 113.632C141.078 114.772 139.144 115.749 136.888 115.749Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter9_i_6741_291118)'>
      <path
        d='M136.888 128.45H65.6736C63.4179 128.45 61.4844 127.473 61.4844 126.333C61.4844 125.193 63.4179 124.216 65.6736 124.216H136.888C139.144 124.216 141.078 125.193 141.078 126.333C141.078 127.473 139.144 128.45 136.888 128.45Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter10_i_6741_291118)'>
      <path
        d='M136.888 140.304H65.6736C63.4179 140.304 61.4844 139.327 61.4844 138.188C61.4844 137.048 63.4179 136.071 65.6736 136.071H136.888C139.144 136.071 141.078 137.048 141.078 138.188C141.078 139.327 139.144 140.304 136.888 140.304Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter11_i_6741_291118)'>
      <path
        d='M136.888 153.005H65.6736C63.4179 153.005 61.4844 152.028 61.4844 150.889C61.4844 149.749 63.4179 148.772 65.6736 148.772H136.888C139.144 148.772 141.078 149.749 141.078 150.889C141.078 152.028 139.144 153.005 136.888 153.005Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter12_i_6741_291118)'>
      <path
        d='M136.888 165.706H65.6736C63.4179 165.706 61.4844 164.729 61.4844 163.59C61.4844 162.45 63.4179 161.473 65.6736 161.473H136.888C139.144 161.473 141.078 162.45 141.078 163.59C141.078 164.729 139.144 165.706 136.888 165.706Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter13_i_6741_291118)'>
      <path
        d='M124.098 42.8866V70.6108C124.098 74.5047 127.525 77.6198 131.419 77.6198H156.028'
        fill='#F0EDFA'
      />
    </g>
    <path
      d='M77.1119 62.9991L84.3572 37.4437L114.755 40.9451L104.472 57.4285C104.284 57.7299 104.351 58.1243 104.629 58.3459L111.936 64.1838C112.187 64.3842 112.269 64.7297 112.135 65.0217L94.6646 103.235L95.6506 73.2659L77.4625 63.8112C77.1678 63.658 77.0213 63.3187 77.1119 62.9991Z'
      fill='url(#paint4_linear_6741_291118)'
    />
    <path
      d='M82.172 60.9562L88.5 40.9451L114.755 40.9451L104.472 57.4286C104.284 57.7299 104.351 58.1243 104.629 58.346L111.936 64.1838C112.187 64.3842 112.269 64.7297 112.135 65.0217L94.6646 103.235L98.9365 71.4721C98.9748 71.1872 98.8351 70.9079 98.5842 70.7677L82.4979 61.7783C82.208 61.6163 82.0718 61.2728 82.172 60.9562Z'
      fill='url(#paint5_linear_6741_291118)'
    />
    <path
      d='M181.54 173.08C183.495 173.08 185.08 171.495 185.08 169.54C185.08 167.585 183.495 166 181.54 166C179.585 166 178 167.585 178 169.54C178 171.495 179.585 173.08 181.54 173.08Z'
      fill='white'
    />
    <path
      d='M180.035 36.0526C181.774 36.0526 183.185 34.6423 183.185 32.9026C183.185 31.1629 181.774 29.7526 180.035 29.7526C178.295 29.7526 176.885 31.1629 176.885 32.9026C176.885 34.6423 178.295 36.0526 180.035 36.0526Z'
      fill='#C5B8EA'
    />
    <path
      d='M167.885 49.7526C171.751 49.7526 174.885 46.6186 174.885 42.7526C174.885 38.8866 171.751 35.7526 167.885 35.7526C164.019 35.7526 160.885 38.8866 160.885 42.7526C160.885 46.6186 164.019 49.7526 167.885 49.7526Z'
      fill='white'
    />
    <path
      d='M17.8848 183.753C21.7507 183.753 24.8848 180.619 24.8848 176.753C24.8848 172.887 21.7507 169.753 17.8848 169.753C14.0188 169.753 10.8848 172.887 10.8848 176.753C10.8848 180.619 14.0188 183.753 17.8848 183.753Z'
      fill='white'
    />
    <path
      d='M191.885 171C192.989 171 193.885 170.105 193.885 169C193.885 167.895 192.989 167 191.885 167C190.78 167 189.885 167.895 189.885 169C189.885 170.105 190.78 171 191.885 171Z'
      fill='#C5B8EA'
    />
    <path
      d='M35.5128 44.301C38.3573 44.301 40.6633 41.995 40.6633 39.1505C40.6633 36.306 38.3573 34 35.5128 34C32.6683 34 30.3623 36.306 30.3623 39.1505C30.3623 41.995 32.6683 44.301 35.5128 44.301Z'
      fill='white'
    />
    <path
      d='M19.0123 44.3C20.4759 44.3 21.6623 43.1136 21.6623 41.65C21.6623 40.1864 20.4759 39 19.0123 39C17.5487 39 16.3623 40.1864 16.3623 41.65C16.3623 43.1136 17.5487 44.3 19.0123 44.3Z'
      fill='#DCDAE3'
    />
    <path
      d='M4.39062 189C6.04748 189 7.39062 187.656 7.39062 186C7.39062 184.343 6.04748 183 4.39062 183C2.73377 183 1.39062 184.343 1.39062 186C1.39062 187.656 2.73377 189 4.39062 189Z'
      fill='#C5B8EA'
    />
    <defs>
      <filter
        id='filter0_i_6741_291118'
        x='95'
        y='0'
        width='7'
        height='34'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter1_i_6741_291118'
        x='107.784'
        y='11.7632'
        width='11.9552'
        height='21.9274'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter2_i_6741_291118'
        x='80.085'
        y='20.0279'
        width='9.4335'
        height='14.8419'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='2' dy='3' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter3_i_6741_291118'
        x='47'
        y='29.8866'
        width='120.274'
        height='154.113'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter4_i_6741_291118'
        x='61.4846'
        y='61.5578'
        width='85.5932'
        height='6.2337'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter5_i_6741_291118'
        x='61.4844'
        y='74.259'
        width='85.5932'
        height='6.2337'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter6_i_6741_291118'
        x='61.4844'
        y='86.1133'
        width='85.5932'
        height='6.2337'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter7_i_6741_291118'
        x='61.4844'
        y='98.8143'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter8_i_6741_291118'
        x='61.4844'
        y='111.515'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter9_i_6741_291118'
        x='61.4844'
        y='124.216'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter10_i_6741_291118'
        x='61.4844'
        y='136.071'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter11_i_6741_291118'
        x='61.4844'
        y='148.772'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter12_i_6741_291118'
        x='61.4844'
        y='161.473'
        width='85.5932'
        height='6.23367'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='9' dy='2' />
        <feGaussianBlur stdDeviation='3' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <filter
        id='filter13_i_6741_291118'
        x='124.098'
        y='42.8866'
        width='31.9296'
        height='38.7332'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_6741_291118'
        />
      </filter>
      <linearGradient
        id='paint0_linear_6741_291118'
        x1='98'
        y1='-4.52876e-07'
        x2='111.162'
        y2='5.42302'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_6741_291118'
        x1='116.751'
        y1='11.9265'
        x2='125.123'
        y2='22.1733'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_6741_291118'
        x1='82.079'
        y1='20.1821'
        x2='92.7915'
        y2='24.4169'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_6741_291118'
        x1='102.137'
        y1='42.8866'
        x2='179.459'
        y2='168.988'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_6741_291118'
        x1='94.0024'
        y1='36.3212'
        x2='101.694'
        y2='102.417'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F0F2FA' />
        <stop offset='1' stopColor='#EAEEFF' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_6741_291118'
        x1='97'
        y1='46.0001'
        x2='104.3'
        y2='102.114'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F4F6FF' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyOrderSvg = () => (
  <svg
    width='200'
    height='201'
    fill='none'
    viewBox='0 0 200 201'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m0 100.5c0-55.228 44.772-100 100-100 55.228 0 100 44.772 100 100 0 55.228-44.772 100-100 100-55.228 0-100-44.772-100-100z'
      fill='#F0EDFA'
    />
    <path
      d='m181.54 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.552c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.88 36.252c3.866 0 7-3.1341 7-7 0-3.866-3.134-7-7-7s-7 3.134-7 7c0 3.8659 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.885 186.25c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m191.88 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.513 30.801c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.012 30.8c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m28.639 68.348h149.82v93.501c0 1.198-0.195 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.7 0.848-1.532 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-134.72c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.636-2.959-0.3792-1.107-0.5744-2.294-0.5744-3.492v-93.501z'
      fill='url(#t)'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='#407BFF'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='url(#i)'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='url(#h)'
    />
    <path
      d='m88.571 61.76c0.2025 0.3929 0.4083 0.78 0.6174 1.1614l-0.44 0.2443-0.6222-1.1796 0.4448-0.2261z'
      fill='#2F3155'
    />
    <path
      d='m70.986 5.6151-0.4139 0.23901 0.2489 0.43122c0.7578-0.4603 1.5424-0.87491 2.3497-1.2416l-0.203-0.45778c-0.6532 0.31583-1.3319 0.65402-1.9817 1.0291zm4.5385-1.9916 0.1503 0.47283c0.8456-0.26239 1.7096-0.46139 2.5848-0.59536l-0.0771-0.49211c-0.8981 0.14261-1.7843 0.35191-2.6514 0.62614l-0.0066-0.0115zm5.3829-0.80793 3e-3 0.49655c0.8836 0.00431 1.7655 0.0797 2.637 0.22542l0.0868-0.48708c-0.9017-0.15641-1.815-0.23691-2.7301-0.24065l0.0033 0.00576zm5.3657 0.88853-0.1469 0.47581c0.8433 0.26922 1.6662 0.59856 2.4625 0.98547l0.217-0.44731c-0.8204-0.40305-1.6691-0.74577-2.5393-1.0255l0.0067 0.01149zm4.8873 2.3837-0.2847 0.40973c0.7275 0.50323 1.4103 1.0683 2.0407 1.6889l0.3476-0.35399c-0.65-0.64366-1.355-1.2294-2.1069-1.7504l0.0033 0.00576zm3.871 3.8367-0.4113 0.28349c0.1793 0.3105 0.4021 0.6035 0.578 0.9082 0.2447 0.4275 0.4657 0.868 0.6622 1.3196-0.4301 0.2884-0.8433 0.6012-1.2376 0.9368l0.3204 0.3824c0.629-0.5321 1.303-1.0085 2.0145-1.4238l0.1495-0.0863-0.249-0.4312-0.1552 0.0896-0.4312 0.249c-0.1943-0.4428-0.4128-0.8746-0.6547-1.2933-0.1735-0.3138-0.38-0.6315-0.5889-0.94024l0.0033 0.00575zm4.3558 0.81239 0.1446 0.4761c0.8405-0.2519 1.7085-0.4028 2.5845-0.4496l-0.027-0.4981c-0.917 0.0477-1.825 0.2041-2.7054 0.4658l0.0033 0.0058zm-6.6944 4.5779c-0.5887 0.6974-1.1209 1.4405-1.5918 2.2223l0.4286 0.2509c0.4558-0.7562 0.9717-1.4745 1.5427-2.148l-0.3795-0.3252zm3.9697-0.268c0.1629 0.8645 0.2287 1.7445 0.1962 2.6236l0.495 0.0208c0.0386-0.9167-0.0285-1.8349-0.2-2.7364l-0.4912 0.092zm8.1718-4.5952-0.087 0.487c0.868 0.156 1.718 0.3969 2.539 0.7192l0.177-0.4628c-0.852-0.3415-1.736-0.5964-2.639-0.7607l0.01 0.0173zm-14.919 9.5332-0.0543 0.1847c-0.2805 0.8286-0.3769 1.7084-0.2825 2.578l0.4954-0.0714c-0.086-0.7963 0.0038-1.6018 0.2629-2.3596l0.0552-0.1699-0.4767-0.1618zm19.998-7.6281-0.239 0.4367c0.788 0.4346 1.556 0.903 2.272 1.3865l0.282-0.4154c-0.729-0.4917-1.51-0.9683-2.315-1.4078zm-13.474 7.8939c-0.2316 0.812-0.5495 1.5969-0.9481 2.3413l-0.0531 0.1073 0.4367 0.2385 0.0588-0.1106c0.4074-0.7746 0.7304-1.5908 0.9633-2.4344l-0.4576-0.1421zm-5.0688 4.406-0.217 0.4473c0.4458 0.2038 0.9344 0.2965 1.4239 0.2702 0.4895-0.0262 0.9653-0.1707 1.3868-0.421l-0.249-0.4313c-0.3523 0.2062-0.7485 0.3259-1.1561 0.3494-0.4076 0.0234-0.8149-0.0501-1.1886-0.2146zm23.024-9.2523-0.317 0.3818c0.683 0.5679 1.336 1.1711 1.956 1.8071l0.354-0.3425c-0.625-0.6553-1.289-1.2729-1.988-1.8497l-5e-3 0.0033zm3.782 3.8956-0.398 0.3064c0.543 0.7034 1.046 1.4369 1.506 2.197l0.431-0.249c-0.471-0.7794-0.985-1.5321-1.539-2.2544zm2.355 4.8497c0.377 0.8117 0.711 1.6426 1 2.4891l0.476-0.1594c-0.295-0.8568-0.632-1.6983-1.011-2.5212l-0.465 0.1915zm1.718 5.0338c0.2 0.8506 0.363 1.7302 0.482 2.6272l0.496-0.0713c-0.123-0.9029-0.279-1.8097-0.491-2.6684l-0.487 0.1125zm0.748 5.2793c0.044 0.8719 0.05 1.7728 0.016 2.6821l0.497 0.0118c0.026-0.9117 0.018-1.8274-0.032-2.7108l-0.481 0.0169zm-0.143 5.3419c-0.084 0.8765-0.206 1.7673-0.355 2.6507l0.492 0.0835c0.152-0.8926 0.273-1.7981 0.36-2.6838l-0.497-0.0504zm-0.879 5.2759c-0.191 0.877-0.434 1.7304-0.693 2.5847l0.476 0.1469c0.263-0.8724 0.516-1.7621 0.697-2.6177l-0.48-0.1139zm-1.539 5.1281c-0.293 0.8207-0.641 1.6655-0.991 2.4807l0.453 0.1989c0.361-0.8218 0.7-1.6691 1.003-2.5112l-0.465-0.1684z'
      fill='#3B424F'
    />
    <path
      d='m68.283 7.4535c-0.359 0.27137-0.703 0.56211-1.0304 0.87091l0.3458 0.35998s0.3542-0.3425 0.9877-0.83859l-0.3031-0.3923z'
      fill='#3B424F'
    />
    <path
      d='m62.976 11.66c-1.5981-2.1438 2.3558-6.1439 4.4518-3.3368 2.0959 2.807-2.8438 5.498-4.4518 3.3368z'
      fill='#3B424F'
    />
    <path
      d='m66.931 4.3004c-0.9383-0.61591-2.5546 0.15631-3.509 2.1946-0.6071 1.4554-0.9305 3.0134-0.953 4.5903 1.433-0.6395 2.7304-1.5473 3.8223-2.6744 1.5232-1.7304 1.6075-3.4963 0.6397-4.1104z'
      fill='#99A2DA'
    />
    <path
      d='m66.931 4.3004c-0.9383-0.61591-2.5546 0.15631-3.509 2.1946-0.6071 1.4554-0.9305 3.0134-0.953 4.5903 1.433-0.6395 2.7304-1.5473 3.8223-2.6744 1.5232-1.7304 1.6075-3.4963 0.6397-4.1104z'
      fill='url(#g)'
      fillOpacity='0.2'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='#99A2DA'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='#99A2DA'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='url(#f)'
      fillOpacity='0.2'
    />
    <path
      d='m62.976 11.659c0.1536-0.1143 0.27-0.2715 0.3344-0.4518s0.0739-0.3757 0.0274-0.5614c-0.0465-0.1858-0.1469-0.3536-0.2887-0.4823-0.1417-0.1287-0.3184-0.21252-0.5078-0.24092-0.1893-0.0284-0.3828-8e-5 -0.5561 0.08142-0.1733 0.0814-0.3186 0.2123-0.4175 0.3763-0.099 0.1639-0.1471 0.3534-0.1385 0.5447 0.0087 0.1913 0.0738 0.3757 0.1871 0.53 0.1539 0.2065 0.3832 0.3439 0.6379 0.3821s0.5141-0.0259 0.7218-0.1781z'
      fill='#3B424F'
    />
    <path
      d='m64.138 13.219c0.1024-0.0763 0.1889-0.172 0.2543-0.2817 0.0655-0.1096 0.1087-0.2311 0.1272-0.3575 0.0186-0.1264 0.012-0.2551-0.0192-0.379-0.0313-0.1238-0.0866-0.2403-0.1629-0.3427-0.0763-0.1025-0.172-0.1889-0.2816-0.2544-0.1097-0.0654-0.2312-0.1087-0.3576-0.1272-0.1263-0.0185-0.2551-0.0119-0.3789 0.0193-0.1239 0.0313-0.2403 0.0866-0.3428 0.1629-0.2069 0.154-0.3441 0.3839-0.3815 0.6391s0.0281 0.5149 0.1821 0.7218 0.3839 0.3441 0.6392 0.3815c0.2552 0.0374 0.5148-0.0281 0.7217-0.1821z'
      fill='#3B424F'
    />
    <path
      d='m178.46 68.347h-106.01l13.041-13.156c1.4348-1.41 4.9807-2.6086 7.9318-2.6086h95.333c2.951 0 4.176 1.1704 2.742 2.6086l-13.041 13.156z'
      fill='url(#e)'
    />
    <path
      d='m178.46 68.347h-106.01l13.041-13.156c1.4348-1.41 4.9807-2.6086 7.9318-2.6086h95.333c2.951 0 4.176 1.1704 2.742 2.6086l-13.041 13.156z'
      fill='url(#d)'
    />
    <path
      d='m72.451 68.348h106.01v93.501c0 1.198-0.196 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.701 0.848-1.533 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.6359-2.959-0.3793-1.107-0.5745-2.294-0.5745-3.492v-93.501z'
      fill='url(#c)'
    />
    <path
      d='m72.451 68.348h106.01v93.501c0 1.198-0.196 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.701 0.848-1.533 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.6359-2.959-0.3793-1.107-0.5745-2.294-0.5745-3.492v-93.501z'
      fill='#413BBC'
      fillOpacity='0.4'
    />
    <path
      d='m178.57 116.14-0.109 45.705c0 1.198-0.196 2.385-0.575 3.491-0.379 1.107-0.935 2.113-1.636 2.96s-1.533 1.519-2.448 1.978c-0.916 0.458-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.236-2.8881-0.694-0.9156-0.459-1.7476-1.131-2.4484-1.978s-1.2567-1.853-1.6359-2.96c-0.3793-1.106-0.5745-2.293-0.5745-3.491v-45.705l3.0418 5.476c23.229 41.817 84.407 38.566 103.07-5.476z'
      fill='url(#b)'
    />
    <path
      d='m178.57 116.14-0.109 45.705c0 1.198-0.196 2.385-0.575 3.491-0.379 1.107-0.935 2.113-1.636 2.96s-1.533 1.519-2.448 1.978c-0.916 0.458-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.236-2.8881-0.694-0.9156-0.459-1.7476-1.131-2.4484-1.978s-1.2567-1.853-1.6359-2.96c-0.3793-1.106-0.5745-2.293-0.5745-3.491v-45.705l3.0418 5.476c23.229 41.817 84.407 38.566 103.07-5.476z'
      fill='url(#a)'
    />
    <g filter='url(#v)'>
      <path
        d='m41.557 68.17 1.584 16.83 2.1685 3.2564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967v-21.245h-17.926z'
        fill='#E2E3F5'
      />
    </g>
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#s)'
    />
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#r)'
    />
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#q)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#p)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#o)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#n)'
    />
    <g filter='url(#u)'>
      <path
        d='m160.76 54.943-1.141-2.4434h11.517c-0.889 2.5919 4.814 8.1016 8.252 11.195 3.437 3.0938 6.187 6.875 2.406 9.9688-3.781 3.0937-7.566 0.3437-9.281-1.375-1.716-1.7188-3.603-3.6919-5.04-5.1322-3.093-3.0938-6.854-1.0313-8.339-4.8297-0.811-2.0728 0.354-4.2247 1.097-5.3522 0.396-0.5998 0.582-1.3144 0.529-2.0316z'
        fill='#fff'
      />
    </g>
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#m)'
    />
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#l)'
    />
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#k)'
    />
    <circle cx='170' cy='170.5' r='20' fill='url(#j)' />
    <path
      d='m167.15 159.07h5.626l-1.5 15.626h-2.625l-1.501-15.626z'
      fill='#fff'
    />
    <ellipse cx='169.96' cy='179.7' rx='2.8127' ry='2.5002' fill='#fff' />
    <defs>
      <filter
        id='v'
        x='25.557'
        y='65.17'
        width='35.926'
        height='39.246'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-7' dy='6' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4297_171243'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_4297_171243'
          result='shape'
        />
      </filter>
      <filter
        id='u'
        x='145.86'
        y='41.5'
        width='42.757'
        height='41.564'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-4' dy='-2' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0.25 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4297_171243'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.183333 0 0 0 0 0.180278 0 0 0 0 0.180278 0 0 0 0.25 0' />
        <feBlend
          in2='effect1_dropShadow_4297_171243'
          result='effect2_dropShadow_4297_171243'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect2_dropShadow_4297_171243'
          result='shape'
        />
      </filter>
      <linearGradient
        id='t'
        x1='47'
        x2='151.5'
        y1='152.5'
        y2='105.5'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='i'
        x1='134.16'
        x2='133.16'
        y1='43.464'
        y2='73.925'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='141.57'
        x2='104.14'
        y1='55.884'
        y2='-5.5772'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='65.352'
        x2='68.543'
        y1='9.3636'
        y2='5.764'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopOpacity='0' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='68'
        x2='71'
        y1='13.001'
        y2='9.0007'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopOpacity='0' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='191.6'
        x2='191.18'
        y1='52.126'
        y2='71.995'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='199.02'
        x2='180.18'
        y1='60.222'
        y2='12.774'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='c'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(172 74.5) rotate(134.19) scale(149.92 154.84)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.7' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='b'
        x1='178.12'
        x2='156.24'
        y1='113.01'
        y2='246.04'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='184.7'
        x2='73.73'
        y1='168.66'
        y2='132.6'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='71.391'
        x2='83.04'
        y1='45.748'
        y2='54.521'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='82.597'
        x2='79.251'
        y1='47.434'
        y2='49.883'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='79.712'
        x2='71.98'
        y1='41.306'
        y2='54.667'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='59.714'
        x2='48.134'
        y1='71.74'
        y2='92.533'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='42.865'
        x2='49.74'
        y1='80.974'
        y2='82.846'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='43.514'
        x2='63.327'
        y1='70.144'
        y2='86.786'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='m'
        x1='183.93'
        x2='175.77'
        y1='58.816'
        y2='80.83'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='160.67'
        x2='169.4'
        y1='67.304'
        y2='70.876'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='161.57'
        x2='179.56'
        y1='57.35'
        y2='80.061'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='170'
        x2='153.5'
        y1='150.5'
        y2='182.5'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyOrderSearchSvg = () => (
  <svg
    width='220'
    height='220'
    fill='none'
    viewBox='0 0 220 220'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='.5' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m181.54 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.552c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.88 36.252c3.866 0 7-3.1341 7-7 0-3.866-3.134-7-7-7s-7 3.134-7 7c0 3.8659 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.885 186.25c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m191.88 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.513 30.801c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.012 30.8c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m28.639 68.348h149.82v93.501c0 1.198-0.195 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.7 0.848-1.532 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-134.72c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.636-2.959-0.3792-1.107-0.5744-2.294-0.5744-3.492v-93.501z'
      fill='url(#y)'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='#407BFF'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='url(#n)'
    />
    <path
      d='m28.639 68.347h106.02l-13.041-20.178c-1.434-2.2139-4.98-4.0046-7.931-4.0046h-95.346c-2.9395 0-4.1759 1.7907-2.7412 4.0046l13.041 20.178z'
      fill='url(#h)'
    />
    <path
      d='m88.571 61.76c0.2025 0.3929 0.4083 0.78 0.6174 1.1614l-0.44 0.2443-0.6222-1.1796 0.4448-0.2261z'
      fill='#2F3155'
    />
    <path
      d='m70.986 5.6151-0.4139 0.23901 0.2489 0.43122c0.7578-0.4603 1.5424-0.87491 2.3497-1.2416l-0.203-0.45778c-0.6532 0.31583-1.3319 0.65402-1.9817 1.0291zm4.5385-1.9916 0.1503 0.47283c0.8456-0.26239 1.7096-0.46139 2.5848-0.59536l-0.0771-0.49211c-0.8981 0.14261-1.7843 0.35191-2.6514 0.62614l-0.0066-0.0115zm5.3829-0.80793 3e-3 0.49655c0.8836 0.00431 1.7655 0.0797 2.637 0.22542l0.0868-0.48708c-0.9017-0.15641-1.815-0.23691-2.7301-0.24065l0.0033 0.00576zm5.3657 0.88853-0.1469 0.47581c0.8433 0.26922 1.6662 0.59856 2.4625 0.98547l0.217-0.44731c-0.8204-0.40305-1.6691-0.74577-2.5393-1.0255l0.0067 0.01149zm4.8873 2.3837-0.2847 0.40973c0.7275 0.50323 1.4103 1.0683 2.0407 1.6889l0.3476-0.35399c-0.65-0.64366-1.355-1.2294-2.1069-1.7504l0.0033 0.00576zm3.871 3.8367-0.4113 0.28349c0.1793 0.3105 0.4021 0.6035 0.578 0.9082 0.2447 0.4275 0.4657 0.868 0.6622 1.3196-0.4301 0.2884-0.8433 0.6012-1.2376 0.9368l0.3204 0.3824c0.629-0.5321 1.303-1.0085 2.0145-1.4238l0.1495-0.0863-0.249-0.4312-0.1552 0.0896-0.4312 0.249c-0.1943-0.4428-0.4128-0.8746-0.6547-1.2933-0.1735-0.3138-0.38-0.6315-0.5889-0.94024l0.0033 0.00575zm4.3558 0.81239 0.1446 0.4761c0.8405-0.2519 1.7085-0.4028 2.5845-0.4496l-0.027-0.4981c-0.917 0.0477-1.825 0.2041-2.7054 0.4658l0.0033 0.0058zm-6.6944 4.5779c-0.5887 0.6974-1.1209 1.4405-1.5918 2.2223l0.4286 0.2509c0.4558-0.7562 0.9717-1.4745 1.5427-2.148l-0.3795-0.3252zm3.9697-0.268c0.1629 0.8645 0.2287 1.7445 0.1962 2.6236l0.495 0.0208c0.0386-0.9167-0.0285-1.8349-0.2-2.7364l-0.4912 0.092zm8.1718-4.5952-0.087 0.487c0.868 0.156 1.718 0.3969 2.539 0.7192l0.177-0.4628c-0.852-0.3415-1.736-0.5964-2.639-0.7607l0.01 0.0173zm-14.919 9.5332-0.0543 0.1847c-0.2805 0.8286-0.3769 1.7084-0.2825 2.578l0.4954-0.0714c-0.086-0.7963 0.0038-1.6018 0.2629-2.3596l0.0552-0.1699-0.4767-0.1618zm19.998-7.6281-0.239 0.4367c0.788 0.4346 1.556 0.903 2.272 1.3865l0.282-0.4154c-0.729-0.4917-1.51-0.9683-2.315-1.4078zm-13.474 7.8939c-0.2316 0.812-0.5495 1.5969-0.9481 2.3413l-0.0531 0.1073 0.4367 0.2385 0.0588-0.1106c0.4074-0.7746 0.7304-1.5908 0.9633-2.4344l-0.4576-0.1421zm-5.0688 4.406-0.217 0.4473c0.4458 0.2038 0.9344 0.2965 1.4239 0.2702 0.4895-0.0262 0.9653-0.1707 1.3868-0.421l-0.249-0.4313c-0.3523 0.2062-0.7485 0.3259-1.1561 0.3494-0.4076 0.0234-0.8149-0.0501-1.1886-0.2146zm23.024-9.2523-0.317 0.3818c0.683 0.5679 1.336 1.1711 1.956 1.8071l0.354-0.3425c-0.625-0.6553-1.289-1.2729-1.988-1.8497l-5e-3 0.0033zm3.782 3.8956-0.398 0.3064c0.543 0.7034 1.046 1.4369 1.506 2.197l0.431-0.249c-0.471-0.7794-0.985-1.5321-1.539-2.2544zm2.355 4.8497c0.377 0.8117 0.711 1.6426 1 2.4891l0.476-0.1594c-0.295-0.8568-0.632-1.6983-1.011-2.5212l-0.465 0.1915zm1.718 5.0338c0.2 0.8506 0.363 1.7302 0.482 2.6272l0.496-0.0713c-0.123-0.9029-0.279-1.8097-0.491-2.6684l-0.487 0.1125zm0.748 5.2793c0.044 0.8719 0.05 1.7728 0.016 2.6821l0.497 0.0118c0.026-0.9117 0.018-1.8274-0.032-2.7108l-0.481 0.0169zm-0.143 5.3419c-0.084 0.8765-0.206 1.7673-0.355 2.6507l0.492 0.0835c0.152-0.8926 0.273-1.7981 0.36-2.6838l-0.497-0.0504zm-0.879 5.2759c-0.191 0.877-0.434 1.7304-0.693 2.5847l0.476 0.1469c0.263-0.8724 0.516-1.7621 0.697-2.6177l-0.48-0.1139zm-1.539 5.1281c-0.293 0.8207-0.641 1.6655-0.991 2.4807l0.453 0.1989c0.361-0.8218 0.7-1.6691 1.003-2.5112l-0.465-0.1684z'
      fill='#3B424F'
    />
    <path
      d='m68.283 7.4535c-0.359 0.27137-0.703 0.56211-1.0304 0.87091l0.3458 0.35998s0.3542-0.3425 0.9877-0.83859l-0.3031-0.3923z'
      fill='#3B424F'
    />
    <path
      d='m62.976 11.66c-1.5981-2.1438 2.3558-6.1439 4.4518-3.3368 2.0959 2.807-2.8438 5.498-4.4518 3.3368z'
      fill='#3B424F'
    />
    <path
      d='m66.931 4.3004c-0.9383-0.61591-2.5546 0.15631-3.509 2.1946-0.6071 1.4554-0.9305 3.0134-0.953 4.5903 1.433-0.6395 2.7304-1.5473 3.8223-2.6744 1.5232-1.7304 1.6075-3.4963 0.6397-4.1104z'
      fill='#99A2DA'
    />
    <path
      d='m66.931 4.3004c-0.9383-0.61591-2.5546 0.15631-3.509 2.1946-0.6071 1.4554-0.9305 3.0134-0.953 4.5903 1.433-0.6395 2.7304-1.5473 3.8223-2.6744 1.5232-1.7304 1.6075-3.4963 0.6397-4.1104z'
      fill='url(#g)'
      fillOpacity='0.2'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='#99A2DA'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='#99A2DA'
    />
    <path
      d='m71.165 9.8829c0.3235 1.0782-0.8762 2.3995-3.099 2.7322-1.5712 0.1651-3.1595 0.0283-4.6792-0.4033 1.034-1.1937 2.2876-2.1777 3.6928-2.8987 2.0306-0.9577 3.751-0.54044 4.0854 0.56979z'
      fill='url(#f)'
      fillOpacity='0.2'
    />
    <path
      d='m62.976 11.659c0.1536-0.1143 0.27-0.2715 0.3344-0.4518s0.0739-0.3757 0.0274-0.5614c-0.0465-0.1858-0.1469-0.3536-0.2887-0.4823-0.1417-0.1287-0.3184-0.21252-0.5078-0.24092-0.1893-0.0284-0.3828-8e-5 -0.5561 0.08142-0.1733 0.0814-0.3186 0.2123-0.4175 0.3763-0.099 0.1639-0.1471 0.3534-0.1385 0.5447 0.0087 0.1913 0.0738 0.3757 0.1871 0.53 0.1539 0.2065 0.3832 0.3439 0.6379 0.3821s0.5141-0.0259 0.7218-0.1781z'
      fill='#3B424F'
    />
    <path
      d='m64.138 13.219c0.1024-0.0763 0.1889-0.172 0.2543-0.2817 0.0655-0.1096 0.1087-0.2311 0.1272-0.3575 0.0186-0.1264 0.012-0.2551-0.0192-0.379-0.0313-0.1238-0.0866-0.2403-0.1629-0.3427-0.0763-0.1025-0.172-0.1889-0.2816-0.2544-0.1097-0.0654-0.2312-0.1087-0.3576-0.1272-0.1263-0.0185-0.2551-0.0119-0.3789 0.0193-0.1239 0.0313-0.2403 0.0866-0.3428 0.1629-0.2069 0.154-0.3441 0.3839-0.3815 0.6391s0.0281 0.5149 0.1821 0.7218 0.3839 0.3441 0.6392 0.3815c0.2552 0.0374 0.5148-0.0281 0.7217-0.1821z'
      fill='#3B424F'
    />
    <path
      d='m178.46 68.347h-106.01l13.041-13.156c1.4348-1.41 4.9807-2.6086 7.9318-2.6086h95.333c2.951 0 4.176 1.1704 2.742 2.6086l-13.041 13.156z'
      fill='url(#e)'
    />
    <path
      d='m178.46 68.347h-106.01l13.041-13.156c1.4348-1.41 4.9807-2.6086 7.9318-2.6086h95.333c2.951 0 4.176 1.1704 2.742 2.6086l-13.041 13.156z'
      fill='url(#d)'
    />
    <path
      d='m72.451 68.348h106.01v93.501c0 1.198-0.196 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.701 0.848-1.533 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.6359-2.959-0.3793-1.107-0.5745-2.294-0.5745-3.492v-93.501z'
      fill='url(#c)'
    />
    <path
      d='m72.451 68.348h106.01v93.501c0 1.198-0.196 2.385-0.575 3.492-0.379 1.106-0.935 2.112-1.636 2.959-0.701 0.848-1.533 1.52-2.448 1.978-0.916 0.459-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.235-2.8881-0.694-0.9156-0.458-1.7476-1.13-2.4484-1.978-0.7008-0.847-1.2567-1.853-1.6359-2.959-0.3793-1.107-0.5745-2.294-0.5745-3.492v-93.501z'
      fill='#413BBC'
      fillOpacity='0.4'
    />
    <path
      d='m178.57 116.14-0.109 45.705c0 1.198-0.196 2.385-0.575 3.491-0.379 1.107-0.935 2.113-1.636 2.96s-1.533 1.519-2.448 1.978c-0.916 0.458-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.236-2.8881-0.694-0.9156-0.459-1.7476-1.131-2.4484-1.978s-1.2567-1.853-1.6359-2.96c-0.3793-1.106-0.5745-2.293-0.5745-3.491v-45.705l3.0418 5.476c23.229 41.817 84.407 38.566 103.07-5.476z'
      fill='url(#b)'
    />
    <path
      d='m178.57 116.14-0.109 45.705c0 1.198-0.196 2.385-0.575 3.491-0.379 1.107-0.935 2.113-1.636 2.96s-1.533 1.519-2.448 1.978c-0.916 0.458-1.897 0.694-2.888 0.694h-90.913c-0.9911 0-1.9725-0.236-2.8881-0.694-0.9156-0.459-1.7476-1.131-2.4484-1.978s-1.2567-1.853-1.6359-2.96c-0.3793-1.106-0.5745-2.293-0.5745-3.491v-45.705l3.0418 5.476c23.229 41.817 84.407 38.566 103.07-5.476z'
      fill='url(#a)'
    />
    <g filter='url(#aa)'>
      <path
        d='m41.557 68.17 1.584 16.83 2.1685 3.2564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967v-21.245h-17.926z'
        fill='#E2E3F5'
      />
    </g>
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#x)'
    />
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#w)'
    />
    <path
      d='m80.876 43.631 3.2985 5.6832-0.421 2.5076-1.2133 1.3223-1.6269-0.2672-1.0176 1.337-2.1039 0.1571-1.8118 1.427-5.3012-12.167h10.197z'
      fill='url(#v)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#u)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#t)'
    />
    <path
      d='m41.557 68.17 1.084 18.33 2.6685 1.7564 2.641 1.1585 2.2945-1.2893 2.3543 1.2893 3.2744-0.967 3.609 0.967-15.105-5.5816-2.821-15.664z'
      fill='url(#s)'
    />
    <g filter='url(#z)'>
      <path
        d='m160.76 54.943-1.141-2.4434h11.517c-0.889 2.5919 4.814 8.1016 8.252 11.195 3.437 3.0938 6.187 6.875 2.406 9.9688-3.781 3.0937-7.566 0.3437-9.281-1.375-1.716-1.7188-3.603-3.6919-5.04-5.1322-3.093-3.0938-6.854-1.0313-8.339-4.8297-0.811-2.0728 0.354-4.2247 1.097-5.3522 0.396-0.5998 0.582-1.3144 0.529-2.0316z'
        fill='#fff'
      />
    </g>
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#r)'
    />
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#q)'
    />
    <path
      d='m160.75 55.535c-0.055 0.5142-0.231 1.008-0.515 1.4403-0.743 1.1275-1.908 3.2793-1.097 5.3522 1.265 3.2415 4.214 2.2171 6.964 3.7675 1.217-5.005-1.031-9.161-5.352-10.56zm14.17 18.6c1.897 1.0656 4.386 1.564 6.875-0.471 2.303-1.8872 2.176-4.0287 0.952-6.1153-3.672 0.2956-6.624 3.0663-7.827 6.5863z'
      fill='url(#p)'
    />
    <path
      d='m124.2 188.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.448 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='#8E76D7'
    />
    <path
      d='m124.2 188.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.448 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#o)'
    />
    <path
      d='m124.2 188.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.448 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#m)'
      fillOpacity='0.8'
    />
    <path
      d='m124.2 188.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.448 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      stroke='#F0EDFA'
      strokeWidth='5'
    />
    <path
      d='m155 187.5c17.121 0 31-13.879 31-31s-13.879-31-31-31-31 13.879-31 31 13.879 31 31 31z'
      fill='url(#l)'
    />
    <path
      d='m151.11 141.6c-0.059-0.588 0.427-1.096 1.049-1.096h5.681c0.622 0 1.108 0.508 1.049 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.049 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#k)'
    />
    <path
      d='m151.11 141.6c-0.059-0.588 0.427-1.096 1.049-1.096h5.681c0.622 0 1.108 0.508 1.049 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.049 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#j)'
    />
    <ellipse cx='155' cy='168.77' rx='4' ry='3.795' fill='url(#i)' />
    <defs>
      <filter
        id='aa'
        x='25.557'
        y='65.17'
        width='35.926'
        height='39.246'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-7' dy='6' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4297_171305'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_4297_171305'
          result='shape'
        />
      </filter>
      <filter
        id='z'
        x='145.86'
        y='41.5'
        width='42.757'
        height='41.564'
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx='-4' dy='-2' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0.25 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_4297_171305'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.183333 0 0 0 0 0.180278 0 0 0 0 0.180278 0 0 0 0.25 0' />
        <feBlend
          in2='effect1_dropShadow_4297_171305'
          result='effect2_dropShadow_4297_171305'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect2_dropShadow_4297_171305'
          result='shape'
        />
      </filter>
      <linearGradient
        id='y'
        x1='47'
        x2='151.5'
        y1='152.5'
        y2='105.5'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='134.16'
        x2='133.16'
        y1='43.464'
        y2='73.925'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='141.57'
        x2='104.14'
        y1='55.884'
        y2='-5.5772'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='65.352'
        x2='68.543'
        y1='9.3636'
        y2='5.764'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopOpacity='0' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='68'
        x2='71'
        y1='13.001'
        y2='9.0007'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopOpacity='0' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='191.6'
        x2='191.18'
        y1='52.126'
        y2='71.995'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='199.02'
        x2='180.18'
        y1='60.222'
        y2='12.774'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='c'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(172 74.5) rotate(134.19) scale(149.92 154.84)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.7' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='b'
        x1='178.12'
        x2='156.24'
        y1='113.01'
        y2='246.04'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.0047052' stopColor='white' />
        <stop offset='.24479' stopColor='#A9A6E2' />
        <stop offset='1' stopColor='#413BBC' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='184.7'
        x2='73.73'
        y1='168.66'
        y2='132.6'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='x'
        x1='71.391'
        x2='83.04'
        y1='45.748'
        y2='54.521'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='82.597'
        x2='79.251'
        y1='47.434'
        y2='49.883'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='79.712'
        x2='71.98'
        y1='41.306'
        y2='54.667'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='59.714'
        x2='48.134'
        y1='71.74'
        y2='92.533'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='42.865'
        x2='49.74'
        y1='80.974'
        y2='82.846'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='43.514'
        x2='63.327'
        y1='70.144'
        y2='86.786'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='183.93'
        x2='175.77'
        y1='58.816'
        y2='80.83'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='160.67'
        x2='169.4'
        y1='67.304'
        y2='70.876'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='161.57'
        x2='179.56'
        y1='57.35'
        y2='80.061'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='o'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(208.1 120.51) rotate(133.56) scale(144.86 149.48)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='m'
        x1='129.53'
        x2='150.81'
        y1='137.3'
        y2='218.08'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='155'
        x2='129.42'
        y1='125.5'
        y2='175.1'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='159.28'
        x2='157.58'
        y1='133.93'
        y2='133.86'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='166.65'
        x2='153.07'
        y1='138.43'
        y2='156.49'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='i'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(160.86 164.93) rotate(148.61) scale(8.6386 8.4494)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='white' />
      </radialGradient>
    </defs>
  </svg>
);
export const EmptyNotificationSvg = () => (
  <svg
    width='200'
    height='201'
    fill='none'
    viewBox='0 0 200 201'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='.5' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m181.54 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.554c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.88 36.254c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.885 186.25c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m192.88 161.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.513 30.801c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.012 30.8c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m110.48 137.5h-19.96c-4.625 0-8.5197 4.211-8.5197 9.211v10.789c0 11.053 8.2763 20 18.5 20 10.224 0 18.5-8.947 18.5-20v-10.789c0-5.264-3.895-9.211-8.52-9.211z'
      fill='url(#i)'
    />
    <path
      d='m110.48 137.5h-19.96c-4.625 0-8.5197 4.211-8.5197 9.211v10.789c0 11.053 8.2763 20 18.5 20 10.224 0 18.5-8.947 18.5-20v-10.789c0-5.264-3.895-9.211-8.52-9.211z'
      fill='url(#h)'
    />
    <path
      d='m110.48 137.5h-19.96c-4.625 0-8.5197 4.211-8.5197 9.211v10.789c0 11.053 8.2763 20 18.5 20 10.224 0 18.5-8.947 18.5-20v-10.789c0-5.264-3.895-9.211-8.52-9.211z'
      fill='url(#g)'
      fillOpacity='0.2'
    />
    <path
      d='m110.54 45.872h-19.378v-9.6861c0-5.4337 4.2537-9.6861 9.6889-9.6861 5.435 0 9.689 4.2524 9.689 9.6861v9.6861z'
      fill='url(#f)'
    />
    <path
      d='m110.54 45.872h-19.378v-9.6861c0-5.4337 4.2537-9.6861 9.6889-9.6861 5.435 0 9.689 4.2524 9.689 9.6861v9.6861z'
      fill='url(#e)'
    />
    <path
      d='m141.28 83.951v-5.4335c0-23.624-17.142-42.759-40.773-42.759s-40.772 19.135-40.772 42.759v5.4335c0 25.536-11.406 46.158-21.506 59.414-4.5589 5.983-0.3097 16.418 7.2122 16.418h110.01c7.51 0 11.76-10.397 7.226-16.382-10.043-13.255-21.395-33.892-21.395-59.45z'
      fill='#413BBC'
    />
    <path
      d='m141.28 83.951v-5.4335c0-23.624-17.142-42.759-40.773-42.759s-40.772 19.135-40.772 42.759v5.4335c0 25.536-11.406 46.158-21.506 59.414-4.5589 5.983-0.3097 16.418 7.2122 16.418h110.01c7.51 0 11.76-10.397 7.226-16.382-10.043-13.255-21.395-33.892-21.395-59.45z'
      fill='url(#d)'
    />
    <path
      d='m165.71 30.009c0 1.9378 1.571 3.5087 3.509 3.5087h8.276l-11.371 13.286c-0.724 0.8449-1.121 1.9204-1.121 3.0326 0 2.5757 2.088 4.6637 4.664 4.6637h14.795c1.938 0 3.509-1.5709 3.509-3.5088 0-1.9378-1.571-3.5087-3.509-3.5087h-9.219l11.372-13.286c0.723-0.8449 1.12-1.9204 1.12-3.0326 0-2.5757-2.088-4.6637-4.664-4.6637h-13.852c-1.938 0-3.509 1.5709-3.509 3.5088z'
      fill='url(#c)'
      stroke='#fff'
      strokeWidth='2'
    />
    <path
      d='m146.55 59.418c0 1.6115 1.306 2.9178 2.918 2.9178h5.611l-8.204 9.9086c-0.567 0.6851-0.877 1.5466-0.877 2.436 0 2.1096 1.71 3.8198 3.82 3.8198h11.262c1.612 0 2.918-1.3063 2.918-2.9178s-1.306-2.9178-2.918-2.9178h-6.439l8.204-9.9086c0.567-0.6851 0.877-1.5466 0.877-2.436 0-2.1096-1.71-3.8198-3.82-3.8198h-10.434c-1.612 0-2.918 1.3063-2.918 2.9178z'
      fill='url(#b)'
      stroke='#fff'
      strokeWidth='2'
    />
    <path
      d='m126.37 86.568c-0.847 0-1.534-0.6869-1.534-1.5343 0-0.8473 0.687-1.5342 1.534-1.5342h8.545c1.242 0 2.248 1.0068 2.248 2.2487 0 0.5295-0.186 1.042-0.527 1.4472l-7.766 9.2356h6.983c0.848 0 1.535 0.6869 1.535 1.5343 0 0.8473-0.687 1.5342-1.535 1.5342h-9.217c-1.242 0-2.248-1.0068-2.248-2.2487 0-0.5295 0.186-1.042 0.527-1.4472l7.766-9.2356h-6.311z'
      fill='url(#a)'
    />
    <defs>
      <linearGradient
        id='i'
        x1='141.34'
        x2='104.6'
        y1='123.94'
        y2='188.88'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='72.575'
        x2='100.38'
        y1='163.19'
        y2='172.83'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='g'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(101 166) rotate(68.199) scale(21.541 19.925)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='.78632' stopColor='#413BBC' />
      </radialGradient>
      <linearGradient
        id='f'
        x1='110.99'
        x2='100.52'
        y1='14.7'
        y2='16.663'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='101.7'
        x2='100.46'
        y1='22.878'
        y2='42.657'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='d'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(36 154) rotate(-47.61) scale(132.01 75.732)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#413BBC' />
      </radialGradient>
      <linearGradient
        id='c'
        x1='176.48'
        x2='176.48'
        y1='30.048'
        y2='52.983'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='155'
        x2='155'
        y1='59.46'
        y2='77.102'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='130.89'
        x2='130.89'
        y1='85.068'
        y2='99.182'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyProductTypeSvg = () => (
  <svg
    width='201'
    height='201'
    fill='none'
    viewBox='0 0 200 201'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='.5' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m181.54 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.553c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.89 36.253c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.887 186.25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m191.89 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.514 30.801c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505c-2.8446 0-5.1505 2.306-5.1505 5.1505s2.3059 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.013 30.8c1.4635 0 2.65-1.1864 2.65-2.65s-1.1865-2.65-2.65-2.65c-1.4636 0-2.65 1.1864-2.65 2.65s1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m161.4 174.5h-122.79c-7.1091 0-12.603-4.952-12.603-10.729v-126.54c0-6.052 5.8166-10.729 12.603-10.729h122.79c7.11 0 12.603 4.9517 12.603 10.729v126.54c0 5.777-5.817 10.729-12.603 10.729z'
      fill='#fff'
    />
    <path
      d='m155.48 119.24c-0.375-0.757 0.375-3.132 0-3.89-1.5-2.274-3.943-2.754-7.693-3.891-5.25-1.515-8.544-3.797-12.669-4.176-1.124 0-2.249-0.379-2.999-0.379-11.625-1.137-21.375-3.032-42.749-29.555-2.2499-2.6523-3.3749-5.3047-5.6248-7.9571-2.2499-2.2734-5.9997 0.379-10.874 1.5157-1.125 0.3789-1.875 0.3789-2.9999 0.3789-3.7499 0-8.2497-0.3789-12.374-0.7578-5.6248-0.7578-2.2499-3.7891-8.9997 39.786-0.3749 3.41-0.7499 6.441-1.1249 9.852-0.375 2.652-0.375 5.683-0.375 8.336 0 1.136 0.375 3.031 1.4999 3.031 17.999 1.894 29.624 1.137 58.123 0.758 14.249 0 28.498 0 42.748-2.653l3.375-0.379c3-0.379 6-1.515 6-3.41 0-2.652-2.513-3.956-3.263-6.609z'
      fill='#8E76D7'
    />
    <path
      d='m135.12 107.66-3.375 9.851c-18.375-0.758-37.124-12.504-46.873-27.66-3.3749-5.3048-5.9998-10.988-9.7497-15.535 0 0-1.1249-1.5157-2.6249-2.6524 4.8748-1.1367 8.6247-3.7891 10.875-1.5156 1.8749 1.8945 2.6249 3.4101 4.1248 5.3047 0.375 0.7578 0.75 1.1367 1.125 1.8945 0 0.379 0.375 0.379 0.375 0.7579 1.1249 1.5156 2.6249 3.0312 3.7498 4.5469 0.375 0.3789 0.75 0.7578 1.125 1.5156 1.4999 1.5157 2.6249 3.0313 4.1248 4.5469 0.375 0.3789 0.75 0.7579 1.125 1.5157 1.5 1.5156 2.625 3.0312 4.125 4.168 0.375 0.3789 1.125 0.7578 1.5 1.5156 1.5 1.1367 2.625 2.2735 3.75 3.4102 0.75 0.3789 1.125 0.7575 1.875 1.5155 1.124 0.758 1.874 1.516 2.999 1.895 0.75 0.379 1.5 0.758 1.875 1.136 1.875 1.137 3.75 1.895 5.625 2.653 0.75 0.379 1.5 0.379 2.25 0.758 3 0.757 5.625 1.136 8.625 1.515 1.125-1.515 2.25-1.515 3.375-1.136z'
      fill='#413BBC'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='#8E76D7'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='url(#v)'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='url(#k)'
      fillOpacity='.8'
    />
    <path
      d='m157.62 117.9c-6.75 2.273-13.499 3.789-20.624 4.168-1.125 0-2.25 0-3-0.379-1.125-0.379-1.125-1.137-1.5-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.875 0.379 10.125 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#h)'
    />
    <path
      d='m157.62 117.9c-6.75 2.273-13.499 3.789-20.624 4.168-1.125 0-2.25 0-3-0.379-1.125-0.379-1.125-1.137-1.5-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.875 0.379 10.125 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#g)'
    />
    <path
      d='m88.625 76.972v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0.375-1.5156l4.8748-3.7891h0.375c0 0.3789 0.375 1.1367 0.75 1.5156z'
      fill='url(#f)'
    />
    <path
      d='m88.625 76.972v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0.375-1.5156l4.8748-3.7891h0.375c0 0.3789 0.375 1.1367 0.75 1.5156z'
      fill='url(#e)'
    />
    <path
      d='m94.248 83.411c0 0.3789 0 0.3789-0.375 0.7579-1.4999 1.5156-2.9999 3.0312-4.8748 4.5469-0.375 0-0.375 0.3789-0.75 0.3789-0.3749 0-0.7499 0-0.7499-0.3789-0.375-0.3789-0.375-1.1368 0.3749-1.5157 1.5-1.1367 2.9999-2.6523 4.4999-4.168 0.375-0.3789 0.375-0.3789 0.7499-0.3789 0 0 0.75 0.3789 1.125 0.7578z'
      fill='url(#d)'
    />
    <path
      d='m94.248 83.411c0 0.3789 0 0.3789-0.375 0.7579-1.4999 1.5156-2.9999 3.0312-4.8748 4.5469-0.375 0-0.375 0.3789-0.75 0.3789-0.3749 0-0.7499 0-0.7499-0.3789-0.375-0.3789-0.375-1.1368 0.3749-1.5157 1.5-1.1367 2.9999-2.6523 4.4999-4.168 0.375-0.3789 0.375-0.3789 0.7499-0.3789 0 0 0.75 0.3789 1.125 0.7578z'
      fill='url(#c)'
    />
    <path
      d='m99.123 89.475c0 0.3789 0 0.3789-0.375 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9259-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.3749-0.3789-0.3749-1.1368 0-1.5157 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.125 1.1367z'
      fill='url(#b)'
    />
    <path
      d='m99.123 89.475c0 0.3789 0 0.3789-0.375 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9259-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.3749-0.3789-0.3749-1.1368 0-1.5157 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.125 1.1367z'
      fill='url(#a)'
    />
    <path
      d='m104.74 94.78c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.7499-0.379c-0.375-0.379-0.75-1.1369-0.375-1.5158 1.4999-1.8945 3.3748-3.7891 5.2498-5.6836 0 0 0.375 0 0.375-0.379 0.75 0.7579 1.125 1.1368 1.5 1.5157z'
      fill='url(#u)'
    />
    <path
      d='m104.74 94.78c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.7499-0.379c-0.375-0.379-0.75-1.1369-0.375-1.5158 1.4999-1.8945 3.3748-3.7891 5.2498-5.6836 0 0 0.375 0 0.375-0.379 0.75 0.7579 1.125 1.1368 1.5 1.5157z'
      fill='url(#t)'
    />
    <path
      d='m110.37 99.328v0c-1.125 2.2739-2.25 4.5469-3.75 6.8209-0.375 0.378-0.75 0.757-1.125 0.757h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.75 0 1.125 0.3789 1.875 0.7578z'
      fill='url(#s)'
    />
    <path
      d='m110.37 99.328v0c-1.125 2.2739-2.25 4.5469-3.75 6.8209-0.375 0.378-0.75 0.757-1.125 0.757h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.75 0 1.125 0.3789 1.875 0.7578z'
      fill='url(#r)'
    />
    <path
      d='m115.25 102.74-1.125 6.821c0 0.758-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#q)'
    />
    <path
      d='m115.25 102.74-1.125 6.821c0 0.758-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#p)'
    />
    <path
      d='m123.12 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#o)'
    />
    <path
      d='m123.12 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#n)'
    />
    <path
      d='m67.25 99.706c5.1775 0 9.3746-4.2411 9.3746-9.4727 0-5.2317-4.1971-9.4728-9.3746-9.4728-5.1774 0-9.3746 4.2411-9.3746 9.4728 0 5.2316 4.1972 9.4727 9.3746 9.4727z'
      fill='url(#m)'
    />
    <path
      d='m67.248 94.022c2.071 0 3.7498-1.6965 3.7498-3.7891 0-2.0927-1.6788-3.7891-3.7498-3.7891s-3.7499 1.6964-3.7499 3.7891c0 2.0926 1.6789 3.7891 3.7499 3.7891z'
      fill='url(#l)'
    />
    <path
      d='m67.248 94.022c2.071 0 3.7498-1.6965 3.7498-3.7891 0-2.0927-1.6788-3.7891-3.7498-3.7891s-3.7499 1.6964-3.7499 3.7891c0 2.0926 1.6789 3.7891 3.7499 3.7891z'
      fill='url(#j)'
    />
    <circle cx='172' cy='30.5' r='20' fill='url(#i)' />
    <path
      d='m169.15 19.073h5.626l-1.5 15.626h-2.625l-1.501-15.626z'
      fill='#fff'
    />
    <ellipse cx='171.96' cy='39.699' rx='2.8127' ry='2.5002' fill='#fff' />
    <defs>
      <radialGradient
        id='v'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(151.94 117.01) rotate(170.89) scale(111.56 36.038)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='k'
        x1='65.24'
        x2='65.823'
        y1='119.84'
        y2='134.35'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='158.22'
        x2='145.1'
        y1='97.674'
        y2='101.88'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='145.82'
        x2='145.25'
        y1='104.07'
        y2='119.59'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='92.623'
        x2='88.07'
        y1='73.53'
        y2='83.664'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='80.317'
        x2='85'
        y1='79.106'
        y2='81.15'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='98.472'
        x2='93.074'
        y1='80.47'
        y2='91.673'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='85.47'
        x2='90.523'
        y1='86.79'
        y2='88.846'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='103.37'
        x2='96.945'
        y1='85.898'
        y2='97.884'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='90.301'
        x2='95.521'
        y1='92.961'
        y2='94.872'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='109.14'
        x2='101.79'
        y1='90.568'
        y2='103.42'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='95.61'
        x2='101.1'
        y1='98.375'
        y2='100.26'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='113.86'
        x2='105.27'
        y1='95.745'
        y2='107.13'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='103.12'
        x2='107.68'
        y1='103.92'
        y2='105.11'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='117.28'
        x2='107.84'
        y1='98.011'
        y2='104.44'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='111.01'
        x2='113.8'
        y1='107.3'
        y2='107.68'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='125.25'
        x2='116.84'
        y1='101.94'
        y2='109.05'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='118.7'
        x2='121.59'
        y1='109.74'
        y2='110.22'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='m'
        x1='67.25'
        x2='67.25'
        y1='82.618'
        y2='99.33'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='71.094'
        x2='67.33'
        y1='87.717'
        y2='95.646'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.37711' stopColor='#413BBC' />
        <stop offset='.69909' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='64.046'
        x2='66.849'
        y1='91.01'
        y2='91.906'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='i'
        x1='172'
        x2='155.5'
        y1='10.5'
        y2='42.5'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
    </defs>
  </svg>
);
export const EmptyProductTypeSearchSvg = () => (
  <svg
    width='201'
    height='201'
    fill='none'
    viewBox='0 0 220 217'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='.50098' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m161.4 174.5h-122.79c-7.1091 0-12.603-4.952-12.603-10.729v-126.54c0-6.052 5.8166-10.729 12.603-10.729h122.79c7.11 0 12.603 4.9516 12.603 10.729v126.54c0 5.777-5.817 10.729-12.603 10.729z'
      fill='#fff'
    />
    <path
      d='m155.48 119.24c-0.375-0.757 0.375-3.132 0-3.89-1.5-2.274-3.943-2.754-7.693-3.891-5.25-1.515-8.544-3.798-12.669-4.176-1.124 0-2.249-0.379-2.999-0.379-11.625-1.137-21.375-3.032-42.749-29.555-2.2499-2.6523-3.3749-5.3047-5.6248-7.9571-2.2499-2.2734-5.9997 0.3789-10.874 1.5157-1.125 0.3789-1.875 0.3789-2.9999 0.3789-3.7499 0-8.2497-0.3789-12.374-0.7578-5.6248-0.7579-2.2499-3.7891-8.9997 39.786-0.3749 3.41-0.7499 6.441-1.1249 9.851-0.375 2.653-0.375 5.684-0.375 8.337 0 1.136 0.375 3.031 1.4999 3.031 17.999 1.894 29.624 1.137 58.123 0.758 14.249 0 28.498 0 42.748-2.653l3.375-0.379c3-0.379 6-1.515 6-3.41 0-2.652-2.513-3.956-3.263-6.609z'
      fill='#8E76D7'
    />
    <path
      d='m135.12 107.66-3.375 9.852c-18.375-0.758-37.124-12.504-46.873-27.66-3.3749-5.3047-5.9998-10.988-9.7497-15.535 0 0-1.1249-1.5156-2.6249-2.6523 4.8748-1.1368 8.6247-3.7891 10.875-1.5157 1.8749 1.8946 2.6249 3.4102 4.1248 5.3048 0.375 0.7578 0.75 1.1367 1.125 1.8945 0 0.3789 0.375 0.3789 0.375 0.7578 1.1249 1.5157 2.6249 3.0313 3.7498 4.547 0.375 0.3789 0.75 0.7578 1.125 1.5156 1.4999 1.5156 2.6249 3.0313 4.1248 4.5469 0.375 0.3789 0.75 0.7578 1.125 1.5157 1.5 1.5156 2.625 3.0312 4.125 4.1679 0.375 0.379 1.125 0.7579 1.5 1.5157 1.5 1.1367 2.625 2.2735 3.75 3.4102 0.75 0.3789 1.125 0.7575 1.875 1.5155 1.124 0.758 1.874 1.516 2.999 1.895 0.75 0.379 1.5 0.757 1.875 1.136 1.875 1.137 3.75 1.895 5.625 2.653 0.75 0.379 1.5 0.379 2.25 0.758 3 0.757 5.625 1.136 8.625 1.515 1.125-1.515 2.25-1.515 3.375-1.137z'
      fill='#413BBC'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='#8E76D7'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='url(#aa)'
    />
    <path
      d='m158.75 126.23c0 1.894-3.375 3.031-6 3.41l-3.375 0.379c-13.875 2.652-28.499 2.652-42.748 2.652-28.499 0-39.749 0.758-58.123-0.758-1.4999 0-1.4999-1.894-1.4999-3.031 0-3.031 0-5.684 0.375-8.336 10.125 0.758 52.873 3.031 85.497-0.379 8.999-1.137 17.249-2.273 23.624-4.168 0.375 0.758 0.75 1.516 1.125 2.273 0.75 2.274 1.125 4.926 1.125 7.958z'
      fill='url(#p)'
      fillOpacity='.8'
    />
    <path
      d='m157.62 117.9c-6.75 2.273-13.499 3.789-20.624 4.168-1.125 0-2.25 0-3-0.379-1.125-0.379-1.125-1.137-1.5-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.875 0.379 10.125 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#h)'
    />
    <path
      d='m157.62 117.9c-6.75 2.273-13.499 3.789-20.624 4.168-1.125 0-2.25 0-3-0.379-1.125-0.379-1.125-1.137-1.5-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.875 0.379 10.125 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#g)'
    />
    <path
      d='m88.625 76.973v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0.375-1.5157l4.8748-3.7891h0.375c0 0.3789 0.375 1.1368 0.75 1.5157z'
      fill='url(#f)'
    />
    <path
      d='m88.625 76.973v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0.375-1.5157l4.8748-3.7891h0.375c0 0.3789 0.375 1.1368 0.75 1.5157z'
      fill='url(#e)'
    />
    <path
      d='m94.248 83.412c0 0.3789 0 0.3789-0.375 0.7578-1.4999 1.5157-2.9999 3.0313-4.8748 4.5469-0.375 0-0.375 0.379-0.75 0.379-0.3749 0-0.7499 0-0.7499-0.379-0.375-0.3789-0.375-1.1367 0.3749-1.5156 1.5-1.1367 2.9999-2.6524 4.4999-4.168 0.375-0.3789 0.375-0.3789 0.7499-0.3789 0 0 0.75 0.3789 1.125 0.7578z'
      fill='url(#d)'
    />
    <path
      d='m94.248 83.412c0 0.3789 0 0.3789-0.375 0.7578-1.4999 1.5157-2.9999 3.0313-4.8748 4.5469-0.375 0-0.375 0.379-0.75 0.379-0.3749 0-0.7499 0-0.7499-0.379-0.375-0.3789-0.375-1.1367 0.3749-1.5156 1.5-1.1367 2.9999-2.6524 4.4999-4.168 0.375-0.3789 0.375-0.3789 0.7499-0.3789 0 0 0.75 0.3789 1.125 0.7578z'
      fill='url(#c)'
    />
    <path
      d='m99.123 89.476c0 0.3789 0 0.3789-0.375 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9258-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.3749-0.3789-0.3749-1.1367 0-1.5156 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.125 1.1367z'
      fill='url(#b)'
    />
    <path
      d='m99.123 89.476c0 0.3789 0 0.3789-0.375 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9258-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.3749-0.3789-0.3749-1.1367 0-1.5156 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.125 1.1367z'
      fill='url(#a)'
    />
    <path
      d='m104.74 94.781c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.7499-0.379c-0.375-0.379-0.75-1.1369-0.375-1.5158 1.4999-1.8946 3.3748-3.7891 5.2498-5.6837 0 0 0.375 0 0.375-0.3789 0.75 0.7578 1.125 1.1368 1.5 1.5157z'
      fill='url(#z)'
    />
    <path
      d='m104.74 94.781c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.7499-0.379c-0.375-0.379-0.75-1.1369-0.375-1.5158 1.4999-1.8946 3.3748-3.7891 5.2498-5.6837 0 0 0.375 0 0.375-0.3789 0.75 0.7578 1.125 1.1368 1.5 1.5157z'
      fill='url(#y)'
    />
    <path
      d='m110.37 99.329v0c-1.125 2.2739-2.25 4.5469-3.75 6.8199-0.375 0.379-0.75 0.758-1.125 0.758h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.75 0 1.125 0.3789 1.875 0.7578z'
      fill='url(#x)'
    />
    <path
      d='m110.37 99.329v0c-1.125 2.2739-2.25 4.5469-3.75 6.8199-0.375 0.379-0.75 0.758-1.125 0.758h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.75 0 1.125 0.3789 1.875 0.7578z'
      fill='url(#w)'
    />
    <path
      d='m115.25 102.74-1.125 6.821c0 0.757-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#v)'
    />
    <path
      d='m115.25 102.74-1.125 6.821c0 0.757-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#u)'
    />
    <path
      d='m123.12 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#t)'
    />
    <path
      d='m123.12 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#s)'
    />
    <path
      d='m67.25 99.707c5.1775 0 9.3746-4.2411 9.3746-9.4727 0-5.2317-4.1971-9.4728-9.3746-9.4728-5.1774 0-9.3746 4.2411-9.3746 9.4728 0 5.2316 4.1972 9.4727 9.3746 9.4727z'
      fill='url(#r)'
    />
    <path
      d='m67.248 94.022c2.071 0 3.7498-1.6964 3.7498-3.7891 0-2.0926-1.6788-3.7891-3.7498-3.7891s-3.7499 1.6965-3.7499 3.7891c0 2.0927 1.6789 3.7891 3.7499 3.7891z'
      fill='url(#q)'
    />
    <path
      d='m67.248 94.022c2.071 0 3.7498-1.6964 3.7498-3.7891 0-2.0926-1.6788-3.7891-3.7498-3.7891s-3.7499 1.6965-3.7499 3.7891c0 2.0927 1.6789 3.7891 3.7499 3.7891z'
      fill='url(#o)'
    />
    <path
      d='m181.54 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.04 22.554c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m167.89 36.254c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m37.887 186.25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m191.89 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m35.514 30.802c2.8445 0 5.1505-2.306 5.1505-5.1505 0-2.8446-2.306-5.1505-5.1505-5.1505-2.8446 0-5.1505 2.3059-5.1505 5.1505 0 2.8445 2.3059 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.013 30.801c1.4635 0 2.65-1.1865 2.65-2.65 0-1.4636-1.1865-2.65-2.65-2.65-1.4636 0-2.65 1.1864-2.65 2.65 0 1.4635 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.391 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m124.2 185.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='#8E76D7'
    />
    <path
      d='m124.2 185.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#n)'
    />
    <path
      d='m124.2 185.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#m)'
      fillOpacity='.8'
    />
    <path
      d='m124.2 185.72 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      stroke='#F0EDFA'
      strokeWidth='5'
    />
    <path
      d='m155 184.5c17.121 0 31-13.879 31-31s-13.879-31-31-31-31 13.879-31 31 13.879 31 31 31z'
      fill='url(#l)'
    />
    <path
      d='m151.11 138.6c-0.059-0.588 0.427-1.096 1.049-1.096h5.681c0.622 0 1.108 0.508 1.049 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.049 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#k)'
    />
    <path
      d='m151.11 138.6c-0.059-0.588 0.427-1.096 1.049-1.096h5.681c0.622 0 1.108 0.508 1.049 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.049 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#j)'
    />
    <ellipse cx='155' cy='165.77' rx='4' ry='3.795' fill='url(#i)' />
    <defs>
      <radialGradient
        id='aa'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(151.94 117.01) rotate(170.89) scale(111.56 36.038)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='p'
        x1='65.24'
        x2='65.823'
        y1='119.84'
        y2='134.35'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='158.22'
        x2='145.1'
        y1='97.675'
        y2='101.88'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='145.82'
        x2='145.25'
        y1='104.07'
        y2='119.59'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='92.623'
        x2='88.07'
        y1='73.531'
        y2='83.665'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='80.317'
        x2='85'
        y1='79.107'
        y2='81.151'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='98.472'
        x2='93.074'
        y1='80.471'
        y2='91.674'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='85.47'
        x2='90.523'
        y1='86.791'
        y2='88.848'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='103.37'
        x2='96.945'
        y1='85.899'
        y2='97.885'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='90.301'
        x2='95.521'
        y1='92.962'
        y2='94.873'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='z'
        x1='109.14'
        x2='101.79'
        y1='90.569'
        y2='103.42'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='y'
        x1='95.61'
        x2='101.1'
        y1='98.376'
        y2='100.26'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='x'
        x1='113.86'
        x2='105.27'
        y1='95.746'
        y2='107.13'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='103.12'
        x2='107.68'
        y1='103.92'
        y2='105.11'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='117.28'
        x2='107.84'
        y1='98.012'
        y2='104.44'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='111.01'
        x2='113.8'
        y1='107.31'
        y2='107.68'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='125.25'
        x2='116.84'
        y1='101.94'
        y2='109.05'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.26116' stopColor='#8E76D7' />
        <stop offset='.64881' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='118.7'
        x2='121.59'
        y1='109.74'
        y2='110.22'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='67.25'
        x2='67.25'
        y1='82.619'
        y2='99.33'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='71.094'
        x2='67.33'
        y1='87.718'
        y2='95.647'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.37711' stopColor='#413BBC' />
        <stop offset='.69909' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='64.046'
        x2='66.849'
        y1='91.011'
        y2='91.907'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='n'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(208.1 117.51) rotate(133.56) scale(144.86 149.48)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.10497' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='.60139' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='m'
        x1='129.53'
        x2='150.81'
        y1='134.3'
        y2='215.08'
        gradientUnits='userSpaceOnUse'>
        <stop offset='.50508' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='155'
        x2='129.42'
        y1='122.5'
        y2='172.1'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='159.28'
        x2='157.58'
        y1='130.93'
        y2='130.86'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='166.65'
        x2='153.07'
        y1='135.43'
        y2='153.49'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='i'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(160.86 161.93) rotate(148.61) scale(8.6386 8.4494)'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#413BBC' />
        <stop offset='1' stopColor='white' />
      </radialGradient>
    </defs>
  </svg>
);
export const EmptyUnLinkedSvg = () => (
  <svg
    width='201'
    height='201'
    fill='none'
    viewBox='0 0 201 201'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='.5' y='.5' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m182.04 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.54 22.553c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m168.38 36.253c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m38.385 186.25c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m192.38 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m36.013 30.801c2.8445 0 5.1505-2.306 5.1505-5.1505s-2.306-5.1505-5.1505-5.1505-5.1505 2.306-5.1505 5.1505 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.512 30.8c1.4636 0 2.65-1.1864 2.65-2.65s-1.1864-2.65-2.65-2.65-2.65 1.1864-2.65 2.65 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.891 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m161.9 174.5h-122.79c-7.1091 0-12.603-4.952-12.603-10.729v-126.54c0-6.052 5.8166-10.729 12.603-10.729h122.79c7.11 0 12.603 4.9517 12.603 10.729v126.54c0 5.777-5.817 10.729-12.603 10.729z'
      fill='#fff'
    />
    <path
      d='m155.98 119.24c-0.375-0.757 0.375-3.132 0-3.89-1.5-2.274-3.944-2.754-7.694-3.891-5.25-1.515-8.543-3.797-12.668-4.176-1.125 0-2.25-0.379-3-0.379-11.624-1.137-21.374-3.032-42.748-29.555-2.2499-2.6523-3.3749-5.3047-5.6248-7.9571-2.2499-2.2734-5.9997 0.379-10.875 1.5157-1.1249 0.3789-1.8749 0.3789-2.9998 0.3789-3.7499 0-8.2497-0.3789-12.374-0.7578-5.6248-0.7578-2.2499-3.7891-8.9997 39.786-0.375 3.41-0.7499 6.441-1.1249 9.852-0.375 2.652-0.375 5.683-0.375 8.336 0 1.136 0.375 3.031 1.4999 3.031 17.999 1.894 29.624 1.137 58.123 0.758 14.25 0 28.499 0 42.748-2.653l3.375-0.379c3-0.379 6-1.515 6-3.41 0-2.652-2.512-3.956-3.262-6.609z'
      fill='#8E76D7'
    />
    <path
      d='m135.62 107.66-3.375 9.851c-18.375-0.758-37.124-12.504-46.873-27.66-3.3749-5.3048-5.9998-10.988-9.7496-15.535 0 0-1.125-1.5157-2.6249-2.6524 4.8748-1.1367 8.6246-3.7891 10.874-1.5156 1.875 1.8945 2.6249 3.4101 4.1249 5.3047 0.3749 0.7578 0.7499 1.1367 1.1249 1.8945 0 0.379 0.375 0.379 0.375 0.7579 1.125 1.5156 2.6249 3.0312 3.7498 4.5469 0.375 0.3789 0.75 0.7578 1.125 1.5156 1.4999 1.5157 2.6249 3.0313 4.1248 4.5469 0.375 0.3789 0.75 0.7579 1.125 1.5157 1.5 1.5156 2.625 3.0312 4.125 4.168 0.375 0.3789 1.125 0.7578 1.5 1.5156 1.5 1.1367 2.625 2.2735 3.75 3.4102 0.75 0.3789 1.125 0.7575 1.875 1.5155 1.124 0.758 1.874 1.516 2.999 1.895 0.75 0.379 1.5 0.758 1.875 1.136 1.875 1.137 3.75 1.895 5.625 2.653 0.75 0.379 1.5 0.379 2.25 0.758 3 0.757 5.625 1.136 8.625 1.515 1.125-1.515 2.25-1.515 3.375-1.136z'
      fill='#413BBC'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='#8E76D7'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='url(#x)'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='url(#m)'
      fillOpacity='.8'
    />
    <path
      d='m158.12 117.9c-6.75 2.273-13.5 3.789-20.625 4.168-1.125 0-2.25 0-3-0.379-1.124-0.379-1.124-1.137-1.499-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.874 0.379 10.124 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#h)'
    />
    <path
      d='m158.12 117.9c-6.75 2.273-13.5 3.789-20.625 4.168-1.125 0-2.25 0-3-0.379-1.124-0.379-1.124-1.137-1.499-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.874 0.379 10.124 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#g)'
    />
    <path
      d='m89.125 76.972v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0.375-1.5156l4.8748-3.7891h0.375c0 0.3789 0.375 1.1367 0.75 1.5156z'
      fill='url(#f)'
    />
    <path
      d='m89.125 76.972v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0.375-1.5156l4.8748-3.7891h0.375c0 0.3789 0.375 1.1367 0.75 1.5156z'
      fill='url(#e)'
    />
    <path
      d='m94.747 83.411c0 0.3789 0 0.3789-0.375 0.7579-1.4999 1.5156-2.9999 3.0312-4.8748 4.5469-0.375 0-0.375 0.3789-0.7499 0.3789-0.375 0-0.75 0-0.75-0.3789-0.375-0.3789-0.375-1.1368 0.375-1.5157 1.4999-1.1367 2.9999-2.6523 4.4998-4.168 0.375-0.3789 0.375-0.3789 0.75-0.3789 0 0 0.7499 0.3789 1.1249 0.7578z'
      fill='url(#d)'
    />
    <path
      d='m94.747 83.411c0 0.3789 0 0.3789-0.375 0.7579-1.4999 1.5156-2.9999 3.0312-4.8748 4.5469-0.375 0-0.375 0.3789-0.7499 0.3789-0.375 0-0.75 0-0.75-0.3789-0.375-0.3789-0.375-1.1368 0.375-1.5157 1.4999-1.1367 2.9999-2.6523 4.4998-4.168 0.375-0.3789 0.375-0.3789 0.75-0.3789 0 0 0.7499 0.3789 1.1249 0.7578z'
      fill='url(#c)'
    />
    <path
      d='m99.624 89.475c0 0.3789 0 0.3789-0.3749 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9259-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0-1.5157 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.1249 1.1367z'
      fill='url(#b)'
    />
    <path
      d='m99.624 89.475c0 0.3789 0 0.3789-0.3749 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9259-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0-1.5157 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.1249 1.1367z'
      fill='url(#a)'
    />
    <path
      d='m105.25 94.78c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.75-0.379-0.7499-1.1369-0.375-1.5158c1.5-1.8945 3.3749-3.7891 5.2499-5.6836 0 0 0.375 0 0.375-0.379 0.75 0.7579 1.125 1.1368 1.5 1.5157z'
      fill='url(#w)'
    />
    <path
      d='m105.25 94.78c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.75-0.379-0.7499-1.1369-0.375-1.5158c1.5-1.8945 3.3749-3.7891 5.2499-5.6836 0 0 0.375 0 0.375-0.379 0.75 0.7579 1.125 1.1368 1.5 1.5157z'
      fill='url(#v)'
    />
    <path
      d='m110.87 99.328v0c-1.125 2.2739-2.249 4.5469-3.749 6.8209-0.375 0.378-0.75 0.757-1.125 0.757h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.749 0 1.124 0.3789 1.874 0.7578z'
      fill='url(#u)'
    />
    <path
      d='m110.87 99.328v0c-1.125 2.2739-2.249 4.5469-3.749 6.8209-0.375 0.378-0.75 0.757-1.125 0.757h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.749 0 1.124 0.3789 1.874 0.7578z'
      fill='url(#t)'
    />
    <path
      d='m115.75 102.74-1.125 6.821c0 0.758-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#s)'
    />
    <path
      d='m115.75 102.74-1.125 6.821c0 0.758-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#r)'
    />
    <path
      d='m123.62 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#q)'
    />
    <path
      d='m123.62 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#p)'
    />
    <path
      d='m67.75 99.706c5.1775 0 9.3746-4.2411 9.3746-9.4727 0-5.2317-4.1971-9.4728-9.3746-9.4728-5.1774 0-9.3746 4.2411-9.3746 9.4728 0 5.2316 4.1972 9.4727 9.3746 9.4727z'
      fill='url(#o)'
    />
    <path
      d='m67.747 94.022c2.071 0 3.7499-1.6965 3.7499-3.7891 0-2.0927-1.6789-3.7891-3.7499-3.7891s-3.7498 1.6964-3.7498 3.7891c0 2.0926 1.6788 3.7891 3.7498 3.7891z'
      fill='url(#n)'
    />
    <path
      d='m67.747 94.022c2.071 0 3.7499-1.6965 3.7499-3.7891 0-2.0927-1.6789-3.7891-3.7499-3.7891s-3.7498 1.6964-3.7498 3.7891c0 2.0926 1.6788 3.7891 3.7498 3.7891z'
      fill='url(#l)'
    />
    <circle cx='172.5' cy='30.5' r='20' fill='url(#k)' />
    <path
      d='m169.65 19.073h5.625l-1.5 15.626h-2.625l-1.5-15.626z'
      fill='#fff'
    />
    <ellipse cx='172.46' cy='39.699' rx='2.8127' ry='2.5002' fill='#fff' />
    <path
      d='m86 136.99c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.613 5.8881 5.988 8.2684 14.347 6.6398 22.331z'
      fill='#8E76D7'
    />
    <path
      d='m86 136.99c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.613 5.8881 5.988 8.2684 14.347 6.6398 22.331z'
      fill='url(#j)'
    />
    <path
      d='m86 136.99c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.613 5.8881 5.988 8.2684 14.347 6.6398 22.331z'
      fill='url(#i)'
      fillOpacity='.8'
    />
    <path
      d='m86 136.99c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.613 5.8881 5.988 8.2684 14.347 6.6398 22.331z'
      stroke='#fff'
      strokeWidth='3'
    />
    <g clipPath='url(#y)' fill='#fff'>
      <path
        d='m62.657 124.08c1.0588-1.023 2.4768-1.589 3.9487-1.576s2.8799 0.603 3.9208 1.644c1.0408 1.041 1.6312 2.449 1.644 3.921s-0.5531 2.89-1.5756 3.949c-5e-3 5e-3 -0.01 0.01-0.0151 0.015l-2.6264 2.626c-1e-4 0-2e-4 0-2e-4 1e-3 -0.5691 0.569-1.2539 1.009-2.0081 1.29-0.7542 0.282-1.5601 0.397-2.363 0.34-0.8029-0.058-1.5841-0.287-2.2905-0.673s-1.3216-0.919-1.8038-1.564c-0.4088-0.547-0.2972-1.321 0.2495-1.73 0.5466-0.409 1.3212-0.297 1.7301 0.249 0.2699 0.361 0.6141 0.66 1.0095 0.876 0.3953 0.216 0.8325 0.344 1.2818 0.376s0.9004-0.032 1.3224-0.19c0.4221-0.157 0.8054-0.404 1.1239-0.722h2e-4l2.6183-2.619c0.568-0.592 0.8821-1.382 0.875-2.203-0.0072-0.823-0.3376-1.611-0.9201-2.194-0.5824-0.582-1.3704-0.913-2.1941-0.92-0.821-7e-3 -1.6121 0.308-2.2039 0.876l-1.4991 1.491c-0.4841 0.481-1.2667 0.479-1.748-5e-3 -0.4813-0.485-0.4791-1.267 0.0051-1.749l1.5059-1.497c0.0042-4e-3 0.0085-8e-3 0.0127-0.012z'
        clipRule='evenodd'
        fillRule='evenodd'
      />
      <path
        d='m60.928 140.08c-1.0587 1.023-2.4768 1.589-3.9487 1.576s-2.8799-0.603-3.9207-1.644-1.6312-2.449-1.644-3.921 0.553-2.89 1.5756-3.948c5e-3 -6e-3 0.01-0.011 0.0151-0.016l2.6264-2.626h2e-4c0.569-0.57 1.2539-1.01 2.008-1.291 0.7542-0.281 1.5601-0.397 2.3631-0.34 0.8029 0.058 1.584 0.287 2.2905 0.673 0.7064 0.386 1.3215 0.919 1.8037 1.564 0.4089 0.547 0.2972 1.321-0.2494 1.73-0.5467 0.409-1.3213 0.297-1.7302-0.249-0.2698-0.361-0.6141-0.659-1.0094-0.875s-0.8325-0.345-1.2818-0.377c-0.4494-0.032-0.9004 0.033-1.3225 0.19-0.4221 0.158-0.8053 0.404-1.1238 0.723h-2e-4l-2.6184 2.618c-0.5679 0.592-0.882 1.382-0.8749 2.203 0.0071 0.824 0.3375 1.611 0.92 2.194 0.5825 0.582 1.3705 0.913 2.1942 0.92 0.821 7e-3 1.612-0.307 2.2039-0.876l1.4991-1.49c0.4841-0.482 1.2667-0.479 1.748 5e-3s0.479 1.266-0.0051 1.748l-1.5059 1.497c-0.0042 4e-3 -0.0085 8e-3 -0.0128 0.012z'
        clipRule='evenodd'
        fillRule='evenodd'
      />
    </g>
    <defs>
      <radialGradient
        id='x'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(152.48 117.27) rotate(171.2) scale(111.56 36.038)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='m'
        x1='65.767'
        x2='66.271'
        y1='119.63'
        y2='134.15'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='158.72'
        x2='145.6'
        y1='97.674'
        y2='101.88'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#F0F2FA' offset='1' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='146.32'
        x2='145.75'
        y1='104.07'
        y2='119.59'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='93.123'
        x2='88.57'
        y1='73.53'
        y2='83.664'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='80.817'
        x2='85.5'
        y1='79.106'
        y2='81.15'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='98.971'
        x2='93.573'
        y1='80.47'
        y2='91.673'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='85.969'
        x2='91.022'
        y1='86.79'
        y2='88.846'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='103.87'
        x2='97.446'
        y1='85.898'
        y2='97.884'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='90.802'
        x2='96.022'
        y1='92.961'
        y2='94.872'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='109.64'
        x2='102.29'
        y1='90.568'
        y2='103.42'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='96.112'
        x2='101.6'
        y1='98.375'
        y2='100.26'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='114.36'
        x2='105.77'
        y1='95.745'
        y2='107.13'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='103.62'
        x2='108.18'
        y1='103.92'
        y2='105.11'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='117.78'
        x2='108.34'
        y1='98.011'
        y2='104.44'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='111.51'
        x2='114.3'
        y1='107.3'
        y2='107.68'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='125.75'
        x2='117.34'
        y1='101.94'
        y2='109.05'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='119.2'
        x2='122.09'
        y1='109.74'
        y2='110.22'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='67.75'
        x2='67.75'
        y1='82.618'
        y2='99.33'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#F0EDFA' offset='1' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='71.594'
        x2='67.829'
        y1='87.717'
        y2='95.646'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.37711' />
        <stop stopColor='#A9A6E2' offset='.69909' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='64.545'
        x2='67.348'
        y1='91.01'
        y2='91.906'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='0' />
        <stop stopColor='#413BBC' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='172.5'
        x2='156'
        y1='10.5'
        y2='42.5'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D92D20' offset='0' />
        <stop stopColor='#981F16' offset='1' />
      </linearGradient>
      <radialGradient
        id='j'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(83.515 110.44) rotate(133.26) scale(70.482 72.689)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='i'
        x1='45.498'
        x2='56.001'
        y1='118.65'
        y2='158.1'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <clipPath id='y'>
        <rect
          transform='translate(51.5 121.5)'
          width='21'
          height='21'
          fill='#fff'
        />
      </clipPath>
    </defs>
  </svg>
);
export const EmptyUnLinkedSearchSvg = () => (
  <svg
    width='220'
    height='221'
    fill='none'
    viewBox='0 0 220 221'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='.5' y='.50098' width='200' height='200' rx='100' fill='#F0EDFA' />
    <path
      d='m182.04 159.58c1.955 0 3.54-1.585 3.54-3.54s-1.585-3.54-3.54-3.54-3.54 1.585-3.54 3.54 1.585 3.54 3.54 3.54z'
      fill='#fff'
    />
    <path
      d='m180.54 22.554c1.739 0 3.15-1.4103 3.15-3.15s-1.411-3.15-3.15-3.15c-1.74 0-3.15 1.4103-3.15 3.15s1.41 3.15 3.15 3.15z'
      fill='#C5B8EA'
    />
    <path
      d='m168.38 36.254c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m38.385 186.25c3.8659 0 7-3.134 7-7s-3.1341-7-7-7c-3.866 0-7 3.134-7 7s3.134 7 7 7z'
      fill='#fff'
    />
    <path
      d='m192.38 157.5c1.104 0 2-0.895 2-2s-0.896-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z'
      fill='#C5B8EA'
    />
    <path
      d='m36.013 30.802c2.8445 0 5.1505-2.306 5.1505-5.1505 0-2.8446-2.306-5.1505-5.1505-5.1505s-5.1505 2.3059-5.1505 5.1505c0 2.8445 2.306 5.1505 5.1505 5.1505z'
      fill='#fff'
    />
    <path
      d='m19.512 30.801c1.4636 0 2.65-1.1865 2.65-2.65 0-1.4636-1.1864-2.65-2.65-2.65s-2.65 1.1864-2.65 2.65c0 1.4635 1.1864 2.65 2.65 2.65z'
      fill='#DCDAE3'
    />
    <path
      d='m34.891 195.5c1.6569 0 3-1.343 3-3s-1.3431-3-3-3c-1.6568 0-3 1.343-3 3s1.3432 3 3 3z'
      fill='#C5B8EA'
    />
    <path
      d='m161.9 174.5h-122.79c-7.1091 0-12.603-4.952-12.603-10.729v-126.54c0-6.052 5.8166-10.729 12.603-10.729h122.79c7.11 0 12.603 4.9516 12.603 10.729v126.54c0 5.777-5.817 10.729-12.603 10.729z'
      fill='#fff'
    />
    <path
      d='m155.98 119.24c-0.375-0.757 0.375-3.132 0-3.89-1.5-2.274-3.944-2.754-7.694-3.891-5.25-1.515-8.543-3.798-12.668-4.176-1.125 0-2.25-0.379-3-0.379-11.624-1.137-21.374-3.032-42.748-29.555-2.2499-2.6523-3.3749-5.3047-5.6248-7.9571-2.2499-2.2734-5.9997 0.3789-10.875 1.5157-1.1249 0.3789-1.8749 0.3789-2.9998 0.3789-3.7499 0-8.2497-0.3789-12.374-0.7578-5.6248-0.7579-2.2499-3.7891-8.9997 39.786-0.375 3.41-0.7499 6.441-1.1249 9.851-0.375 2.653-0.375 5.684-0.375 8.337 0 1.136 0.375 3.031 1.4999 3.031 17.999 1.894 29.624 1.137 58.123 0.758 14.25 0 28.499 0 42.748-2.653l3.375-0.379c3-0.379 6-1.515 6-3.41 0-2.652-2.512-3.956-3.262-6.609z'
      fill='#8E76D7'
    />
    <path
      d='m135.62 107.66-3.375 9.852c-18.375-0.758-37.124-12.504-46.873-27.66-3.3749-5.3047-5.9998-10.988-9.7496-15.535 0 0-1.125-1.5156-2.6249-2.6523 4.8748-1.1368 8.6246-3.7891 10.874-1.5157 1.875 1.8946 2.6249 3.4102 4.1249 5.3048 0.3749 0.7578 0.7499 1.1367 1.1249 1.8945 0 0.3789 0.375 0.3789 0.375 0.7578 1.125 1.5157 2.6249 3.0313 3.7498 4.547 0.375 0.3789 0.75 0.7578 1.125 1.5156 1.4999 1.5156 2.6249 3.0313 4.1248 4.5469 0.375 0.3789 0.75 0.7578 1.125 1.5157 1.5 1.5156 2.625 3.0312 4.125 4.1679 0.375 0.379 1.125 0.7579 1.5 1.5157 1.5 1.1367 2.625 2.2735 3.75 3.4102 0.75 0.3789 1.125 0.7575 1.875 1.5155 1.124 0.758 1.874 1.516 2.999 1.895 0.75 0.379 1.5 0.757 1.875 1.136 1.875 1.137 3.75 1.895 5.625 2.653 0.75 0.379 1.5 0.379 2.25 0.758 3 0.757 5.625 1.136 8.625 1.515 1.125-1.515 2.25-1.515 3.375-1.137z'
      fill='#413BBC'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='#8E76D7'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='url(#ad)'
    />
    <path
      d='m159.24 126.53c-0.01 1.894-3.391 3.013-6.018 3.377l-3.377 0.361c-13.888 2.578-28.513 2.499-42.762 2.422-28.498-0.154-39.752 0.543-58.118-1.072-1.4999-8e-3 -1.4897-1.902-1.4835-3.039 0.0163-3.031 0.0306-5.684 0.4199-8.334 10.12 0.813 52.856 3.317 85.497 0.083 9.006-1.089 17.261-2.181 23.646-4.041l1.113 2.28c0.738 2.277 1.098 4.931 1.082 7.963z'
      fill='url(#s)'
      fillOpacity='.8'
    />
    <path
      d='m158.12 117.9c-6.75 2.273-13.5 3.789-20.625 4.168-1.125 0-2.25 0-3-0.379-1.124-0.379-1.124-1.137-1.499-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.874 0.379 10.124 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#h)'
    />
    <path
      d='m158.12 117.9c-6.75 2.273-13.5 3.789-20.625 4.168-1.125 0-2.25 0-3-0.379-1.124-0.379-1.124-1.137-1.499-1.895v-1.137c-0.375-3.789-0.75-7.957-0.75-11.746 4.874 0.379 10.124 0.758 16.499 3.032 3.75 1.136 6.375 3.031 7.875 5.683 0.75 0.758 1.125 1.516 1.5 2.274z'
      fill='url(#g)'
    />
    <path
      d='m89.125 76.973v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0.375-1.5157l4.8748-3.7891h0.375c0 0.3789 0.375 1.1368 0.75 1.5157z'
      fill='url(#f)'
    />
    <path
      d='m89.125 76.973v0l-4.8748 3.7891c-0.375 0-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1368 0.375-1.5157l4.8748-3.7891h0.375c0 0.3789 0.375 1.1368 0.75 1.5157z'
      fill='url(#e)'
    />
    <path
      d='m94.747 83.412c0 0.3789 0 0.3789-0.375 0.7578-1.4999 1.5157-2.9999 3.0313-4.8748 4.5469-0.375 0-0.375 0.379-0.7499 0.379-0.375 0-0.75 0-0.75-0.379-0.375-0.3789-0.375-1.1367 0.375-1.5156 1.4999-1.1367 2.9999-2.6524 4.4998-4.168 0.375-0.3789 0.375-0.3789 0.75-0.3789 0 0 0.7499 0.3789 1.1249 0.7578z'
      fill='url(#d)'
    />
    <path
      d='m94.747 83.412c0 0.3789 0 0.3789-0.375 0.7578-1.4999 1.5157-2.9999 3.0313-4.8748 4.5469-0.375 0-0.375 0.379-0.7499 0.379-0.375 0-0.75 0-0.75-0.379-0.375-0.3789-0.375-1.1367 0.375-1.5156 1.4999-1.1367 2.9999-2.6524 4.4998-4.168 0.375-0.3789 0.375-0.3789 0.75-0.3789 0 0 0.7499 0.3789 1.1249 0.7578z'
      fill='url(#c)'
    />
    <path
      d='m99.624 89.476c0 0.3789 0 0.3789-0.3749 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9258-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0-1.5156 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.1249 1.1367z'
      fill='url(#b)'
    />
    <path
      d='m99.624 89.476c0 0.3789 0 0.3789-0.3749 0.7578-1.5 1.5157-3.3749 3.4102-4.8748 4.9258-0.375 0.3789-0.375 0.3789-0.75 0.3789s-0.75 0-0.75-0.3789c-0.375-0.3789-0.375-1.1367 0-1.5156 1.5-1.5156 3.3749-3.4102 4.8748-4.9258 0.375-0.3789 0.375-0.3789 0.75-0.3789s0.75 0.7578 1.1249 1.1367z'
      fill='url(#a)'
    />
    <path
      d='m105.25 94.781c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.75-0.379-0.7499-1.1369-0.375-1.5158c1.5-1.8946 3.3749-3.7891 5.2499-5.6837 0 0 0.375 0 0.375-0.3789 0.75 0.7578 1.125 1.1368 1.5 1.5157z'
      fill='url(#ac)'
    />
    <path
      d='m105.25 94.781c0 0.3789 0 0.3789-0.375 0.7578-1.875 1.5156-3.75 3.4102-4.8749 5.3049-0.375 0.379-0.375 0.379-0.75 0.379s-0.375 0-0.75-0.379-0.7499-1.1369-0.375-1.5158c1.5-1.8946 3.3749-3.7891 5.2499-5.6837 0 0 0.375 0 0.375-0.3789 0.75 0.7578 1.125 1.1368 1.5 1.5157z'
      fill='url(#ab)'
    />
    <path
      d='m110.87 99.329v0c-1.125 2.2739-2.249 4.5469-3.749 6.8199-0.375 0.379-0.75 0.758-1.125 0.758h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.749 0 1.124 0.3789 1.874 0.7578z'
      fill='url(#aa)'
    />
    <path
      d='m110.87 99.329v0c-1.125 2.2739-2.249 4.5469-3.749 6.8199-0.375 0.379-0.75 0.758-1.125 0.758h-0.375c-0.375-0.379-0.75-1.136-0.375-1.515 1.125-2.274 2.25-4.547 3.375-6.4418l0.375-0.3789c0.749 0 1.124 0.3789 1.874 0.7578z'
      fill='url(#z)'
    />
    <path
      d='m115.75 102.74-1.125 6.821c0 0.757-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#y)'
    />
    <path
      d='m115.75 102.74-1.125 6.821c0 0.757-0.75 1.136-1.125 1.136-0.75 0-1.125-0.757-1.125-1.515l1.125-7.578c0-0.379 0-0.379 0.375-0.379 0.75 0.757 1.125 1.136 1.875 1.515z'
      fill='url(#x)'
    />
    <path
      d='m123.62 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#w)'
    />
    <path
      d='m123.62 105.77c-0.375 1.894-0.75 4.168-1.125 6.062 0 0.379-0.75 0.758-1.125 0.758h-0.375c-0.75 0-1.125-0.758-0.75-1.516 0.375-1.894 0.75-4.168 1.125-6.062v-0.379c0.75 0.758 1.5 1.137 2.25 1.137z'
      fill='url(#v)'
    />
    <path
      d='m67.75 99.707c5.1775 0 9.3746-4.2411 9.3746-9.4727 0-5.2317-4.1971-9.4728-9.3746-9.4728-5.1774 0-9.3746 4.2411-9.3746 9.4728 0 5.2316 4.1972 9.4727 9.3746 9.4727z'
      fill='url(#u)'
    />
    <path
      d='m67.747 94.022c2.071 0 3.7499-1.6964 3.7499-3.7891 0-2.0926-1.6789-3.7891-3.7499-3.7891s-3.7498 1.6965-3.7498 3.7891c0 2.0927 1.6788 3.7891 3.7498 3.7891z'
      fill='url(#t)'
    />
    <path
      d='m67.747 94.022c2.071 0 3.7499-1.6964 3.7499-3.7891 0-2.0926-1.6789-3.7891-3.7499-3.7891s-3.7498 1.6965-3.7498 3.7891c0 2.0927 1.6788 3.7891 3.7498 3.7891z'
      fill='url(#r)'
    />
    <circle cx='172.5' cy='30.501' r='20' fill='url(#q)' />
    <path
      d='m169.65 19.074h5.625l-1.5 15.626h-2.625l-1.5-15.626z'
      fill='#fff'
    />
    <ellipse cx='172.46' cy='39.7' rx='2.8127' ry='2.5002' fill='#fff' />
    <path
      d='m86 137c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.612 5.8881 5.989 8.2684 14.348 6.6398 22.332z'
      fill='#8E76D7'
    />
    <path
      d='m86 137c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.612 5.8881 5.989 8.2684 14.348 6.6398 22.332z'
      fill='url(#p)'
    />
    <path
      d='m86 137c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.612 5.8881 5.989 8.2684 14.348 6.6398 22.332z'
      fill='url(#o)'
      fillOpacity='.8'
    />
    <path
      d='m86 137c-0.5011 2.121-1.2528 4.367-2.1297 6.238-2.3803 4.616-6.1387 8.234-10.774 10.605-4.7606 2.37-10.398 3.368-16.036 2.121-13.28-2.745-21.798-15.72-19.042-28.944 2.7561-13.225 15.66-21.833 28.939-18.964 4.7606 0.998 8.8947 3.369 12.402 6.612 5.8881 5.989 8.2684 14.348 6.6398 22.332z'
      stroke='#fff'
      strokeWidth='3'
    />
    <g clipPath='url(#ae)' fill='#fff'>
      <path
        d='m62.657 124.08c1.0588-1.023 2.4768-1.589 3.9487-1.576s2.8799 0.603 3.9208 1.644c1.0408 1.041 1.6312 2.449 1.644 3.921s-0.5531 2.89-1.5756 3.949c-5e-3 5e-3 -0.01 0.01-0.0151 0.015l-2.6264 2.626c-1e-4 0-2e-4 0-2e-4 1e-3 -0.5691 0.569-1.2539 1.009-2.0081 1.29-0.7542 0.282-1.5601 0.397-2.363 0.34-0.8029-0.058-1.5841-0.287-2.2905-0.673s-1.3216-0.919-1.8038-1.564c-0.4088-0.547-0.2972-1.321 0.2495-1.73 0.5466-0.409 1.3212-0.297 1.7301 0.249 0.2699 0.361 0.6141 0.66 1.0095 0.876 0.3953 0.216 0.8325 0.344 1.2818 0.376s0.9004-0.032 1.3224-0.19c0.4221-0.157 0.8054-0.404 1.1239-0.722l2e-4 -1e-3 2.6183-2.618c0.568-0.592 0.8821-1.382 0.875-2.203-0.0072-0.823-0.3376-1.611-0.9201-2.194-0.5824-0.582-1.3704-0.913-2.1941-0.92-0.821-7e-3 -1.6121 0.308-2.2039 0.876l-1.4991 1.491c-0.4841 0.481-1.2667 0.479-1.748-5e-3 -0.4813-0.485-0.4791-1.267 0.0051-1.749l1.5059-1.497c0.0042-4e-3 0.0085-8e-3 0.0127-0.012z'
        clipRule='evenodd'
        fillRule='evenodd'
      />
      <path
        d='m60.928 140.08c-1.0587 1.023-2.4768 1.589-3.9487 1.576s-2.8799-0.603-3.9207-1.644-1.6312-2.449-1.644-3.921 0.553-2.89 1.5756-3.948c5e-3 -6e-3 0.01-0.011 0.0151-0.016l2.6264-2.626h2e-4c0.569-0.57 1.2539-1.01 2.008-1.291 0.7542-0.281 1.5601-0.397 2.3631-0.34 0.8029 0.058 1.584 0.287 2.2905 0.673 0.7064 0.386 1.3215 0.919 1.8037 1.564 0.4089 0.547 0.2972 1.321-0.2494 1.73-0.5467 0.409-1.3213 0.297-1.7302-0.249-0.2698-0.361-0.6141-0.659-1.0094-0.875s-0.8325-0.345-1.2818-0.377c-0.4494-0.032-0.9004 0.033-1.3225 0.19-0.4221 0.158-0.8053 0.404-1.1238 0.723h-2e-4l-2.6184 2.618c-0.5679 0.592-0.882 1.382-0.8749 2.203 0.0071 0.824 0.3375 1.611 0.92 2.194 0.5825 0.582 1.3705 0.913 2.1942 0.92 0.821 7e-3 1.612-0.307 2.2039-0.876l1.4991-1.49c0.4841-0.482 1.2667-0.479 1.748 5e-3s0.479 1.266-0.0051 1.748l-1.5059 1.497c-0.0042 4e-3 -0.0085 8e-3 -0.0128 0.012z'
        clipRule='evenodd'
        fillRule='evenodd'
      />
    </g>
    <path
      d='m124.2 189.22 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='#8E76D7'
    />
    <path
      d='m124.2 189.22 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#n)'
    />
    <path
      d='m124.2 189.22 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      fill='url(#m)'
      fillOpacity='.8'
    />
    <path
      d='m124.2 189.22 3e-3 3e-3c8.376 7.935 19.689 12.498 31.043 12.498 9.077 0 17.992-2.862 25.7-8.288l21.683 21.684c1.583 1.748 3.632 2.586 5.707 2.586 3.418 0 6.383-2.449 7.795-5.273l0.08-0.159 0.056-0.168c0.25-0.75 0.619-2.049 0.463-3.611-0.162-1.626-0.874-3.341-2.457-4.924l-21.898-21.899c8.994-13.804 9.825-30.77 2.192-45.316l-4e-3 -8e-3c-7.936-14.991-22.683-23.845-39.456-23.845-24.59 0-44.61 20.02-44.61 44.61 0 12.353 4.863 23.712 13.703 32.11zm53.14-14.635-6e-3 8e-3c-5.519 6.931-13.287 10.732-21.81 10.732-14.148 0-28.492-10.646-28.492-28.215 0-15.443 12.508-28.075 28.075-28.075 10.837 0 20.538 6.107 25.409 15.967 4.734 9.863 3.563 21.191-3.176 29.583z'
      stroke='#F0EDFA'
      strokeWidth='5'
    />
    <path
      d='m155 188c17.121 0 31-13.879 31-31s-13.879-31-31-31-31 13.879-31 31 13.879 31 31 31z'
      fill='url(#l)'
    />
    <path
      d='m151.11 142.1c-0.06-0.588 0.427-1.096 1.048-1.096h5.682c0.621 0 1.108 0.508 1.048 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.048 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#k)'
    />
    <path
      d='m151.11 142.1c-0.06-0.588 0.427-1.096 1.048-1.096h5.682c0.621 0 1.108 0.508 1.048 1.096l-1.931 19.095c-0.052 0.513-0.506 0.904-1.048 0.904h-1.819c-0.543 0-0.997-0.391-1.049-0.904l-1.931-19.095z'
      fill='url(#j)'
    />
    <ellipse cx='155' cy='169.27' rx='4' ry='3.795' fill='url(#i)' />
    <defs>
      <radialGradient
        id='ad'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(152.48 117.27) rotate(171.2) scale(111.56 36.038)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='s'
        x1='65.767'
        x2='66.271'
        y1='119.63'
        y2='134.15'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='158.72'
        x2='145.6'
        y1='97.675'
        y2='101.88'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#F0F2FA' offset='1' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='146.32'
        x2='145.75'
        y1='104.07'
        y2='119.59'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='93.123'
        x2='88.57'
        y1='73.531'
        y2='83.665'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='80.817'
        x2='85.5'
        y1='79.107'
        y2='81.151'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='98.971'
        x2='93.573'
        y1='80.471'
        y2='91.674'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='85.969'
        x2='91.022'
        y1='86.791'
        y2='88.848'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='103.87'
        x2='97.446'
        y1='85.899'
        y2='97.885'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='90.802'
        x2='96.022'
        y1='92.962'
        y2='94.873'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='ac'
        x1='109.64'
        x2='102.29'
        y1='90.569'
        y2='103.42'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='ab'
        x1='96.112'
        x2='101.6'
        y1='98.376'
        y2='100.26'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='aa'
        x1='114.36'
        x2='105.77'
        y1='95.746'
        y2='107.13'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='z'
        x1='103.62'
        x2='108.18'
        y1='103.92'
        y2='105.11'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='y'
        x1='117.78'
        x2='108.34'
        y1='98.012'
        y2='104.44'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='x'
        x1='111.51'
        x2='114.3'
        y1='107.31'
        y2='107.68'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='125.75'
        x2='117.34'
        y1='101.94'
        y2='109.05'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='.26116' />
        <stop stopColor='#fff' offset='.64881' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='119.2'
        x2='122.09'
        y1='109.74'
        y2='110.22'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='67.75'
        x2='67.75'
        y1='82.619'
        y2='99.33'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#F0EDFA' offset='1' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='71.594'
        x2='67.829'
        y1='87.718'
        y2='95.647'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.37711' />
        <stop stopColor='#A9A6E2' offset='.69909' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='64.545'
        x2='67.348'
        y1='91.011'
        y2='91.907'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='0' />
        <stop stopColor='#413BBC' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='172.5'
        x2='156'
        y1='10.501'
        y2='42.501'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D92D20' offset='0' />
        <stop stopColor='#981F16' offset='1' />
      </linearGradient>
      <radialGradient
        id='p'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(83.515 110.44) rotate(133.26) scale(70.482 72.689)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='o'
        x1='45.498'
        x2='56.001'
        y1='118.65'
        y2='158.1'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <radialGradient
        id='n'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(208.1 121.01) rotate(133.56) scale(144.86 149.48)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='m'
        x1='129.53'
        x2='150.81'
        y1='137.8'
        y2='218.58'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='155'
        x2='129.42'
        y1='126'
        y2='175.6'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D92D20' offset='0' />
        <stop stopColor='#981F16' offset='1' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='159.28'
        x2='157.58'
        y1='134.43'
        y2='134.36'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#F0F2FA' offset='1' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='166.65'
        x2='153.07'
        y1='138.93'
        y2='156.99'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='i'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(160.86 165.43) rotate(148.61) scale(8.6386 8.4494)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='0' />
        <stop stopColor='#fff' offset='1' />
      </radialGradient>
      <clipPath id='ae'>
        <rect
          transform='translate(51.5 121.5)'
          width='21'
          height='21'
          fill='#fff'
        />
      </clipPath>
    </defs>
  </svg>
);
export const EmptyActivePlan = () => (
  <svg
    width='100'
    height='101'
    fill='none'
    viewBox='0 0 100 101'
    xmlns='http://www.w3.org/2000/svg'>
    <rect
      x='.00097656'
      y='.5'
      width='100'
      height='100'
      rx='50'
      fill='#F0EDFA'
    />
    <path
      d='m90.771 80.04c0.9775 0 1.77-0.7924 1.77-1.77 0-0.9775-0.7925-1.77-1.77-1.77-0.9776 0-1.77 0.7925-1.77 1.77 0 0.9776 0.7924 1.77 1.77 1.77z'
      fill='#fff'
    />
    <path
      d='m90.018 11.526c0.8698 0 1.575-0.7052 1.575-1.575s-0.7052-1.575-1.575-1.575c-0.8699 0-1.575 0.70516-1.575 1.575s0.7051 1.575 1.575 1.575z'
      fill='#C5B8EA'
    />
    <path
      d='m83.942 18.376c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5z'
      fill='#fff'
    />
    <path
      d='m18.943 93.376c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5z'
      fill='#fff'
    />
    <path
      d='m96.442 81c0.5523 0 1-0.4477 1-1s-0.4477-1-1-1-1 0.4477-1 1 0.4477 1 1 1z'
      fill='#C5B8EA'
    />
    <path
      d='m17.757 15.651c1.4223 0 2.5752-1.1529 2.5752-2.5752s-1.1529-2.5753-2.5752-2.5753-2.5753 1.153-2.5753 2.5753 1.153 2.5752 2.5753 2.5752z'
      fill='#fff'
    />
    <path
      d='m9.5066 15.65c0.73176 0 1.325-0.5932 1.325-1.325s-0.5932-1.325-1.325-1.325c-0.73178 0-1.325 0.5932-1.325 1.325s0.59322 1.325 1.325 1.325z'
      fill='#DCDAE3'
    />
    <path
      d='m17.196 98c0.8284 0 1.5-0.6715 1.5-1.5 0-0.8284-0.6716-1.5-1.5-1.5s-1.5 0.6716-1.5 1.5c0 0.8285 0.6716 1.5 1.5 1.5z'
      fill='#C5B8EA'
    />
    <path
      d='m22.787 84h56.206c2.2684 0 4.2847-2.0146 4.2847-4.281v-58.17c0-2.2664-2.0163-4.281-4.2847-4.281h-56.206c-2.2684 0-4.2847 2.0146-4.2847 4.281v58.17c0 2.2664 2.0163 4.281 4.2847 4.281z'
      fill='#8E76D7'
    />
    <path
      d='m22.787 84h56.206c2.2684 0 4.2847-2.0146 4.2847-4.281v-58.17c0-2.2664-2.0163-4.281-4.2847-4.281h-56.206c-2.2684 0-4.2847 2.0146-4.2847 4.281v58.17c0 2.2664 2.0163 4.281 4.2847 4.281z'
      fill='url(#x)'
    />
    <path
      d='m22.787 84h56.206c2.2684 0 4.2847-2.0146 4.2847-4.281v-58.17c0-2.2664-2.0163-4.281-4.2847-4.281h-56.206c-2.2684 0-4.2847 2.0146-4.2847 4.281v58.17c0 2.2664 2.0163 4.281 4.2847 4.281z'
      fill='url(#m)'
      fillOpacity='.8'
    />
    <path
      d='m72.141 54.77c0-0.8652-0.3204-1.6953-0.9024-2.3359l-5.756-6.33c-0.4277-0.4708-1.039-0.7422-1.6758-0.7422-0.6367 0-1.248 0.2695-1.6758 0.7422l-5.756 6.33c-0.582 0.6406-0.9023 1.4707-0.9023 2.3359v15.592c0 1.9141 1.5586 3.4726 3.4726 3.4726h9.7225c1.9141 0 3.4727-1.5585 3.4727-3.4726l5e-4 -15.592zm-1.3887 15.594c0 1.1485-0.9336 2.084-2.084 2.084h-9.7225c-1.1484 0-2.084-0.9336-2.084-2.084v-15.592c0-0.5195 0.1934-1.0176 0.541-1.4023l5.756-6.3301c0.166-0.1816 0.4023-0.2871 0.6485-0.2871 0.2461 0 0.4824 0.1036 0.6484 0.2871l5.756 6.3301c0.3496 0.3847 0.541 0.8828 0.541 1.4023l-4e-4 15.592z'
      fill='url(#h)'
    />
    <path
      d='m72.141 54.77c0-0.8652-0.3204-1.6953-0.9024-2.3359l-5.756-6.33c-0.4277-0.4708-1.039-0.7422-1.6758-0.7422-0.6367 0-1.248 0.2695-1.6758 0.7422l-5.756 6.33c-0.582 0.6406-0.9023 1.4707-0.9023 2.3359v15.592c0 1.9141 1.5586 3.4726 3.4726 3.4726h9.7225c1.9141 0 3.4727-1.5585 3.4727-3.4726l5e-4 -15.592zm-1.3887 15.594c0 1.1485-0.9336 2.084-2.084 2.084h-9.7225c-1.1484 0-2.084-0.9336-2.084-2.084v-15.592c0-0.5195 0.1934-1.0176 0.541-1.4023l5.756-6.3301c0.166-0.1816 0.4023-0.2871 0.6485-0.2871 0.2461 0 0.4824 0.1036 0.6484 0.2871l5.756 6.3301c0.3496 0.3847 0.541 0.8828 0.541 1.4023l-4e-4 15.592z'
      fill='url(#g)'
    />
    <path
      d='m60.336 28.002h-25c-1.914 0-3.4726 1.5586-3.4726 3.4726v31.946c0 1.9141 1.5586 3.4727 3.4726 3.4727h2.084v2.084c0 1.914 1.5586 3.4726 3.4727 3.4726h13.396c0.3847 0 0.6953-0.3105 0.6953-0.6953 0-0.3847-0.3106-0.6953-0.6953-0.6953h-13.396c-1.1485 0-2.084-0.9336-2.084-2.084v-2.084h15.278c0.3847 0 0.6953-0.3105 0.6953-0.6953 0-0.3847-0.3106-0.6953-0.6953-0.6953l-18.75 2e-3c-1.1485 0-2.084-0.9336-2.084-2.084v-31.946c0-1.1484 0.9336-2.084 2.084-2.084h25c1.1484 0 2.084 0.9336 2.084 2.084v12.576c0 0.3848 0.3105 0.6953 0.6953 0.6953 0.3847 0 0.6953-0.3105 0.6953-0.6953v-9.1035h2.084c1.1484 0 2.084 0.9336 2.084 2.084v10.514c0 0.3848 0.3105 0.6953 0.6953 0.6953 0.3847 0 0.6953-0.3105 0.6953-0.6953v-10.514c0-1.9141-1.5586-3.4726-3.4727-3.4726h-2.084v-2.084c0-1.9141-1.5586-3.4727-3.4726-3.4727l-0.0041 0.0021z'
      fill='url(#f)'
    />
    <path
      d='m54.086 37.03c1.1484 0 2.084-0.9336 2.084-2.084 0-1.1485-0.9336-2.084-2.084-2.084h-12.5c-1.1485 0-2.084 0.9336-2.084 2.084 0 1.1484 0.9336 2.084 2.084 2.084h12.5zm-13.196-2.084c0-0.3828 0.3125-0.6953 0.6953-0.6953h12.5c0.3828 0 0.6953 0.3105 0.6953 0.6953 0 0.3828-0.3106 0.6953-0.6953 0.6953h-12.5c-0.3829 0-0.6953-0.3106-0.6953-0.6953z'
      fill='url(#e)'
    />
    <path
      d='m54.086 37.03c1.1484 0 2.084-0.9336 2.084-2.084 0-1.1485-0.9336-2.084-2.084-2.084h-12.5c-1.1485 0-2.084 0.9336-2.084 2.084 0 1.1484 0.9336 2.084 2.084 2.084h12.5zm-13.196-2.084c0-0.3828 0.3125-0.6953 0.6953-0.6953h12.5c0.3828 0 0.6953 0.3105 0.6953 0.6953 0 0.3828-0.3106 0.6953-0.6953 0.6953h-12.5c-0.3829 0-0.6953-0.3106-0.6953-0.6953z'
      fill='url(#d)'
    />
    <path
      d='m58.714 40.848h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#c)'
    />
    <path
      d='m58.714 40.848h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#b)'
    />
    <path
      d='m58.714 44.348h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#a)'
    />
    <path
      d='m58.714 44.348h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#w)'
    />
    <path
      d='m58.714 47.848h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#v)'
    />
    <path
      d='m58.714 47.848h-21.763c-0.5022 0-0.9207-0.3931-0.9207-0.8648s0.4185-0.8648 0.9207-0.8648h21.763c0.5022 0 0.9207 0.3931 0.9207 0.8648 0.0837 0.4717-0.3348 0.8648-0.9207 0.8648z'
      fill='url(#u)'
    />
    <path
      d='m55.731 50.848h-18.901c-0.4361 0-0.7996-0.3931-0.7996-0.8648s0.3635-0.8648 0.7996-0.8648h18.901c0.4362 0 0.7996 0.3931 0.7996 0.8648 0.0727 0.4717-0.2907 0.8648-0.7996 0.8648z'
      fill='url(#t)'
    />
    <path
      d='m55.731 50.848h-18.901c-0.4361 0-0.7996-0.3931-0.7996-0.8648s0.3635-0.8648 0.7996-0.8648h18.901c0.4362 0 0.7996 0.3931 0.7996 0.8648 0.0727 0.4717-0.2907 0.8648-0.7996 0.8648z'
      fill='url(#s)'
    />
    <path
      d='m54.086 53.002h-17.362c-0.3828 0-0.6953 0.3105-0.6953 0.6953 0 0.3847 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3106 0.6953-0.6953 0-0.3848-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#r)'
    />
    <path
      d='m54.086 53.002h-17.362c-0.3828 0-0.6953 0.3105-0.6953 0.6953 0 0.3847 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3106 0.6953-0.6953 0-0.3848-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#q)'
    />
    <path
      d='m54.086 56.472h-17.362c-0.3828 0-0.6953 0.3106-0.6953 0.6953 0 0.3848 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3105 0.6953-0.6953 0-0.3847-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#p)'
    />
    <path
      d='m54.086 56.472h-17.362c-0.3828 0-0.6953 0.3106-0.6953 0.6953 0 0.3848 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3105 0.6953-0.6953 0-0.3847-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#o)'
    />
    <path
      d='m54.086 59.946h-17.362c-0.3828 0-0.6953 0.3105-0.6953 0.6953 0 0.3847 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3106 0.6953-0.6953 0-0.3848-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#n)'
    />
    <path
      d='m54.086 59.946h-17.362c-0.3828 0-0.6953 0.3105-0.6953 0.6953 0 0.3847 0.3105 0.6953 0.6953 0.6953h17.362c0.3848 0 0.6953-0.3106 0.6953-0.6953 0-0.3848-0.3105-0.6953-0.6953-0.6953z'
      fill='url(#l)'
    />
    <circle cx='79.502' cy='23' r='10' fill='url(#k)' />
    <path
      d='m78.075 17.287h2.8127l-0.7501 7.8131h-1.3126l-0.75-7.8131z'
      fill='#fff'
    />
    <ellipse cx='79.482' cy='27.6' rx='1.4064' ry='1.2501' fill='#fff' />
    <path
      d='m61.813 60.789h3.9887c0.7331 0 1.3296 0.5965 1.3296 1.3296 0 0.3683 0.2973 0.6657 0.6657 0.6657s0.6657-0.2974 0.6657-0.6657c0-1.4661-1.1931-2.6592-2.6591-2.6592v-0.6657c0-0.3684-0.2974-0.6657-0.6658-0.6657-0.3683 0-0.6657 0.2973-0.6657 0.6657v0.6657h-1.3295v-0.6657c0-0.3684-0.2973-0.6657-0.6657-0.6657s-0.6657 0.2973-0.6657 0.6657v0.6657c-1.4661 0-2.6592 1.1931-2.6592 2.6592 0 1.466 1.1931 2.6591 2.6592 2.6591h3.9887c0.733 0 1.3295 0.5965 1.3295 1.3296 0 0.733-0.5965 1.3295-1.3295 1.3295h-3.9887c-0.7331 0-1.3296-0.5965-1.3296-1.3295 0-0.3684-0.2973-0.6657-0.6657-0.6657s-0.6657 0.2973-0.6657 0.6657c0 1.466 1.1931 2.6591 2.6591 2.6591v0.6657c0 0.3684 0.2974 0.6657 0.6658 0.6657 0.3683 0 0.6657-0.2973 0.6657-0.6657v-0.6657h1.3295v0.6657c0 0.3684 0.2973 0.6657 0.6657 0.6657s0.6657-0.2973 0.6657-0.6657v-0.6657c1.4661 0 2.6592-1.1931 2.6592-2.6591 0-1.4661-1.1931-2.6592-2.6592-2.6592h-3.9887c-0.733 0-1.3295-0.5965-1.3295-1.3295 0-0.7331 0.5965-1.3296 1.3295-1.3296z'
      fill='url(#j)'
    />
    <path
      d='m61.813 60.789h3.9887c0.7331 0 1.3296 0.5965 1.3296 1.3296 0 0.3683 0.2973 0.6657 0.6657 0.6657s0.6657-0.2974 0.6657-0.6657c0-1.4661-1.1931-2.6592-2.6591-2.6592v-0.6657c0-0.3684-0.2974-0.6657-0.6658-0.6657-0.3683 0-0.6657 0.2973-0.6657 0.6657v0.6657h-1.3295v-0.6657c0-0.3684-0.2973-0.6657-0.6657-0.6657s-0.6657 0.2973-0.6657 0.6657v0.6657c-1.4661 0-2.6592 1.1931-2.6592 2.6592 0 1.466 1.1931 2.6591 2.6592 2.6591h3.9887c0.733 0 1.3295 0.5965 1.3295 1.3296 0 0.733-0.5965 1.3295-1.3295 1.3295h-3.9887c-0.7331 0-1.3296-0.5965-1.3296-1.3295 0-0.3684-0.2973-0.6657-0.6657-0.6657s-0.6657 0.2973-0.6657 0.6657c0 1.466 1.1931 2.6591 2.6591 2.6591v0.6657c0 0.3684 0.2974 0.6657 0.6658 0.6657 0.3683 0 0.6657-0.2973 0.6657-0.6657v-0.6657h1.3295v0.6657c0 0.3684 0.2973 0.6657 0.6657 0.6657s0.6657-0.2973 0.6657-0.6657v-0.6657c1.4661 0 2.6592-1.1931 2.6592-2.6591 0-1.4661-1.1931-2.6592-2.6592-2.6592h-3.9887c-0.733 0-1.3295-0.5965-1.3295-1.3295 0-0.7331 0.5965-1.3296 1.3295-1.3296z'
      fill='url(#i)'
    />
    <defs>
      <radialGradient
        id='x'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(79.332 21.268) rotate(132.41) scale(94.677 97.422)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.10497' stopOpacity='0.9' />
        <stop stopColor='#8E76D7' offset='.60139' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='m'
        x1='29.075'
        x2='43.751'
        y1='32.454'
        y2='85.958'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' offset='.50508' />
        <stop stopColor='#8E76D7' offset='1' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='69.227'
        x2='56.173'
        y1='74.999'
        y2='75.403'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='64.54'
        x2='61.45'
        y1='40.038'
        y2='68.892'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='52.349'
        x2='22.847'
        y1='71.627'
        y2='74.02'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='53.256'
        x2='40.75'
        y1='37.2'
        y2='39.846'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='48.569'
        x2='48.502'
        y1='32.082'
        y2='36.354'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='55.517'
        x2='43.35'
        y1='40.918'
        y2='49.705'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='48.876'
        x2='48.868'
        y1='38.795'
        y2='40.567'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='55.517'
        x2='43.35'
        y1='44.418'
        y2='53.205'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='w'
        x1='48.876'
        x2='48.868'
        y1='42.295'
        y2='44.067'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='v'
        x1='55.517'
        x2='43.35'
        y1='47.918'
        y2='56.705'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='u'
        x1='48.876'
        x2='48.868'
        y1='45.795'
        y2='47.567'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='t'
        x1='52.955'
        x2='41.416'
        y1='50.918'
        y2='58.156'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='s'
        x1='47.187'
        x2='47.178'
        y1='48.794'
        y2='50.567'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='r'
        x1='51.503'
        x2='41.76'
        y1='54.45'
        y2='61.399'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='q'
        x1='46.23'
        x2='46.224'
        y1='52.742'
        y2='54.167'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='51.503'
        x2='41.76'
        y1='57.92'
        y2='64.87'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='46.23'
        x2='46.224'
        y1='56.212'
        y2='57.638'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='n'
        x1='51.503'
        x2='41.76'
        y1='61.393'
        y2='68.343'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='46.23'
        x2='46.224'
        y1='59.686'
        y2='61.111'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='79.502'
        x2='71.252'
        y1='13'
        y2='29'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D92D20' offset='0' />
        <stop stopColor='#981F16' offset='1' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='64.454'
        x2='57.772'
        y1='69.482'
        y2='67.062'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='i'
        x1='64.216'
        x2='63.234'
        y1='55.89'
        y2='68.08'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
export const NoInternetConnectionSvg = () => (
  <svg
    width='171'
    height='172'
    fill='none'
    viewBox='0 0 171 172'
    xmlns='http://www.w3.org/2000/svg'>
    <rect
      x='.078613'
      y='.61621'
      width='170.7'
      height='170.7'
      rx='85.348'
      fill='#F0EDFA'
    />
    <path
      d='m85.679 146.16c33.136 0 59.997-26.848 59.997-59.967 0-33.119-26.861-59.967-59.997-59.967-33.136 0-59.997 26.848-59.997 59.967 0 33.119 26.862 59.967 59.997 59.967z'
      fill='url(#f)'
    />
    <path
      d='m77.489 52.174c-7.728 0.9382-14.61 2.985-21.759 6.4718-6.0016 2.927-13.729 8.3541-15.003 10.538-0.7832 1.3419-0.6954 3.3924 0.2038 4.7517 0.8732 1.3202 2.5021 2.179 4.1331 2.179 1.4851 0 1.8944-0.2068 4.4555-2.2526 20.941-16.727 50.823-16.727 71.763 0 2.56 2.0445 2.909 2.2202 4.438 2.2318 2.721 0.0211 4.829-1.9732 4.867-4.6039 0.014-0.9501-0.149-1.6838-0.512-2.306-1.277-2.1861-9.012-7.6177-15.004-10.535-7.392-3.599-13.977-5.5371-22.021-6.4816-3.9605-0.4649-11.702-0.4617-15.56 0.0066zm4.2193 18.77c-0.3626 0.0525-1.7273 0.2271-3.0326 0.3883-7.4971 0.9258-16.464 4.6493-22.213 9.2245-2.0263 1.6123-2.4171 2.1925-2.6175 3.8842-0.2993 2.5296 1.4662 4.8115 4.037 5.2181 1.5213 0.2403 2.4955-0.1544 5.2353-2.1207 2.814-2.0197 6.7466-4.0274 10.026-5.1184 11.709-3.8963 24.652-1.9782 34.54 5.1184 1.305 0.9369 2.772 1.8368 3.261 1.9996 3.083 1.0289 6.403-1.7862 6.011-5.097-0.2-1.6917-0.591-2.2719-2.618-3.8842-4.911-3.9079-12.559-7.3855-19.166-8.7147-4.4809-0.9015-10.61-1.3102-13.463-0.8981zm-2.1555 19.613c-5.4734 1.155-10.776 3.9817-11.723 6.2494-1.077 2.5787 0.4913 5.7126 3.2 6.3956 1.4201 0.358 2.5606 0.157 4.0861-0.717 3.5727-2.049 6.7041-2.9461 10.284-2.9461s6.7118 0.8971 10.284 2.9461c1.5255 0.874 2.666 1.075 4.086 0.717 2.6218-0.661 4.2298-3.7095 3.2808-6.222-0.901-2.3858-6.2332-5.2698-11.867-6.4188-3.3509-0.6831-8.4053-0.6849-11.631-0.0042z'
      clipRule='evenodd'
      fill='url(#d)'
      fillRule='evenodd'
    />
    <path
      d='m77.489 52.174c-7.728 0.9382-14.61 2.985-21.759 6.4718-6.0016 2.927-13.729 8.3541-15.003 10.538-0.7832 1.3419-0.6954 3.3924 0.2038 4.7517 0.8732 1.3202 2.5021 2.179 4.1331 2.179 1.4851 0 1.8944-0.2068 4.4555-2.2526 20.941-16.727 50.823-16.727 71.763 0 2.56 2.0445 2.909 2.2202 4.438 2.2318 2.721 0.0211 4.829-1.9732 4.867-4.6039 0.014-0.9501-0.149-1.6838-0.512-2.306-1.277-2.1861-9.012-7.6177-15.004-10.535-7.392-3.599-13.977-5.5371-22.021-6.4816-3.9605-0.4649-11.702-0.4617-15.56 0.0066zm4.2193 18.77c-0.3626 0.0525-1.7273 0.2271-3.0326 0.3883-7.4971 0.9258-16.464 4.6493-22.213 9.2245-2.0263 1.6123-2.4171 2.1925-2.6175 3.8842-0.2993 2.5296 1.4662 4.8115 4.037 5.2181 1.5213 0.2403 2.4955-0.1544 5.2353-2.1207 2.814-2.0197 6.7466-4.0274 10.026-5.1184 11.709-3.8963 24.652-1.9782 34.54 5.1184 1.305 0.9369 2.772 1.8368 3.261 1.9996 3.083 1.0289 6.403-1.7862 6.011-5.097-0.2-1.6917-0.591-2.2719-2.618-3.8842-4.911-3.9079-12.559-7.3855-19.166-8.7147-4.4809-0.9015-10.61-1.3102-13.463-0.8981zm-2.1555 19.613c-5.4734 1.155-10.776 3.9817-11.723 6.2494-1.077 2.5787 0.4913 5.7126 3.2 6.3956 1.4201 0.358 2.5606 0.157 4.0861-0.717 3.5727-2.049 6.7041-2.9461 10.284-2.9461s6.7118 0.8971 10.284 2.9461c1.5255 0.874 2.666 1.075 4.086 0.717 2.6218-0.661 4.2298-3.7095 3.2808-6.222-0.901-2.3858-6.2332-5.2698-11.867-6.4188-3.3509-0.6831-8.4053-0.6849-11.631-0.0042z'
      clipRule='evenodd'
      fill='url(#c)'
      fillRule='evenodd'
    />
    <path
      d='m93.961 116.68c0 4.714-3.8212 8.535-8.5348 8.535-4.7137 0-8.5348-3.821-8.5348-8.535s3.8211-8.535 8.5348-8.535c4.7136 0 8.5348 3.821 8.5348 8.535z'
      fill='url(#d)'
    />
    <path
      d='m93.961 116.68c0 4.714-3.8212 8.535-8.5348 8.535-4.7137 0-8.5348-3.821-8.5348-8.535s3.8211-8.535 8.5348-8.535c4.7136 0 8.5348 3.821 8.5348 8.535z'
      fill='url(#c)'
    />
    <path
      d='m155.02 136.4c1.669 0 3.021-1.353 3.021-3.021 0-1.669-1.352-3.022-3.021-3.022s-3.021 1.353-3.021 3.022c0 1.668 1.352 3.021 3.021 3.021z'
      fill='#E2D9FF'
    />
    <path
      d='m153.73 19.442c1.485 0 2.688-1.2037 2.688-2.6885s-1.203-2.6885-2.688-2.6885-2.689 1.2037-2.689 2.6885 1.204 2.6885 2.689 2.6885z'
      fill='#C5B8EA'
    />
    <path
      d='m143.37 31.132c3.299 0 5.974-2.6748 5.974-5.9743 0-3.2996-2.675-5.9744-5.974-5.9744-3.3 0-5.975 2.6748-5.975 5.9744 0 3.2995 2.675 5.9743 5.975 5.9743z'
      fill='#E2D9FF'
    />
    <path
      d='m32.411 159.15c3.2995 0 5.9743-2.675 5.9743-5.975 0-3.299-2.6748-5.974-5.9743-5.974-3.2996 0-5.9744 2.675-5.9744 5.974 0 3.3 2.6748 5.975 5.9744 5.975z'
      fill='#E2D9FF'
    />
    <path
      d='m163.85 134.62c0.943 0 1.707-0.764 1.707-1.707s-0.764-1.707-1.707-1.707-1.707 0.764-1.707 1.707 0.764 1.707 1.707 1.707z'
      fill='#C5B8EA'
    />
    <path
      d='m30.387 26.481c2.4277 0 4.3958-1.9681 4.3958-4.3959s-1.9681-4.3958-4.3958-4.3958c-2.4278 0-4.3959 1.968-4.3959 4.3958s1.9681 4.3959 4.3959 4.3959z'
      fill='#E2D9FF'
    />
    <path
      d='m16.304 26.481c1.2491 0 2.2617-1.0126 2.2617-2.2617s-1.0126-2.2617-2.2617-2.2617-2.2617 1.0126-2.2617 2.2617 1.0126 2.2617 2.2617 2.2617z'
      fill='#DCDAE3'
    />
    <path
      d='m29.43 167.05c1.4141 0 2.5605-1.147 2.5605-2.561s-1.1464-2.56-2.5605-2.56-2.5604 1.146-2.5604 2.56 1.1463 2.561 2.5604 2.561z'
      fill='#C5B8EA'
    />
    <path
      d='m68.078 66.922 6.3249-22.309 26.758 3.0822-8.9396 14.33c-0.2293 0.3676-0.147 0.8486 0.1914 1.119l6.1219 4.891c0.306 0.2445 0.4064 0.6659 0.2436 1.0221l-15.302 33.469 0.868-26.381-15.838-8.2332c-0.3595-0.1869-0.5381-0.6007-0.4276-0.9905z'
      fill='#E2D9FF'
    />
    <path
      d='m72.538 65.128 5.5119-17.43h23.112l-8.9405 14.33c-0.2293 0.3676-0.147 0.8486 0.1915 1.119l6.1219 4.8911c0.306 0.2445 0.4064 0.6658 0.2435 1.022l-15.302 33.469 3.7389-27.8c0.0468-0.3475-0.1236-0.6882-0.4297-0.8592l-13.85-7.7397c-0.3537-0.1976-0.5197-0.6165-0.3976-1.0027z'
      fill='url(#e)'
    />
    <path
      d='m80.937 14.273c0-1.4141 1.1464-2.5604 2.5605-2.5604s2.5604 1.1463 2.5604 2.5604v23.044c0 1.4141-1.1463 2.5605-2.5604 2.5605s-2.5605-1.1464-2.5605-2.5605v-23.044z'
      fill='url(#b)'
    />
    <path
      d='m80.937 14.273c0-1.4141 1.1464-2.5604 2.5605-2.5604s2.5604 1.1463 2.5604 2.5604v23.044c0 1.4141-1.1463 2.5605-2.5604 2.5605s-2.5605-1.1464-2.5605-2.5605v-23.044z'
      fill='url(#a)'
    />
    <path
      d='m96.282 23.485c0.4453-1.3512 1.9198-2.0666 3.2567-1.58 1.308 0.4763 1.983 1.923 1.507 3.2314l-4.7163 12.957c-0.338 0.9287-1.2295 1.5394-2.2176 1.5191-1.5528-0.0319-2.6321-1.5567-2.1459-3.0318l4.3161-13.096z'
      fill='url(#b)'
    />
    <path
      d='m96.282 23.485c0.4453-1.3512 1.9198-2.0666 3.2567-1.58 1.308 0.4763 1.983 1.923 1.507 3.2314l-4.7163 12.957c-0.338 0.9287-1.2295 1.5394-2.2176 1.5191-1.5528-0.0319-2.6321-1.5567-2.1459-3.0318l4.3161-13.096z'
      fill='url(#a)'
    />
    <path
      d='m68.359 32.164c-0.4726-1.2984 0.1969-2.7341 1.4953-3.2067 1.3406-0.4879 2.8172 0.2422 3.2434 1.6037l2.1996 7.0281c0.4649 1.4856-0.6275 3.0012-2.1838 3.0299-0.9966 0.0184-1.8948-0.5982-2.2358-1.5349l-2.5187-6.9201z'
      fill='url(#b)'
    />
    <path
      d='m68.359 32.164c-0.4726-1.2984 0.1969-2.7341 1.4953-3.2067 1.3406-0.4879 2.8172 0.2422 3.2434 1.6037l2.1996 7.0281c0.4649 1.4856-0.6275 3.0012-2.1838 3.0299-0.9966 0.0184-1.8948-0.5982-2.2358-1.5349l-2.5187-6.9201z'
      fill='url(#a)'
    />
    <defs>
      <radialGradient
        id='f'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='translate(85.679 86.189) rotate(92.8) scale(110.01 110.06)'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='.42872' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='d'
        x1='114.78'
        x2='44.222'
        y1='128.22'
        y2='132.82'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='89.366'
        x2='85.545'
        y1='38.096'
        y2='113.14'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='88.743'
        x2='85'
        y1='46.945'
        y2='98.34'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' offset='0' />
        <stop stopColor='#EDF1FF' offset='.41668' />
        <stop stopColor='#fff' offset='1' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='95.432'
        x2='69.663'
        y1='41.802'
        y2='43.358'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#8E76D7' offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='a'
        x1='86.154'
        x2='115.3'
        y1='6.308'
        y2='31.94'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' offset='0' />
        <stop stopColor='#fff' offset='1' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);

export const NoImageFoundSvg = () => (
  <svg
    width='172'
    height='171'
    viewBox='0 0 172 171'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M86.424 170.959C133.62 170.959 171.883 132.772 171.883 85.5002C171.883 38.2285 133.452 0.0410156 86.424 0.0410156C39.2276 0.0410156 0.964844 38.2285 0.964844 85.5002C0.964844 132.772 39.2276 170.959 86.424 170.959Z'
      fill='#F0EDFA'
    />
    <path
      d='M131.348 159.97C133.693 159.97 135.593 158.06 135.593 155.704C135.593 153.348 133.693 151.438 131.348 151.438C129.004 151.438 127.104 153.348 127.104 155.704C127.104 158.06 129.004 159.97 131.348 159.97Z'
      fill='#DCDAE3'
    />
    <path
      d='M140.671 10.6368C142.087 10.6368 143.236 9.48259 143.236 8.05886C143.236 6.63512 142.087 5.48096 140.671 5.48096C139.254 5.48096 138.105 6.63512 138.105 8.05886C138.105 9.48259 139.254 10.6368 140.671 10.6368Z'
      fill='#C5B8EA'
    />
    <path
      d='M131.781 19.6056C134.498 19.6056 136.7 17.3921 136.7 14.6617C136.7 11.9312 134.498 9.71777 131.781 9.71777C129.064 9.71777 126.861 11.9312 126.861 14.6617C126.861 17.3921 129.064 19.6056 131.781 19.6056Z'
      fill='white'
    />
    <path
      d='M34.6166 157.175C37.3335 157.175 39.536 154.961 39.536 152.231C39.536 149.501 37.3335 147.287 34.6166 147.287C31.8997 147.287 29.6973 149.501 29.6973 152.231C29.6973 154.961 31.8997 157.175 34.6166 157.175Z'
      fill='white'
    />
    <path
      d='M139.4 162.032C140.176 162.032 140.805 161.399 140.805 160.619C140.805 159.839 140.176 159.207 139.4 159.207C138.623 159.207 137.994 159.839 137.994 160.619C137.994 161.399 138.623 162.032 139.4 162.032Z'
      fill='#C5B8EA'
    />
    <path
      d='M34.5024 20.4731C36.5015 20.4731 38.122 18.8444 38.122 16.8354C38.122 14.8264 36.5015 13.1978 34.5024 13.1978C32.5034 13.1978 30.8828 14.8264 30.8828 16.8354C30.8828 18.8444 32.5034 20.4731 34.5024 20.4731Z'
      fill='#C5B8EA'
    />
    <path
      d='M22.0557 20.0289C23.0842 20.0289 23.918 19.1909 23.918 18.1573C23.918 17.1236 23.0842 16.2856 22.0557 16.2856C21.0272 16.2856 20.1934 17.1236 20.1934 18.1573C20.1934 19.1909 21.0272 20.0289 22.0557 20.0289Z'
      fill='#DCDAE3'
    />
    <path
      d='M23.7271 161.588C25.2796 161.588 26.5382 160.323 26.5382 158.763C26.5382 157.202 25.2796 155.938 23.7271 155.938C22.1746 155.938 20.916 157.202 20.916 158.763C20.916 160.323 22.1746 161.588 23.7271 161.588Z'
      fill='#C5B8EA'
    />
    <path
      d='M126.675 44.48H45.3181C39.7095 44.48 35.1484 49.0315 35.1484 54.6283V115.518C35.1484 121.115 39.7095 125.666 45.3181 125.666H126.675C132.284 125.666 136.845 121.115 136.845 115.518V54.6283C136.845 49.0315 132.284 44.48 126.675 44.48ZM58.0301 59.7024C60.053 59.7024 61.993 60.5043 63.4234 61.9317C64.8538 63.359 65.6574 65.295 65.6574 67.3136C65.6574 69.3322 64.8538 71.2682 63.4234 72.6955C61.993 74.1229 60.053 74.9248 58.0301 74.9248C56.0073 74.9248 54.0672 74.1229 52.6369 72.6955C51.2065 71.2682 50.4029 69.3322 50.4029 67.3136C50.4029 65.295 51.2065 63.359 52.6369 61.9317C54.0672 60.5043 56.0073 59.7024 58.0301 59.7024ZM85.9966 110.444H50.4029L70.7422 85.0731L78.3694 95.2214L93.6239 74.9248L121.59 110.444H85.9966Z'
      fill='#8E76D7'
    />
    <path
      d='M126.675 44.48H45.3181C39.7095 44.48 35.1484 49.0315 35.1484 54.6283V115.518C35.1484 121.115 39.7095 125.666 45.3181 125.666H126.675C132.284 125.666 136.845 121.115 136.845 115.518V54.6283C136.845 49.0315 132.284 44.48 126.675 44.48ZM58.0301 59.7024C60.053 59.7024 61.993 60.5043 63.4234 61.9317C64.8538 63.359 65.6574 65.295 65.6574 67.3136C65.6574 69.3322 64.8538 71.2682 63.4234 72.6955C61.993 74.1229 60.053 74.9248 58.0301 74.9248C56.0073 74.9248 54.0672 74.1229 52.6369 72.6955C51.2065 71.2682 50.4029 69.3322 50.4029 67.3136C50.4029 65.295 51.2065 63.359 52.6369 61.9317C54.0672 60.5043 56.0073 59.7024 58.0301 59.7024ZM85.9966 110.444H50.4029L70.7422 85.0731L78.3694 95.2214L93.6239 74.9248L121.59 110.444H85.9966Z'
      fill='url(#paint0_radial_2287_109305)'
    />
    <path
      d='M126.675 44.48H45.3181C39.7095 44.48 35.1484 49.0315 35.1484 54.6283V115.518C35.1484 121.115 39.7095 125.666 45.3181 125.666H126.675C132.284 125.666 136.845 121.115 136.845 115.518V54.6283C136.845 49.0315 132.284 44.48 126.675 44.48ZM58.0301 59.7024C60.053 59.7024 61.993 60.5043 63.4234 61.9317C64.8538 63.359 65.6574 65.295 65.6574 67.3136C65.6574 69.3322 64.8538 71.2682 63.4234 72.6955C61.993 74.1229 60.053 74.9248 58.0301 74.9248C56.0073 74.9248 54.0672 74.1229 52.6369 72.6955C51.2065 71.2682 50.4029 69.3322 50.4029 67.3136C50.4029 65.295 51.2065 63.359 52.6369 61.9317C54.0672 60.5043 56.0073 59.7024 58.0301 59.7024ZM85.9966 110.444H50.4029L70.7422 85.0731L78.3694 95.2214L93.6239 74.9248L121.59 110.444H85.9966Z'
      fill='url(#paint1_linear_2287_109305)'
      fillOpacity='0.8'
    />
    <circle
      cx='132.145'
      cy='47.4711'
      r='20.0829'
      fill='url(#paint2_linear_2287_109305)'
    />
    <path
      d='M129.281 35.9971H134.93L133.424 51.688H130.788L129.281 35.9971Z'
      fill='white'
    />
    <ellipse cx='132.106' cy='56.7083' rx='2.82436' ry='2.51054' fill='white' />
    <defs>
      <radialGradient
        id='paint0_radial_2287_109305'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(130.65 49.3471) rotate(139.692) scale(131.463 134.01)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint1_linear_2287_109305'
        x1='51.7483'
        y1='62.9556'
        x2='65.9817'
        y2='129.92'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2287_109305'
        x1='132.145'
        y1='27.3882'
        x2='115.577'
        y2='59.5208'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D92D20' />
        <stop offset='1' stopColor='#981F16' />
      </linearGradient>
    </defs>
  </svg>
);

export const NoBundleProductsSvg = () => (
  <svg
    width='200'
    height='201'
    viewBox='0 0 200 201'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 100.5C0 45.2715 44.7715 0.5 100 0.5C155.228 0.5 200 45.2715 200 100.5C200 155.728 155.228 200.5 100 200.5C44.7715 200.5 0 155.728 0 100.5Z'
      fill='#F0EDFA'
    />
    <path
      d='M181.538 159.579C183.493 159.579 185.078 157.994 185.078 156.039C185.078 154.084 183.493 152.499 181.538 152.499C179.583 152.499 177.998 154.084 177.998 156.039C177.998 157.994 179.583 159.579 181.538 159.579Z'
      fill='#E2D9FF'
    />
    <path
      d='M180.033 22.5441C181.773 22.5441 183.183 21.1338 183.183 19.3941C183.183 17.6544 181.773 16.2441 180.033 16.2441C178.293 16.2441 176.883 17.6544 176.883 19.3941C176.883 21.1338 178.293 22.5441 180.033 22.5441Z'
      fill='#C5B8EA'
    />
    <path
      d='M167.886 36.2412C171.752 36.2412 174.886 33.1072 174.886 29.2412C174.886 25.3752 171.752 22.2412 167.886 22.2412C164.02 22.2412 160.886 25.3752 160.886 29.2412C160.886 33.1072 164.02 36.2412 167.886 36.2412Z'
      fill='#E2D9FF'
    />
    <path
      d='M37.8838 186.24C41.7498 186.24 44.8838 183.106 44.8838 179.24C44.8838 175.374 41.7498 172.24 37.8838 172.24C34.0178 172.24 30.8838 175.374 30.8838 179.24C30.8838 183.106 34.0178 186.24 37.8838 186.24Z'
      fill='#E2D9FF'
    />
    <path
      d='M192.883 161.49C193.987 161.49 194.883 160.595 194.883 159.49C194.883 158.386 193.987 157.49 192.883 157.49C191.778 157.49 190.883 158.386 190.883 159.49C190.883 160.595 191.778 161.49 192.883 161.49Z'
      fill='#C5B8EA'
    />
    <path
      d='M35.5109 30.7912C38.3554 30.7912 40.6614 28.4853 40.6614 25.6407C40.6614 22.7962 38.3554 20.4902 35.5109 20.4902C32.6663 20.4902 30.3604 22.7962 30.3604 25.6407C30.3604 28.4853 32.6663 30.7912 35.5109 30.7912Z'
      fill='#E2D9FF'
    />
    <path
      d='M19.0113 30.7902C20.4749 30.7902 21.6613 29.6038 21.6613 28.1402C21.6613 26.6767 20.4749 25.4902 19.0113 25.4902C17.5478 25.4902 16.3613 26.6767 16.3613 28.1402C16.3613 29.6038 17.5478 30.7902 19.0113 30.7902Z'
      fill='#DCDAE3'
    />
    <path
      d='M34.3906 195.494C36.0475 195.494 37.3906 194.151 37.3906 192.494C37.3906 190.837 36.0475 189.494 34.3906 189.494C32.7338 189.494 31.3906 190.837 31.3906 192.494C31.3906 194.151 32.7338 195.494 34.3906 195.494Z'
      fill='#C5B8EA'
    />
    <g filter='url(#filter0_dd_9694_152332)'>
      <path
        d='M126.534 132.613H44.8749C40.1473 132.613 36.4941 129.32 36.4941 125.478V41.327C36.4941 37.3023 40.3622 34.1924 44.8749 34.1924H126.534C131.261 34.1924 134.915 37.4853 134.915 41.327V125.478C134.915 129.32 131.047 132.613 126.534 132.613Z'
        fill='url(#paint0_linear_9694_152332)'
      />
      <path
        d='M117.999 43.5431C118.311 42.6744 119.54 42.6744 119.852 43.5431L121.195 47.2838C121.331 47.6629 121.685 47.9208 122.087 47.9348L126.042 48.0718C126.958 48.1036 127.337 49.2602 126.617 49.8281L123.48 52.3038C123.167 52.5507 123.034 52.9621 123.143 53.3455L124.239 57.2003C124.49 58.0859 123.497 58.8014 122.737 58.2821L119.481 56.0578C119.146 55.8291 118.705 55.8291 118.37 56.0578L115.114 58.2821C114.354 58.8014 113.361 58.0859 113.612 57.2004L114.708 53.3455C114.817 52.9621 114.684 52.5507 114.371 52.3038L111.234 49.8281C110.514 49.2602 110.893 48.1036 111.809 48.0718L115.764 47.9348C116.166 47.9208 116.52 47.6629 116.656 47.2838L117.999 43.5431Z'
        fill='url(#paint1_radial_9694_152332)'
      />
      <path
        d='M117.999 43.5431C118.311 42.6744 119.54 42.6744 119.852 43.5431L121.195 47.2838C121.331 47.6629 121.685 47.9208 122.087 47.9348L126.042 48.0718C126.958 48.1036 127.337 49.2602 126.617 49.8281L123.48 52.3038C123.167 52.5507 123.034 52.9621 123.143 53.3455L124.239 57.2003C124.49 58.0859 123.497 58.8014 122.737 58.2821L119.481 56.0578C119.146 55.8291 118.705 55.8291 118.37 56.0578L115.114 58.2821C114.354 58.8014 113.361 58.0859 113.612 57.2004L114.708 53.3455C114.817 52.9621 114.684 52.5507 114.371 52.3038L111.234 49.8281C110.514 49.2602 110.893 48.1036 111.809 48.0718L115.764 47.9348C116.166 47.9208 116.52 47.6629 116.656 47.2838L117.999 43.5431Z'
        fill='url(#paint2_radial_9694_152332)'
      />
      <path
        d='M112.049 104.97H59.4147C57.9231 104.97 56.6445 103.679 56.6445 102.171C56.6445 100.664 57.9231 99.3721 59.4147 99.3721H112.049C113.54 99.3721 114.819 100.664 114.819 102.171C114.819 103.679 113.54 104.97 112.049 104.97Z'
        fill='url(#paint3_linear_9694_152332)'
      />
      <path
        d='M112.049 104.97H59.4147C57.9231 104.97 56.6445 103.679 56.6445 102.171C56.6445 100.664 57.9231 99.3721 59.4147 99.3721H112.049C113.54 99.3721 114.819 100.664 114.819 102.171C114.819 103.679 113.54 104.97 112.049 104.97Z'
        fill='url(#paint4_linear_9694_152332)'
      />
      <path
        d='M102.147 115.728H69.7932C67.7155 115.728 65.9346 114.392 65.9346 112.833C65.9346 111.274 67.7155 109.938 69.7932 109.938H102.147C104.224 109.938 106.005 111.274 106.005 112.833C105.708 114.392 104.224 115.728 102.147 115.728Z'
        fill='url(#paint5_linear_9694_152332)'
      />
      <path
        d='M102.147 115.728H69.7932C67.7155 115.728 65.9346 114.392 65.9346 112.833C65.9346 111.274 67.7155 109.938 69.7932 109.938H102.147C104.224 109.938 106.005 111.274 106.005 112.833C105.708 114.392 104.224 115.728 102.147 115.728Z'
        fill='url(#paint6_linear_9694_152332)'
      />
      <path
        d='M115.856 80.7446C115.643 80.314 116.069 78.9645 115.856 78.5338C115.004 77.2419 113.615 76.969 111.484 76.3231C108.501 75.4618 106.629 74.1648 104.285 73.9495C103.646 73.9495 103.007 73.7342 102.581 73.7342C95.9747 73.0882 90.4344 72.0116 78.2882 56.9391C77.0097 55.4319 76.3704 53.9247 75.0918 52.4174C73.8133 51.1255 71.6824 52.6327 68.9122 53.2787C68.273 53.494 67.8468 53.494 67.2075 53.494C65.0766 53.494 62.5195 53.2787 60.1755 53.0634C56.9792 52.6327 58.897 50.9102 55.0613 75.672C54.8483 77.6099 54.6352 79.3325 54.4221 81.2704C54.209 82.7776 54.209 84.5002 54.209 86.0074C54.209 86.6534 54.4221 87.73 55.0613 87.73C65.2897 88.8066 71.8955 88.376 88.0904 88.1606C96.1878 88.1606 104.285 88.1606 112.383 86.6534L114.3 86.4381C116.005 86.2228 117.71 85.5768 117.71 84.5002C117.71 82.9929 116.282 82.2519 115.856 80.7446Z'
        fill='#8E76D7'
      />
      <path
        d='M104.284 74.1687L102.367 79.7671C91.9251 79.3364 81.2706 72.6615 75.7302 64.0487C73.8124 61.0342 72.3208 57.8044 70.1899 55.2205C70.1899 55.2205 69.5506 54.3592 68.6982 53.7133C71.4684 53.0673 73.5993 51.5601 74.8779 52.852C75.9433 53.9286 76.3695 54.7899 77.2219 55.8665C77.4349 56.2971 77.648 56.5124 77.8611 56.9431C77.8611 57.1584 78.0742 57.1584 78.0742 57.3737C78.7135 58.235 79.5658 59.0963 80.2051 59.9576C80.4182 60.1729 80.6313 60.3882 80.8444 60.8189C81.6968 61.6801 82.336 62.5414 83.1884 63.4027C83.4015 63.618 83.6146 63.8333 83.8277 64.264C84.68 65.1253 85.3193 65.9865 86.1717 66.6325C86.3847 66.8478 86.8109 67.0632 87.024 67.4938C87.8764 68.1398 88.5156 68.7857 89.1549 69.4317C89.5811 69.647 89.7942 69.8623 90.2204 70.293C90.8596 70.7236 91.2858 71.1542 91.9251 71.3696C92.3513 71.5849 92.7775 71.8002 92.9905 72.0155C94.056 72.6615 95.1214 73.0921 96.1869 73.5228C96.6131 73.7381 97.0393 73.7381 97.4654 73.9534C99.1702 74.3841 100.662 74.5994 102.367 74.8147C103.006 73.9534 103.645 73.9534 104.284 74.1687Z'
        fill='#413BBC'
      />
      <path
        d='M117.71 84.7092C117.71 85.7858 115.792 86.4317 114.3 86.6471L112.383 86.8624C104.498 88.3696 96.1878 88.3696 88.0904 88.3696C71.8955 88.3696 65.5028 88.8003 55.0613 87.939C54.209 87.939 54.209 86.8624 54.209 86.2164C54.209 84.4939 54.209 82.9866 54.4221 81.4794C60.1755 81.91 84.4678 83.2019 103.007 81.264C108.121 80.6181 112.809 79.9721 116.431 78.8955C116.644 79.3261 116.858 79.7568 117.071 80.1874C117.497 81.4794 117.71 82.9866 117.71 84.7092Z'
        fill='#8E76D7'
      />
      <path
        d='M117.71 84.7092C117.71 85.7858 115.792 86.4317 114.3 86.6471L112.383 86.8624C104.498 88.3696 96.1878 88.3696 88.0904 88.3696C71.8955 88.3696 65.5028 88.8003 55.0613 87.939C54.209 87.939 54.209 86.8624 54.209 86.2164C54.209 84.4939 54.209 82.9866 54.4221 81.4794C60.1755 81.91 84.4678 83.2019 103.007 81.264C108.121 80.6181 112.809 79.9721 116.431 78.8955C116.644 79.3261 116.858 79.7568 117.071 80.1874C117.497 81.4794 117.71 82.9866 117.71 84.7092Z'
        fill='url(#paint7_radial_9694_152332)'
      />
      <path
        d='M117.71 84.7092C117.71 85.7858 115.792 86.4317 114.3 86.6471L112.383 86.8624C104.498 88.3696 96.1878 88.3696 88.0904 88.3696C71.8955 88.3696 65.5028 88.8003 55.0613 87.939C54.209 87.939 54.209 86.8624 54.209 86.2164C54.209 84.4939 54.209 82.9866 54.4221 81.4794C60.1755 81.91 84.4678 83.2019 103.007 81.264C108.121 80.6181 112.809 79.9721 116.431 78.8955C116.644 79.3261 116.858 79.7568 117.071 80.1874C117.497 81.4794 117.71 82.9866 117.71 84.7092Z'
        fill='url(#paint8_linear_9694_152332)'
        fillOpacity='0.8'
      />
      <path
        d='M117.071 79.9797C113.236 81.2716 109.4 82.1329 105.351 82.3482C104.712 82.3482 104.073 82.3482 103.647 82.1329C103.007 81.9175 103.007 81.4869 102.794 81.0563C102.794 80.8409 102.794 80.6256 102.794 80.4103C102.581 78.2571 102.368 75.8886 102.368 73.7354C105.138 73.9507 108.122 74.166 111.744 75.4579C113.875 76.1039 115.367 77.1805 116.219 78.6877C116.645 79.1184 116.858 79.549 117.071 79.9797Z'
        fill='url(#paint9_linear_9694_152332)'
      />
      <path
        d='M117.071 79.9797C113.236 81.2716 109.4 82.1329 105.351 82.3482C104.712 82.3482 104.073 82.3482 103.647 82.1329C103.007 81.9175 103.007 81.4869 102.794 81.0563C102.794 80.8409 102.794 80.6256 102.794 80.4103C102.581 78.2571 102.368 75.8886 102.368 73.7354C105.138 73.9507 108.122 74.166 111.744 75.4579C113.875 76.1039 115.367 77.1805 116.219 78.6877C116.645 79.1184 116.858 79.549 117.071 79.9797Z'
        fill='url(#paint10_linear_9694_152332)'
      />
      <path
        d='M77.8641 56.7285C77.8641 56.9438 77.8641 56.9438 77.8641 56.7285L75.0939 58.8817C74.8808 58.8817 74.8808 59.097 74.6677 59.097C74.4546 59.097 74.2415 59.097 74.2415 58.8817C74.0284 58.6664 74.0284 58.2357 74.4546 58.0204L77.2248 55.8672H77.4379C77.4379 56.0825 77.651 56.5132 77.8641 56.7285Z'
        fill='url(#paint11_linear_9694_152332)'
      />
      <path
        d='M77.8641 56.7285C77.8641 56.9438 77.8641 56.9438 77.8641 56.7285L75.0939 58.8817C74.8808 58.8817 74.8808 59.097 74.6677 59.097C74.4546 59.097 74.2415 59.097 74.2415 58.8817C74.0284 58.6664 74.0284 58.2357 74.4546 58.0204L77.2248 55.8672H77.4379C77.4379 56.0825 77.651 56.5132 77.8641 56.7285Z'
        fill='url(#paint12_linear_9694_152332)'
      />
      <path
        d='M81.0576 60.3838C81.0576 60.5991 81.0576 60.5991 80.8445 60.8144C79.9922 61.6757 79.1398 62.537 78.0744 63.3982C77.8613 63.3982 77.8613 63.6136 77.6482 63.6136C77.4351 63.6136 77.222 63.6136 77.222 63.3982C77.0089 63.1829 77.0089 62.7523 77.4351 62.537C78.2875 61.891 79.1398 61.0297 79.9922 60.1684C80.2053 59.9531 80.2053 59.9531 80.4184 59.9531C80.4184 59.9531 80.8445 60.1684 81.0576 60.3838Z'
        fill='url(#paint13_linear_9694_152332)'
      />
      <path
        d='M81.0576 60.3838C81.0576 60.5991 81.0576 60.5991 80.8445 60.8144C79.9922 61.6757 79.1398 62.537 78.0744 63.3982C77.8613 63.3982 77.8613 63.6136 77.6482 63.6136C77.4351 63.6136 77.222 63.6136 77.222 63.3982C77.0089 63.1829 77.0089 62.7523 77.4351 62.537C78.2875 61.891 79.1398 61.0297 79.9922 60.1684C80.2053 59.9531 80.2053 59.9531 80.4184 59.9531C80.4184 59.9531 80.8445 60.1684 81.0576 60.3838Z'
        fill='url(#paint14_linear_9694_152332)'
      />
      <path
        d='M83.8294 63.8305C83.8294 64.0459 83.8294 64.0459 83.6163 64.2612C82.764 65.1225 81.6985 66.1991 80.8462 67.0603C80.6331 67.2757 80.6331 67.2757 80.42 67.2757C80.2069 67.2757 79.9938 67.2757 79.9938 67.0603C79.7807 66.845 79.7807 66.4144 79.9938 66.1991C80.8462 65.3378 81.9116 64.2612 82.764 63.3999C82.9771 63.1846 82.9771 63.1846 83.1902 63.1846C83.4033 63.1846 83.6163 63.6152 83.8294 63.8305Z'
        fill='url(#paint15_linear_9694_152332)'
      />
      <path
        d='M83.8294 63.8305C83.8294 64.0459 83.8294 64.0459 83.6163 64.2612C82.764 65.1225 81.6985 66.1991 80.8462 67.0603C80.6331 67.2757 80.6331 67.2757 80.42 67.2757C80.2069 67.2757 79.9938 67.2757 79.9938 67.0603C79.7807 66.845 79.7807 66.4144 79.9938 66.1991C80.8462 65.3378 81.9116 64.2612 82.764 63.3999C82.9771 63.1846 82.9771 63.1846 83.1902 63.1846C83.4033 63.1846 83.6163 63.6152 83.8294 63.8305Z'
        fill='url(#paint16_linear_9694_152332)'
      />
      <path
        d='M87.0257 66.8447C87.0257 67.06 87.0256 67.06 86.8126 67.2753C85.7471 68.1366 84.6817 69.2132 84.0424 70.2898C83.8293 70.5051 83.8293 70.5051 83.6162 70.5051C83.4031 70.5051 83.4031 70.5051 83.19 70.2898C82.9769 70.0745 82.7638 69.6439 82.9769 69.4285C83.8293 68.3519 84.8947 67.2753 85.9602 66.1987C85.9602 66.1987 86.1733 66.1987 86.1733 65.9834C86.5995 66.414 86.8126 66.6294 87.0257 66.8447Z'
        fill='url(#paint17_linear_9694_152332)'
      />
      <path
        d='M87.0257 66.8447C87.0257 67.06 87.0256 67.06 86.8126 67.2753C85.7471 68.1366 84.6817 69.2132 84.0424 70.2898C83.8293 70.5051 83.8293 70.5051 83.6162 70.5051C83.4031 70.5051 83.4031 70.5051 83.19 70.2898C82.9769 70.0745 82.7638 69.6439 82.9769 69.4285C83.8293 68.3519 84.8947 67.2753 85.9602 66.1987C85.9602 66.1987 86.1733 66.1987 86.1733 65.9834C86.5995 66.414 86.8126 66.6294 87.0257 66.8447Z'
        fill='url(#paint18_linear_9694_152332)'
      />
      <path
        d='M90.2192 69.4248C90.2192 69.4248 90.2192 69.6401 90.2192 69.4248C89.5799 70.7167 88.9406 72.0086 88.0883 73.3006C87.8752 73.5159 87.6621 73.7312 87.449 73.7312H87.2359C87.0228 73.5159 86.8097 73.0852 87.0228 72.8699C87.6621 71.578 88.3014 70.2861 88.9406 69.2095L89.1537 68.9941C89.5799 68.9941 89.793 69.2095 90.2192 69.4248Z'
        fill='url(#paint19_linear_9694_152332)'
      />
      <path
        d='M90.2192 69.4248C90.2192 69.4248 90.2192 69.6401 90.2192 69.4248C89.5799 70.7167 88.9406 72.0086 88.0883 73.3006C87.8752 73.5159 87.6621 73.7312 87.449 73.7312H87.2359C87.0228 73.5159 86.8097 73.0852 87.0228 72.8699C87.6621 71.578 88.3014 70.2861 88.9406 69.2095L89.1537 68.9941C89.5799 68.9941 89.793 69.2095 90.2192 69.4248Z'
        fill='url(#paint20_linear_9694_152332)'
      />
      <path
        d='M92.992 71.3652L92.3528 75.241C92.3528 75.6716 91.9266 75.8869 91.7135 75.8869C91.2873 75.8869 91.0742 75.4563 91.0742 75.0256L91.7135 70.7192C91.7135 70.5039 91.7135 70.5039 91.9266 70.5039C92.3528 70.9345 92.5658 71.1499 92.992 71.3652Z'
        fill='url(#paint21_linear_9694_152332)'
      />
      <path
        d='M92.992 71.3652L92.3528 75.241C92.3528 75.6716 91.9266 75.8869 91.7135 75.8869C91.2873 75.8869 91.0742 75.4563 91.0742 75.0256L91.7135 70.7192C91.7135 70.5039 91.7135 70.5039 91.9266 70.5039C92.3528 70.9345 92.5658 71.1499 92.992 71.3652Z'
        fill='url(#paint22_linear_9694_152332)'
      />
      <path
        d='M97.4653 73.0942C97.2522 74.1708 97.0391 75.4627 96.826 76.5393C96.826 76.7547 96.3998 76.97 96.1867 76.97C96.1867 76.97 96.1867 76.97 95.9736 76.97C95.5475 76.97 95.3344 76.5393 95.5475 76.1087C95.7606 75.0321 95.9736 73.7402 96.1867 72.6636C96.1867 72.6636 96.1867 72.6636 96.1867 72.4482C96.6129 72.8789 97.0391 73.0942 97.4653 73.0942Z'
        fill='url(#paint23_linear_9694_152332)'
      />
      <path
        d='M97.4653 73.0942C97.2522 74.1708 97.0391 75.4627 96.826 76.5393C96.826 76.7547 96.3998 76.97 96.1867 76.97C96.1867 76.97 96.1867 76.97 95.9736 76.97C95.5475 76.97 95.3344 76.5393 95.5475 76.1087C95.7606 75.0321 95.9736 73.7402 96.1867 72.6636C96.1867 72.6636 96.1867 72.6636 96.1867 72.4482C96.6129 72.8789 97.0391 73.0942 97.4653 73.0942Z'
        fill='url(#paint24_linear_9694_152332)'
      />
      <path
        d='M65.715 69.6449C68.6571 69.6449 71.0422 67.2349 71.0422 64.2619C71.0422 61.289 68.6571 58.8789 65.715 58.8789C62.7728 58.8789 60.3877 61.289 60.3877 64.2619C60.3877 67.2349 62.7728 69.6449 65.715 69.6449Z'
        fill='url(#paint25_linear_9694_152332)'
      />
      <path
        d='M65.7149 66.4168C66.8918 66.4168 67.8458 65.4527 67.8458 64.2636C67.8458 63.0744 66.8918 62.1104 65.7149 62.1104C64.538 62.1104 63.584 63.0744 63.584 64.2636C63.584 65.4527 64.538 66.4168 65.7149 66.4168Z'
        fill='url(#paint26_linear_9694_152332)'
      />
      <path
        d='M65.7149 66.4168C66.8918 66.4168 67.8458 65.4527 67.8458 64.2636C67.8458 63.0744 66.8918 62.1104 65.7149 62.1104C64.538 62.1104 63.584 63.0744 63.584 64.2636C63.584 65.4527 64.538 66.4168 65.7149 66.4168Z'
        fill='url(#paint27_linear_9694_152332)'
      />
    </g>
    <g filter='url(#filter1_dd_9694_152332)'>
      <path
        d='M155.125 166.807H73.4657C68.7381 166.807 65.085 163.514 65.085 159.673V75.5213C65.085 71.4967 68.953 68.3867 73.4657 68.3867H155.125C159.852 68.3867 163.505 71.6796 163.505 75.5213V159.673C163.505 163.514 159.637 166.807 155.125 166.807Z'
        fill='url(#paint28_linear_9694_152332)'
      />
      <path
        d='M146.59 77.7375C146.902 76.8688 148.131 76.8688 148.443 77.7375L149.786 81.4782C149.922 81.8573 150.276 82.1151 150.678 82.1291L154.633 82.2662C155.549 82.2979 155.928 83.4546 155.208 84.0224L152.071 86.4981C151.758 86.7451 151.625 87.1564 151.734 87.5398L152.829 91.3947C153.081 92.2802 152.088 92.9957 151.328 92.4764L148.071 90.2521C147.737 90.0234 147.296 90.0234 146.961 90.2521L143.705 92.4764C142.945 92.9957 141.952 92.2802 142.203 91.3947L143.299 87.5398C143.408 87.1564 143.275 86.7451 142.962 86.4981L139.824 84.0224C139.105 83.4546 139.484 82.2979 140.4 82.2662L144.354 82.1291C144.757 82.1151 145.11 81.8573 145.247 81.4782L146.59 77.7375Z'
        fill='url(#paint29_radial_9694_152332)'
      />
      <path
        d='M146.59 77.7375C146.902 76.8688 148.131 76.8688 148.443 77.7375L149.786 81.4782C149.922 81.8573 150.276 82.1151 150.678 82.1291L154.633 82.2662C155.549 82.2979 155.928 83.4546 155.208 84.0224L152.071 86.4981C151.758 86.7451 151.625 87.1564 151.734 87.5398L152.829 91.3947C153.081 92.2802 152.088 92.9957 151.328 92.4764L148.071 90.2521C147.737 90.0234 147.296 90.0234 146.961 90.2521L143.705 92.4764C142.945 92.9957 141.952 92.2802 142.203 91.3947L143.299 87.5398C143.408 87.1564 143.275 86.7451 142.962 86.4981L139.824 84.0224C139.105 83.4546 139.484 82.2979 140.4 82.2662L144.354 82.1291C144.757 82.1151 145.11 81.8573 145.247 81.4782L146.59 77.7375Z'
        fill='url(#paint30_radial_9694_152332)'
      />
      <path
        d='M140.639 139.165H88.0056C86.5139 139.165 85.2354 137.873 85.2354 136.366C85.2354 134.858 86.5139 133.566 88.0056 133.566H140.639C142.131 133.566 143.41 134.858 143.41 136.366C143.41 137.873 142.131 139.165 140.639 139.165Z'
        fill='url(#paint31_linear_9694_152332)'
      />
      <path
        d='M140.639 139.165H88.0056C86.5139 139.165 85.2354 137.873 85.2354 136.366C85.2354 134.858 86.5139 133.566 88.0056 133.566H140.639C142.131 133.566 143.41 134.858 143.41 136.366C143.41 137.873 142.131 139.165 140.639 139.165Z'
        fill='url(#paint32_linear_9694_152332)'
      />
      <path
        d='M130.737 149.922H98.3841C96.3063 149.922 94.5254 148.586 94.5254 147.028C94.5254 145.469 96.3063 144.133 98.3841 144.133H130.737C132.815 144.133 134.596 145.469 134.596 147.028C134.299 148.586 132.815 149.922 130.737 149.922Z'
        fill='url(#paint33_linear_9694_152332)'
      />
      <path
        d='M130.737 149.922H98.3841C96.3063 149.922 94.5254 148.586 94.5254 147.028C94.5254 145.469 96.3063 144.133 98.3841 144.133H130.737C132.815 144.133 134.596 145.469 134.596 147.028C134.299 148.586 132.815 149.922 130.737 149.922Z'
        fill='url(#paint34_linear_9694_152332)'
      />
      <path
        d='M144.447 114.939C144.234 114.508 144.66 113.159 144.447 112.728C143.595 111.436 142.206 111.163 140.075 110.517C137.092 109.656 135.22 108.359 132.876 108.144C132.237 108.144 131.598 107.928 131.171 107.928C124.566 107.283 119.025 106.206 106.879 91.1335C105.6 89.6262 104.961 88.119 103.683 86.6118C102.404 85.3198 100.273 86.8271 97.503 87.473C96.8638 87.6884 96.4376 87.6884 95.7983 87.6884C93.6674 87.6884 91.1103 87.473 88.7663 87.2577C85.57 86.8271 87.4878 85.1045 83.6522 109.866C83.4391 111.804 83.226 113.527 83.0129 115.465C82.7998 116.972 82.7998 118.695 82.7998 120.202C82.7998 120.848 83.0129 121.924 83.6522 121.924C93.8805 123.001 100.486 122.57 116.681 122.355C124.779 122.355 132.876 122.355 140.973 120.848L142.891 120.632C144.596 120.417 146.301 119.771 146.301 118.695C146.301 117.187 144.873 116.446 144.447 114.939Z'
        fill='#8E76D7'
      />
      <path
        d='M132.875 108.363L130.957 113.961C120.516 113.531 109.861 106.856 104.321 98.243C102.403 95.2285 100.912 91.9987 98.7807 89.4149C98.7807 89.4149 98.1414 88.5536 97.2891 87.9076C100.059 87.2616 102.19 85.7544 103.469 87.0463C104.534 88.1229 104.96 88.9842 105.813 90.0608C106.026 90.4915 106.239 90.7068 106.452 91.1374C106.452 91.3527 106.665 91.3527 106.665 91.5681C107.304 92.4293 108.157 93.2906 108.796 94.1519C109.009 94.3672 109.222 94.5825 109.435 95.0132C110.288 95.8745 110.927 96.7357 111.779 97.597C111.992 97.8124 112.205 98.0277 112.418 98.4583C113.271 99.3196 113.91 100.181 114.762 100.827C114.976 101.042 115.402 101.257 115.615 101.688C116.467 102.334 117.106 102.98 117.746 103.626C118.172 103.841 118.385 104.057 118.811 104.487C119.45 104.918 119.877 105.349 120.516 105.564C120.942 105.779 121.368 105.995 121.581 106.21C122.647 106.856 123.712 107.286 124.778 107.717C125.204 107.932 125.63 107.932 126.056 108.148C127.761 108.578 129.253 108.794 130.957 109.009C131.597 108.148 132.236 108.148 132.875 108.363Z'
        fill='#413BBC'
      />
      <path
        d='M146.301 118.904C146.301 119.98 144.383 120.626 142.891 120.841L140.973 121.057C133.089 122.564 124.779 122.564 116.681 122.564C100.486 122.564 94.0936 122.995 83.6522 122.133C82.7998 122.133 82.7998 121.057 82.7998 120.411C82.7998 118.688 82.7998 117.181 83.0129 115.674C88.7663 116.104 113.059 117.396 131.598 115.458C136.712 114.812 141.4 114.166 145.022 113.09C145.235 113.52 145.448 113.951 145.661 114.382C146.088 115.674 146.301 117.181 146.301 118.904Z'
        fill='#8E76D7'
      />
      <path
        d='M146.301 118.904C146.301 119.98 144.383 120.626 142.891 120.841L140.973 121.057C133.089 122.564 124.779 122.564 116.681 122.564C100.486 122.564 94.0936 122.995 83.6522 122.133C82.7998 122.133 82.7998 121.057 82.7998 120.411C82.7998 118.688 82.7998 117.181 83.0129 115.674C88.7663 116.104 113.059 117.396 131.598 115.458C136.712 114.812 141.4 114.166 145.022 113.09C145.235 113.52 145.448 113.951 145.661 114.382C146.088 115.674 146.301 117.181 146.301 118.904Z'
        fill='url(#paint35_radial_9694_152332)'
      />
      <path
        d='M146.301 118.904C146.301 119.98 144.383 120.626 142.891 120.841L140.973 121.057C133.089 122.564 124.779 122.564 116.681 122.564C100.486 122.564 94.0936 122.995 83.6522 122.133C82.7998 122.133 82.7998 121.057 82.7998 120.411C82.7998 118.688 82.7998 117.181 83.0129 115.674C88.7663 116.104 113.059 117.396 131.598 115.458C136.712 114.812 141.4 114.166 145.022 113.09C145.235 113.52 145.448 113.951 145.661 114.382C146.088 115.674 146.301 117.181 146.301 118.904Z'
        fill='url(#paint36_linear_9694_152332)'
        fillOpacity='0.8'
      />
      <path
        d='M145.662 114.174C141.827 115.466 137.991 116.327 133.942 116.543C133.303 116.543 132.664 116.543 132.238 116.327C131.598 116.112 131.598 115.681 131.385 115.251C131.385 115.035 131.385 114.82 131.385 114.605C131.172 112.451 130.959 110.083 130.959 107.93C133.729 108.145 136.712 108.36 140.335 109.652C142.466 110.298 143.957 111.375 144.81 112.882C145.236 113.313 145.449 113.743 145.662 114.174Z'
        fill='url(#paint37_linear_9694_152332)'
      />
      <path
        d='M145.662 114.174C141.827 115.466 137.991 116.327 133.942 116.543C133.303 116.543 132.664 116.543 132.238 116.327C131.598 116.112 131.598 115.681 131.385 115.251C131.385 115.035 131.385 114.82 131.385 114.605C131.172 112.451 130.959 110.083 130.959 107.93C133.729 108.145 136.712 108.36 140.335 109.652C142.466 110.298 143.957 111.375 144.81 112.882C145.236 113.313 145.449 113.743 145.662 114.174Z'
        fill='url(#paint38_linear_9694_152332)'
      />
      <path
        d='M106.455 90.9228C106.455 91.1381 106.455 91.1381 106.455 90.9228L103.685 93.076C103.472 93.076 103.472 93.2913 103.259 93.2913C103.045 93.2913 102.832 93.2913 102.832 93.076C102.619 92.8607 102.619 92.43 103.045 92.2147L105.816 90.0615H106.029C106.029 90.2768 106.242 90.7075 106.455 90.9228Z'
        fill='url(#paint39_linear_9694_152332)'
      />
      <path
        d='M106.455 90.9228C106.455 91.1381 106.455 91.1381 106.455 90.9228L103.685 93.076C103.472 93.076 103.472 93.2913 103.259 93.2913C103.045 93.2913 102.832 93.2913 102.832 93.076C102.619 92.8607 102.619 92.43 103.045 92.2147L105.816 90.0615H106.029C106.029 90.2768 106.242 90.7075 106.455 90.9228Z'
        fill='url(#paint40_linear_9694_152332)'
      />
      <path
        d='M109.648 94.5781C109.648 94.7934 109.648 94.7934 109.435 95.0087C108.583 95.87 107.731 96.7313 106.665 97.5926C106.452 97.5926 106.452 97.8079 106.239 97.8079C106.026 97.8079 105.813 97.8079 105.813 97.5926C105.6 97.3773 105.6 96.9466 106.026 96.7313C106.878 96.0853 107.731 95.2241 108.583 94.3628C108.796 94.1475 108.796 94.1475 109.009 94.1475C109.009 94.1475 109.435 94.3628 109.648 94.5781Z'
        fill='url(#paint41_linear_9694_152332)'
      />
      <path
        d='M109.648 94.5781C109.648 94.7934 109.648 94.7934 109.435 95.0087C108.583 95.87 107.731 96.7313 106.665 97.5926C106.452 97.5926 106.452 97.8079 106.239 97.8079C106.026 97.8079 105.813 97.8079 105.813 97.5926C105.6 97.3773 105.6 96.9466 106.026 96.7313C106.878 96.0853 107.731 95.2241 108.583 94.3628C108.796 94.1475 108.796 94.1475 109.009 94.1475C109.009 94.1475 109.435 94.3628 109.648 94.5781Z'
        fill='url(#paint42_linear_9694_152332)'
      />
      <path
        d='M112.42 98.0249C112.42 98.2402 112.42 98.2402 112.207 98.4555C111.355 99.3168 110.289 100.393 109.437 101.255C109.224 101.47 109.224 101.47 109.011 101.47C108.798 101.47 108.585 101.47 108.585 101.255C108.372 101.039 108.372 100.609 108.585 100.393C109.437 99.5321 110.502 98.4555 111.355 97.5942C111.568 97.3789 111.568 97.3789 111.781 97.3789C111.994 97.3789 112.207 97.8095 112.42 98.0249Z'
        fill='url(#paint43_linear_9694_152332)'
      />
      <path
        d='M112.42 98.0249C112.42 98.2402 112.42 98.2402 112.207 98.4555C111.355 99.3168 110.289 100.393 109.437 101.255C109.224 101.47 109.224 101.47 109.011 101.47C108.798 101.47 108.585 101.47 108.585 101.255C108.372 101.039 108.372 100.609 108.585 100.393C109.437 99.5321 110.502 98.4555 111.355 97.5942C111.568 97.3789 111.568 97.3789 111.781 97.3789C111.994 97.3789 112.207 97.8095 112.42 98.0249Z'
        fill='url(#paint44_linear_9694_152332)'
      />
      <path
        d='M115.616 101.039C115.616 101.254 115.616 101.254 115.403 101.47C114.338 102.331 113.272 103.408 112.633 104.484C112.42 104.699 112.42 104.699 112.207 104.699C111.994 104.699 111.994 104.699 111.781 104.484C111.568 104.269 111.355 103.838 111.568 103.623C112.42 102.546 113.486 101.47 114.551 100.393C114.551 100.393 114.764 100.393 114.764 100.178C115.19 100.608 115.403 100.824 115.616 101.039Z'
        fill='url(#paint45_linear_9694_152332)'
      />
      <path
        d='M115.616 101.039C115.616 101.254 115.616 101.254 115.403 101.47C114.338 102.331 113.272 103.408 112.633 104.484C112.42 104.699 112.42 104.699 112.207 104.699C111.994 104.699 111.994 104.699 111.781 104.484C111.568 104.269 111.355 103.838 111.568 103.623C112.42 102.546 113.486 101.47 114.551 100.393C114.551 100.393 114.764 100.393 114.764 100.178C115.19 100.608 115.403 100.824 115.616 101.039Z'
        fill='url(#paint46_linear_9694_152332)'
      />
      <path
        d='M118.81 103.619C118.81 103.619 118.81 103.834 118.81 103.619C118.171 104.911 117.531 106.203 116.679 107.495C116.466 107.71 116.253 107.926 116.04 107.926H115.827C115.614 107.71 115.401 107.28 115.614 107.064C116.253 105.772 116.892 104.48 117.531 103.404L117.745 103.188C118.171 103.188 118.384 103.404 118.81 103.619Z'
        fill='url(#paint47_linear_9694_152332)'
      />
      <path
        d='M118.81 103.619C118.81 103.619 118.81 103.834 118.81 103.619C118.171 104.911 117.531 106.203 116.679 107.495C116.466 107.71 116.253 107.926 116.04 107.926H115.827C115.614 107.71 115.401 107.28 115.614 107.064C116.253 105.772 116.892 104.48 117.531 103.404L117.745 103.188C118.171 103.188 118.384 103.404 118.81 103.619Z'
        fill='url(#paint48_linear_9694_152332)'
      />
      <path
        d='M121.583 105.56L120.944 109.435C120.944 109.866 120.517 110.081 120.304 110.081C119.878 110.081 119.665 109.651 119.665 109.22L120.304 104.914C120.304 104.698 120.304 104.698 120.517 104.698C120.944 105.129 121.157 105.344 121.583 105.56Z'
        fill='url(#paint49_linear_9694_152332)'
      />
      <path
        d='M121.583 105.56L120.944 109.435C120.944 109.866 120.517 110.081 120.304 110.081C119.878 110.081 119.665 109.651 119.665 109.22L120.304 104.914C120.304 104.698 120.304 104.698 120.517 104.698C120.944 105.129 121.157 105.344 121.583 105.56Z'
        fill='url(#paint50_linear_9694_152332)'
      />
      <path
        d='M126.056 107.289C125.843 108.365 125.63 109.657 125.417 110.734C125.417 110.949 124.991 111.164 124.778 111.164C124.778 111.164 124.778 111.164 124.564 111.164C124.138 111.164 123.925 110.734 124.138 110.303C124.351 109.226 124.564 107.935 124.778 106.858C124.778 106.858 124.778 106.858 124.778 106.643C125.204 107.073 125.63 107.289 126.056 107.289Z'
        fill='url(#paint51_linear_9694_152332)'
      />
      <path
        d='M126.056 107.289C125.843 108.365 125.63 109.657 125.417 110.734C125.417 110.949 124.991 111.164 124.778 111.164C124.778 111.164 124.778 111.164 124.564 111.164C124.138 111.164 123.925 110.734 124.138 110.303C124.351 109.226 124.564 107.935 124.778 106.858C124.778 106.858 124.778 106.858 124.778 106.643C125.204 107.073 125.63 107.289 126.056 107.289Z'
        fill='url(#paint52_linear_9694_152332)'
      />
      <path
        d='M94.3058 103.839C97.2479 103.839 99.633 101.429 99.633 98.4563C99.633 95.4833 97.2479 93.0732 94.3058 93.0732C91.3636 93.0732 88.9785 95.4833 88.9785 98.4563C88.9785 101.429 91.3636 103.839 94.3058 103.839Z'
        fill='url(#paint53_linear_9694_152332)'
      />
      <path
        d='M94.3057 100.611C95.4826 100.611 96.4366 99.6471 96.4366 98.4579C96.4366 97.2687 95.4826 96.3047 94.3057 96.3047C93.1288 96.3047 92.1748 97.2687 92.1748 98.4579C92.1748 99.6471 93.1288 100.611 94.3057 100.611Z'
        fill='url(#paint54_linear_9694_152332)'
      />
      <path
        d='M94.3057 100.611C95.4826 100.611 96.4366 99.6471 96.4366 98.4579C96.4366 97.2687 95.4826 96.3047 94.3057 96.3047C93.1288 96.3047 92.1748 97.2687 92.1748 98.4579C92.1748 99.6471 93.1288 100.611 94.3057 100.611Z'
        fill='url(#paint55_linear_9694_152332)'
      />
    </g>
    <path
      d='M95.747 166.835V166.835C95.7663 168.659 93.564 169.588 92.2715 168.301L34.9517 111.246C33.5553 109.856 34.5129 107.47 36.4827 107.432V107.432'
      stroke='#C5B8EA'
      strokeWidth='1.67'
    />
    <path
      d='M62.8408 146.105C66.6162 146.105 69.6768 143.045 69.6768 139.27C69.6768 135.494 66.6162 132.434 62.8408 132.434C59.0654 132.434 56.0049 135.494 56.0049 139.27C56.0049 143.045 59.0654 146.105 62.8408 146.105Z'
      fill='#413BBC'
      stroke='#413BBC'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <filter
        id='filter0_dd_9694_152332'
        x='31.4941'
        y='33.1924'
        width='108.421'
        height='108.421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='2'
          operator='erode'
          in='SourceAlpha'
          result='effect1_dropShadow_9694_152332'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_9694_152332'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='1'
          operator='erode'
          in='SourceAlpha'
          result='effect2_dropShadow_9694_152332'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='3' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_9694_152332'
          result='effect2_dropShadow_9694_152332'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_9694_152332'
          result='shape'
        />
      </filter>
      <filter
        id='filter1_dd_9694_152332'
        x='60.085'
        y='67.3867'
        width='108.421'
        height='108.421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='2'
          operator='erode'
          in='SourceAlpha'
          result='effect1_dropShadow_9694_152332'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_9694_152332'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='1'
          operator='erode'
          in='SourceAlpha'
          result='effect2_dropShadow_9694_152332'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='3' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_9694_152332'
          result='effect2_dropShadow_9694_152332'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_9694_152332'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_9694_152332'
        x1='85.7044'
        y1='43.8388'
        x2='85.7044'
        y2='132.613'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F6F6F6' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(113.754 46.9851) rotate(40.3645) scale(12.9171 13.3904)'>
        <stop stopColor='#FFCC02' />
        <stop offset='1' stopColor='#FFCC02' stopOpacity='0' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(126.057 44.0325) rotate(130.101) scale(12.2236 12.6714)'>
        <stop offset='0.078125' stopColor='#B28C35' />
        <stop offset='0.801556' stopColor='#FFCC02' />
      </radialGradient>
      <linearGradient
        id='paint3_linear_9694_152332'
        x1='104.65'
        y1='105.199'
        x2='69.6256'
        y2='124.449'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_9694_152332'
        x1='88.2905'
        y1='98.3253'
        x2='88.2559'
        y2='104.064'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_9694_152332'
        x1='99.0007'
        y1='115.965'
        x2='71.3008'
        y2='126.105'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_9694_152332'
        x1='87.7325'
        y1='108.856'
        x2='87.6787'
        y2='114.79'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(113.842 79.4699) rotate(170.891) scale(63.3981 20.4789)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_9694_152332'
        x1='64.5742'
        y1='81.076'
        x2='64.9056'
        y2='89.3231'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_9694_152332'
        x1='117.411'
        y1='68.4889'
        x2='109.953'
        y2='70.8762'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_9694_152332'
        x1='110.367'
        y1='72.125'
        x2='110.043'
        y2='80.9413'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_9694_152332'
        x1='80.1358'
        y1='54.7725'
        x2='77.5487'
        y2='60.5315'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_9694_152332'
        x1='73.1432'
        y1='57.9413'
        x2='75.8039'
        y2='59.1028'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_9694_152332'
        x1='83.458'
        y1='58.7124'
        x2='80.3906'
        y2='65.0786'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_9694_152332'
        x1='76.0694'
        y1='62.3038'
        x2='78.9409'
        y2='63.4725'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_9694_152332'
        x1='86.2418'
        y1='61.7979'
        x2='82.5921'
        y2='68.6092'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_9694_152332'
        x1='78.8163'
        y1='65.8118'
        x2='81.7828'
        y2='66.8975'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_9694_152332'
        x1='89.5234'
        y1='64.4508'
        x2='85.3474'
        y2='71.7519'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_9694_152332'
        x1='81.8349'
        y1='68.8872'
        x2='84.9516'
        y2='69.9557'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_9694_152332'
        x1='92.2024'
        y1='67.3885'
        x2='87.3213'
        y2='73.8559'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_9694_152332'
        x1='86.0979'
        y1='72.0362'
        x2='88.6884'
        y2='72.7093'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint21_linear_9694_152332'
        x1='94.1499'
        y1='68.6794'
        x2='88.7838'
        y2='72.3327'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint22_linear_9694_152332'
        x1='90.5857'
        y1='73.9608'
        x2='92.1721'
        y2='74.1726'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_9694_152332'
        x1='98.6737'
        y1='70.9156'
        x2='93.8959'
        y2='74.9567'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_9694_152332'
        x1='94.9541'
        y1='75.352'
        x2='96.594'
        y2='75.624'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint25_linear_9694_152332'
        x1='65.715'
        y1='59.9341'
        x2='65.715'
        y2='69.4309'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='paint26_linear_9694_152332'
        x1='67.9008'
        y1='62.8339'
        x2='65.7613'
        y2='67.34'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.377114' stopColor='#413BBC' />
        <stop offset='0.699087' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint27_linear_9694_152332'
        x1='63.8951'
        y1='64.7056'
        x2='65.4881'
        y2='65.2145'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint28_linear_9694_152332'
        x1='114.295'
        y1='78.0331'
        x2='114.295'
        y2='166.807'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F6F6F6' />
      </linearGradient>
      <radialGradient
        id='paint29_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(142.345 81.1794) rotate(40.3645) scale(12.9171 13.3904)'>
        <stop stopColor='#FFCC02' />
        <stop offset='1' stopColor='#FFCC02' stopOpacity='0' />
      </radialGradient>
      <radialGradient
        id='paint30_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(154.648 78.2268) rotate(130.101) scale(12.2236 12.6714)'>
        <stop offset='0.078125' stopColor='#B28C35' />
        <stop offset='0.801556' stopColor='#FFCC02' />
      </radialGradient>
      <linearGradient
        id='paint31_linear_9694_152332'
        x1='133.24'
        y1='139.394'
        x2='98.2164'
        y2='158.644'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint32_linear_9694_152332'
        x1='116.881'
        y1='132.52'
        x2='116.847'
        y2='138.258'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint33_linear_9694_152332'
        x1='127.591'
        y1='150.159'
        x2='99.8916'
        y2='160.3'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint34_linear_9694_152332'
        x1='116.323'
        y1='143.05'
        x2='116.27'
        y2='148.984'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='paint35_radial_9694_152332'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(142.433 113.664) rotate(170.891) scale(63.3981 20.4788)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint36_linear_9694_152332'
        x1='93.1651'
        y1='115.27'
        x2='93.4964'
        y2='123.517'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint37_linear_9694_152332'
        x1='146.002'
        y1='102.683'
        x2='138.544'
        y2='105.071'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='paint38_linear_9694_152332'
        x1='138.957'
        y1='106.319'
        x2='138.634'
        y2='115.136'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint39_linear_9694_152332'
        x1='108.727'
        y1='88.9668'
        x2='106.14'
        y2='94.7259'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint40_linear_9694_152332'
        x1='101.734'
        y1='92.1357'
        x2='104.395'
        y2='93.2971'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint41_linear_9694_152332'
        x1='112.049'
        y1='92.9068'
        x2='108.981'
        y2='99.2729'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint42_linear_9694_152332'
        x1='104.66'
        y1='96.4982'
        x2='107.532'
        y2='97.6668'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint43_linear_9694_152332'
        x1='114.833'
        y1='95.9922'
        x2='111.183'
        y2='102.804'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint44_linear_9694_152332'
        x1='107.407'
        y1='100.006'
        x2='110.374'
        y2='101.092'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint45_linear_9694_152332'
        x1='118.114'
        y1='98.6451'
        x2='113.938'
        y2='105.946'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint46_linear_9694_152332'
        x1='110.426'
        y1='103.082'
        x2='113.542'
        y2='104.15'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint47_linear_9694_152332'
        x1='120.793'
        y1='101.583'
        x2='115.912'
        y2='108.05'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint48_linear_9694_152332'
        x1='114.689'
        y1='106.231'
        x2='117.279'
        y2='106.904'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint49_linear_9694_152332'
        x1='122.741'
        y1='102.874'
        x2='117.375'
        y2='106.527'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint50_linear_9694_152332'
        x1='119.177'
        y1='108.155'
        x2='120.763'
        y2='108.367'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint51_linear_9694_152332'
        x1='127.264'
        y1='105.11'
        x2='122.487'
        y2='109.151'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint52_linear_9694_152332'
        x1='123.545'
        y1='109.546'
        x2='125.185'
        y2='109.818'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint53_linear_9694_152332'
        x1='94.3058'
        y1='94.1284'
        x2='94.3058'
        y2='103.625'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='paint54_linear_9694_152332'
        x1='96.4916'
        y1='97.0283'
        x2='94.3521'
        y2='101.534'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.377114' stopColor='#413BBC' />
        <stop offset='0.699087' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint55_linear_9694_152332'
        x1='92.4859'
        y1='98.9'
        x2='94.0789'
        y2='99.4088'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);

export const CreateBundleSvg = () => (
  <svg
    width='200'
    height='200'
    viewBox='0 0 200 200'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 100.001C0 44.7725 44.7715 0.000976562 100 0.000976562C155.228 0.000976562 200 44.7725 200 100.001C200 155.229 155.228 200.001 100 200.001C44.7715 200.001 0 155.229 0 100.001Z'
      fill='#F0EDFA'
    />
    <path
      d='M181.538 159.08C183.493 159.08 185.078 157.495 185.078 155.54C185.078 153.585 183.493 152 181.538 152C179.583 152 177.998 153.585 177.998 155.54C177.998 157.495 179.583 159.08 181.538 159.08Z'
      fill='#E2D9FF'
    />
    <path
      d='M180.033 22.0451C181.773 22.0451 183.183 20.6348 183.183 18.8951C183.183 17.1554 181.773 15.7451 180.033 15.7451C178.293 15.7451 176.883 17.1554 176.883 18.8951C176.883 20.6348 178.293 22.0451 180.033 22.0451Z'
      fill='#C5B8EA'
    />
    <path
      d='M167.886 35.7422C171.752 35.7422 174.886 32.6082 174.886 28.7422C174.886 24.8762 171.752 21.7422 167.886 21.7422C164.02 21.7422 160.886 24.8762 160.886 28.7422C160.886 32.6082 164.02 35.7422 167.886 35.7422Z'
      fill='#E2D9FF'
    />
    <path
      d='M37.8838 185.741C41.7498 185.741 44.8838 182.607 44.8838 178.741C44.8838 174.875 41.7498 171.741 37.8838 171.741C34.0178 171.741 30.8838 174.875 30.8838 178.741C30.8838 182.607 34.0178 185.741 37.8838 185.741Z'
      fill='#E2D9FF'
    />
    <path
      d='M192.883 160.991C193.987 160.991 194.883 160.096 194.883 158.991C194.883 157.887 193.987 156.991 192.883 156.991C191.778 156.991 190.883 157.887 190.883 158.991C190.883 160.096 191.778 160.991 192.883 160.991Z'
      fill='#C5B8EA'
    />
    <path
      d='M35.5109 30.2922C38.3554 30.2922 40.6614 27.9863 40.6614 25.1417C40.6614 22.2972 38.3554 19.9912 35.5109 19.9912C32.6663 19.9912 30.3604 22.2972 30.3604 25.1417C30.3604 27.9863 32.6663 30.2922 35.5109 30.2922Z'
      fill='#E2D9FF'
    />
    <path
      d='M19.0113 30.2912C20.4749 30.2912 21.6613 29.1048 21.6613 27.6412C21.6613 26.1777 20.4749 24.9912 19.0113 24.9912C17.5478 24.9912 16.3613 26.1777 16.3613 27.6412C16.3613 29.1048 17.5478 30.2912 19.0113 30.2912Z'
      fill='#DCDAE3'
    />
    <path
      d='M34.3906 194.995C36.0475 194.995 37.3906 193.652 37.3906 191.995C37.3906 190.338 36.0475 188.995 34.3906 188.995C32.7338 188.995 31.3906 190.338 31.3906 191.995C31.3906 193.652 32.7338 194.995 34.3906 194.995Z'
      fill='#C5B8EA'
    />
    <g filter='url(#filter0_dd_9690_151951)'>
      <path
        d='M126.534 132.114H44.8749C40.1473 132.114 36.4941 128.821 36.4941 124.979V40.8279C36.4941 36.8033 40.3622 33.6934 44.8749 33.6934H126.534C131.261 33.6934 134.915 36.9862 134.915 40.8279V124.979C134.915 128.821 131.047 132.114 126.534 132.114Z'
        fill='url(#paint0_linear_9690_151951)'
      />
      <path
        d='M117.999 43.0441C118.311 42.1754 119.54 42.1754 119.852 43.0441L121.195 46.7848C121.331 47.1639 121.685 47.4218 122.087 47.4357L126.042 47.5728C126.958 47.6046 127.337 48.7612 126.617 49.329L123.48 51.8048C123.167 52.0517 123.034 52.463 123.143 52.8465L124.239 56.7013C124.49 57.5869 123.497 58.3024 122.737 57.7831L119.481 55.5588C119.146 55.3301 118.705 55.3301 118.37 55.5588L115.114 57.7831C114.354 58.3024 113.361 57.5869 113.612 56.7013L114.708 52.8465C114.817 52.463 114.684 52.0517 114.371 51.8048L111.234 49.329C110.514 48.7612 110.893 47.6046 111.809 47.5728L115.764 47.4357C116.166 47.4218 116.52 47.1639 116.656 46.7848L117.999 43.0441Z'
        fill='url(#paint1_radial_9690_151951)'
      />
      <path
        d='M117.999 43.0441C118.311 42.1754 119.54 42.1754 119.852 43.0441L121.195 46.7848C121.331 47.1639 121.685 47.4218 122.087 47.4357L126.042 47.5728C126.958 47.6046 127.337 48.7612 126.617 49.329L123.48 51.8048C123.167 52.0517 123.034 52.463 123.143 52.8465L124.239 56.7013C124.49 57.5869 123.497 58.3024 122.737 57.7831L119.481 55.5588C119.146 55.3301 118.705 55.3301 118.37 55.5588L115.114 57.7831C114.354 58.3024 113.361 57.5869 113.612 56.7013L114.708 52.8465C114.817 52.463 114.684 52.0517 114.371 51.8048L111.234 49.329C110.514 48.7612 110.893 47.6046 111.809 47.5728L115.764 47.4357C116.166 47.4218 116.52 47.1639 116.656 46.7848L117.999 43.0441Z'
        fill='url(#paint2_radial_9690_151951)'
      />
      <path
        d='M112.049 104.471H59.4147C57.9231 104.471 56.6445 103.18 56.6445 101.672C56.6445 100.165 57.9231 98.873 59.4147 98.873H112.049C113.54 98.873 114.819 100.165 114.819 101.672C114.819 103.18 113.54 104.471 112.049 104.471Z'
        fill='url(#paint3_linear_9690_151951)'
      />
      <path
        d='M112.049 104.471H59.4147C57.9231 104.471 56.6445 103.18 56.6445 101.672C56.6445 100.165 57.9231 98.873 59.4147 98.873H112.049C113.54 98.873 114.819 100.165 114.819 101.672C114.819 103.18 113.54 104.471 112.049 104.471Z'
        fill='url(#paint4_linear_9690_151951)'
      />
      <path
        d='M102.147 115.229H69.7932C67.7155 115.229 65.9346 113.893 65.9346 112.334C65.9346 110.775 67.7155 109.439 69.7932 109.439H102.147C104.224 109.439 106.005 110.775 106.005 112.334C105.708 113.893 104.224 115.229 102.147 115.229Z'
        fill='url(#paint5_linear_9690_151951)'
      />
      <path
        d='M102.147 115.229H69.7932C67.7155 115.229 65.9346 113.893 65.9346 112.334C65.9346 110.775 67.7155 109.439 69.7932 109.439H102.147C104.224 109.439 106.005 110.775 106.005 112.334C105.708 113.893 104.224 115.229 102.147 115.229Z'
        fill='url(#paint6_linear_9690_151951)'
      />
      <path
        d='M115.856 80.2456C115.643 79.815 116.069 78.4655 115.856 78.0348C115.004 76.7429 113.615 76.47 111.484 75.824C108.501 74.9627 106.629 73.6658 104.285 73.4505C103.646 73.4505 103.007 73.2351 102.581 73.2351C95.9747 72.5892 90.4344 71.5126 78.2882 56.4401C77.0097 54.9329 76.3704 53.4256 75.0918 51.9184C73.8133 50.6265 71.6824 52.1337 68.9122 52.7797C68.273 52.995 67.8468 52.995 67.2075 52.995C65.0766 52.995 62.5195 52.7797 60.1755 52.5644C56.9792 52.1337 58.897 50.4111 55.0613 75.173C54.8483 77.1109 54.6352 78.8335 54.4221 80.7714C54.209 82.2786 54.209 84.0012 54.209 85.5084C54.209 86.1544 54.4221 87.231 55.0613 87.231C65.2897 88.3076 71.8955 87.8769 88.0904 87.6616C96.1878 87.6616 104.285 87.6616 112.383 86.1544L114.3 85.9391C116.005 85.7237 117.71 85.0778 117.71 84.0012C117.71 82.4939 116.282 81.7529 115.856 80.2456Z'
        fill='#8E76D7'
      />
      <path
        d='M104.284 73.6697L102.367 79.268C91.9251 78.8374 81.2706 72.1625 75.7302 63.5496C73.8124 60.5351 72.3208 57.3053 70.1899 54.7215C70.1899 54.7215 69.5506 53.8602 68.6982 53.2142C71.4684 52.5683 73.5993 51.061 74.8779 52.353C75.9433 53.4296 76.3695 54.2908 77.2219 55.3675C77.4349 55.7981 77.648 56.0134 77.8611 56.4441C77.8611 56.6594 78.0742 56.6594 78.0742 56.8747C78.7135 57.736 79.5658 58.5973 80.2051 59.4585C80.4182 59.6739 80.6313 59.8892 80.8444 60.3198C81.6968 61.1811 82.336 62.0424 83.1884 62.9037C83.4015 63.119 83.6146 63.3343 83.8277 63.765C84.68 64.6262 85.3193 65.4875 86.1717 66.1335C86.3847 66.3488 86.8109 66.5641 87.024 66.9948C87.8764 67.6407 88.5156 68.2867 89.1549 68.9327C89.5811 69.148 89.7942 69.3633 90.2204 69.7939C90.8596 70.2246 91.2858 70.6552 91.9251 70.8705C92.3513 71.0859 92.7775 71.3012 92.9905 71.5165C94.056 72.1625 95.1214 72.5931 96.1869 73.0237C96.6131 73.2391 97.0393 73.2391 97.4654 73.4544C99.1702 73.885 100.662 74.1003 102.367 74.3157C103.006 73.4544 103.645 73.4544 104.284 73.6697Z'
        fill='#413BBC'
      />
      <path
        d='M117.71 84.2101C117.71 85.2868 115.792 85.9327 114.3 86.148L112.383 86.3634C104.498 87.8706 96.1878 87.8706 88.0904 87.8706C71.8955 87.8706 65.5028 88.3012 55.0613 87.44C54.209 87.44 54.209 86.3634 54.209 85.7174C54.209 83.9948 54.209 82.4876 54.4221 80.9803C60.1755 81.411 84.4678 82.7029 103.007 80.765C108.121 80.119 112.809 79.4731 116.431 78.3965C116.644 78.8271 116.858 79.2578 117.071 79.6884C117.497 80.9803 117.71 82.4876 117.71 84.2101Z'
        fill='#8E76D7'
      />
      <path
        d='M117.71 84.2101C117.71 85.2868 115.792 85.9327 114.3 86.148L112.383 86.3634C104.498 87.8706 96.1878 87.8706 88.0904 87.8706C71.8955 87.8706 65.5028 88.3012 55.0613 87.44C54.209 87.44 54.209 86.3634 54.209 85.7174C54.209 83.9948 54.209 82.4876 54.4221 80.9803C60.1755 81.411 84.4678 82.7029 103.007 80.765C108.121 80.119 112.809 79.4731 116.431 78.3965C116.644 78.8271 116.858 79.2578 117.071 79.6884C117.497 80.9803 117.71 82.4876 117.71 84.2101Z'
        fill='url(#paint7_radial_9690_151951)'
      />
      <path
        d='M117.71 84.2101C117.71 85.2868 115.792 85.9327 114.3 86.148L112.383 86.3634C104.498 87.8706 96.1878 87.8706 88.0904 87.8706C71.8955 87.8706 65.5028 88.3012 55.0613 87.44C54.209 87.44 54.209 86.3634 54.209 85.7174C54.209 83.9948 54.209 82.4876 54.4221 80.9803C60.1755 81.411 84.4678 82.7029 103.007 80.765C108.121 80.119 112.809 79.4731 116.431 78.3965C116.644 78.8271 116.858 79.2578 117.071 79.6884C117.497 80.9803 117.71 82.4876 117.71 84.2101Z'
        fill='url(#paint8_linear_9690_151951)'
        fillOpacity='0.8'
      />
      <path
        d='M117.071 79.4806C113.236 80.7726 109.4 81.6338 105.351 81.8492C104.712 81.8492 104.073 81.8492 103.647 81.6338C103.007 81.4185 103.007 80.9879 102.794 80.5572C102.794 80.3419 102.794 80.1266 102.794 79.9113C102.581 77.7581 102.368 75.3895 102.368 73.2363C105.138 73.4516 108.122 73.667 111.744 74.9589C113.875 75.6049 115.367 76.6815 116.219 78.1887C116.645 78.6193 116.858 79.05 117.071 79.4806Z'
        fill='url(#paint9_linear_9690_151951)'
      />
      <path
        d='M117.071 79.4806C113.236 80.7726 109.4 81.6338 105.351 81.8492C104.712 81.8492 104.073 81.8492 103.647 81.6338C103.007 81.4185 103.007 80.9879 102.794 80.5572C102.794 80.3419 102.794 80.1266 102.794 79.9113C102.581 77.7581 102.368 75.3895 102.368 73.2363C105.138 73.4516 108.122 73.667 111.744 74.9589C113.875 75.6049 115.367 76.6815 116.219 78.1887C116.645 78.6193 116.858 79.05 117.071 79.4806Z'
        fill='url(#paint10_linear_9690_151951)'
      />
      <path
        d='M77.8641 56.2295C77.8641 56.4448 77.8641 56.4448 77.8641 56.2295L75.0939 58.3827C74.8808 58.3827 74.8808 58.598 74.6677 58.598C74.4546 58.598 74.2415 58.598 74.2415 58.3827C74.0284 58.1673 74.0284 57.7367 74.4546 57.5214L77.2248 55.3682H77.4379C77.4379 55.5835 77.651 56.0141 77.8641 56.2295Z'
        fill='url(#paint11_linear_9690_151951)'
      />
      <path
        d='M77.8641 56.2295C77.8641 56.4448 77.8641 56.4448 77.8641 56.2295L75.0939 58.3827C74.8808 58.3827 74.8808 58.598 74.6677 58.598C74.4546 58.598 74.2415 58.598 74.2415 58.3827C74.0284 58.1673 74.0284 57.7367 74.4546 57.5214L77.2248 55.3682H77.4379C77.4379 55.5835 77.651 56.0141 77.8641 56.2295Z'
        fill='url(#paint12_linear_9690_151951)'
      />
      <path
        d='M81.0576 59.8847C81.0576 60.1001 81.0576 60.1001 80.8445 60.3154C79.9922 61.1767 79.1398 62.0379 78.0744 62.8992C77.8613 62.8992 77.8613 63.1145 77.6482 63.1145C77.4351 63.1145 77.222 63.1145 77.222 62.8992C77.0089 62.6839 77.0089 62.2533 77.4351 62.0379C78.2875 61.392 79.1398 60.5307 79.9922 59.6694C80.2053 59.4541 80.2053 59.4541 80.4184 59.4541C80.4184 59.4541 80.8445 59.6694 81.0576 59.8847Z'
        fill='url(#paint13_linear_9690_151951)'
      />
      <path
        d='M81.0576 59.8847C81.0576 60.1001 81.0576 60.1001 80.8445 60.3154C79.9922 61.1767 79.1398 62.0379 78.0744 62.8992C77.8613 62.8992 77.8613 63.1145 77.6482 63.1145C77.4351 63.1145 77.222 63.1145 77.222 62.8992C77.0089 62.6839 77.0089 62.2533 77.4351 62.0379C78.2875 61.392 79.1398 60.5307 79.9922 59.6694C80.2053 59.4541 80.2053 59.4541 80.4184 59.4541C80.4184 59.4541 80.8445 59.6694 81.0576 59.8847Z'
        fill='url(#paint14_linear_9690_151951)'
      />
      <path
        d='M83.8294 63.3315C83.8294 63.5468 83.8294 63.5468 83.6163 63.7622C82.764 64.6234 81.6985 65.7 80.8462 66.5613C80.6331 66.7766 80.6331 66.7766 80.42 66.7766C80.2069 66.7766 79.9938 66.7766 79.9938 66.5613C79.7807 66.346 79.7807 65.9154 79.9938 65.7C80.8462 64.8388 81.9116 63.7621 82.764 62.9009C82.9771 62.6855 82.9771 62.6855 83.1902 62.6855C83.4033 62.6855 83.6163 63.1162 83.8294 63.3315Z'
        fill='url(#paint15_linear_9690_151951)'
      />
      <path
        d='M83.8294 63.3315C83.8294 63.5468 83.8294 63.5468 83.6163 63.7622C82.764 64.6234 81.6985 65.7 80.8462 66.5613C80.6331 66.7766 80.6331 66.7766 80.42 66.7766C80.2069 66.7766 79.9938 66.7766 79.9938 66.5613C79.7807 66.346 79.7807 65.9154 79.9938 65.7C80.8462 64.8388 81.9116 63.7621 82.764 62.9009C82.9771 62.6855 82.9771 62.6855 83.1902 62.6855C83.4033 62.6855 83.6163 63.1162 83.8294 63.3315Z'
        fill='url(#paint16_linear_9690_151951)'
      />
      <path
        d='M87.0257 66.3457C87.0257 66.561 87.0256 66.561 86.8126 66.7763C85.7471 67.6376 84.6817 68.7142 84.0424 69.7908C83.8293 70.0061 83.8293 70.0061 83.6162 70.0061C83.4031 70.0061 83.4031 70.0061 83.19 69.7908C82.9769 69.5755 82.7638 69.1448 82.9769 68.9295C83.8293 67.8529 84.8947 66.7763 85.9602 65.6997C85.9602 65.6997 86.1733 65.6997 86.1733 65.4844C86.5995 65.915 86.8126 66.1303 87.0257 66.3457Z'
        fill='url(#paint17_linear_9690_151951)'
      />
      <path
        d='M87.0257 66.3457C87.0257 66.561 87.0256 66.561 86.8126 66.7763C85.7471 67.6376 84.6817 68.7142 84.0424 69.7908C83.8293 70.0061 83.8293 70.0061 83.6162 70.0061C83.4031 70.0061 83.4031 70.0061 83.19 69.7908C82.9769 69.5755 82.7638 69.1448 82.9769 68.9295C83.8293 67.8529 84.8947 66.7763 85.9602 65.6997C85.9602 65.6997 86.1733 65.6997 86.1733 65.4844C86.5995 65.915 86.8126 66.1303 87.0257 66.3457Z'
        fill='url(#paint18_linear_9690_151951)'
      />
      <path
        d='M90.2192 68.9258C90.2192 68.9258 90.2192 69.1411 90.2192 68.9258C89.5799 70.2177 88.9406 71.5096 88.0883 72.8015C87.8752 73.0169 87.6621 73.2322 87.449 73.2322H87.2359C87.0228 73.0169 86.8097 72.5862 87.0228 72.3709C87.6621 71.079 88.3014 69.787 88.9406 68.7104L89.1537 68.4951C89.5799 68.4951 89.793 68.7104 90.2192 68.9258Z'
        fill='url(#paint19_linear_9690_151951)'
      />
      <path
        d='M90.2192 68.9258C90.2192 68.9258 90.2192 69.1411 90.2192 68.9258C89.5799 70.2177 88.9406 71.5096 88.0883 72.8015C87.8752 73.0169 87.6621 73.2322 87.449 73.2322H87.2359C87.0228 73.0169 86.8097 72.5862 87.0228 72.3709C87.6621 71.079 88.3014 69.787 88.9406 68.7104L89.1537 68.4951C89.5799 68.4951 89.793 68.7104 90.2192 68.9258Z'
        fill='url(#paint20_linear_9690_151951)'
      />
      <path
        d='M92.992 70.8662L92.3528 74.7419C92.3528 75.1726 91.9266 75.3879 91.7135 75.3879C91.2873 75.3879 91.0742 74.9573 91.0742 74.5266L91.7135 70.2202C91.7135 70.0049 91.7135 70.0049 91.9266 70.0049C92.3528 70.4355 92.5658 70.6508 92.992 70.8662Z'
        fill='url(#paint21_linear_9690_151951)'
      />
      <path
        d='M92.992 70.8662L92.3528 74.7419C92.3528 75.1726 91.9266 75.3879 91.7135 75.3879C91.2873 75.3879 91.0742 74.9573 91.0742 74.5266L91.7135 70.2202C91.7135 70.0049 91.7135 70.0049 91.9266 70.0049C92.3528 70.4355 92.5658 70.6508 92.992 70.8662Z'
        fill='url(#paint22_linear_9690_151951)'
      />
      <path
        d='M97.4653 72.5952C97.2522 73.6718 97.0391 74.9637 96.826 76.0403C96.826 76.2556 96.3998 76.471 96.1867 76.471C96.1867 76.471 96.1867 76.471 95.9736 76.471C95.5475 76.471 95.3344 76.0403 95.5475 75.6097C95.7606 74.5331 95.9736 73.2411 96.1867 72.1645C96.1867 72.1645 96.1867 72.1645 96.1867 71.9492C96.6129 72.3799 97.0391 72.5952 97.4653 72.5952Z'
        fill='url(#paint23_linear_9690_151951)'
      />
      <path
        d='M97.4653 72.5952C97.2522 73.6718 97.0391 74.9637 96.826 76.0403C96.826 76.2556 96.3998 76.471 96.1867 76.471C96.1867 76.471 96.1867 76.471 95.9736 76.471C95.5475 76.471 95.3344 76.0403 95.5475 75.6097C95.7606 74.5331 95.9736 73.2411 96.1867 72.1645C96.1867 72.1645 96.1867 72.1645 96.1867 71.9492C96.6129 72.3799 97.0391 72.5952 97.4653 72.5952Z'
        fill='url(#paint24_linear_9690_151951)'
      />
      <path
        d='M65.715 69.1459C68.6571 69.1459 71.0422 66.7359 71.0422 63.7629C71.0422 60.7899 68.6571 58.3799 65.715 58.3799C62.7728 58.3799 60.3877 60.7899 60.3877 63.7629C60.3877 66.7359 62.7728 69.1459 65.715 69.1459Z'
        fill='url(#paint25_linear_9690_151951)'
      />
      <path
        d='M65.7149 65.9177C66.8918 65.9177 67.8458 64.9537 67.8458 63.7645C67.8458 62.5754 66.8918 61.6113 65.7149 61.6113C64.538 61.6113 63.584 62.5754 63.584 63.7645C63.584 64.9537 64.538 65.9177 65.7149 65.9177Z'
        fill='url(#paint26_linear_9690_151951)'
      />
      <path
        d='M65.7149 65.9177C66.8918 65.9177 67.8458 64.9537 67.8458 63.7645C67.8458 62.5754 66.8918 61.6113 65.7149 61.6113C64.538 61.6113 63.584 62.5754 63.584 63.7645C63.584 64.9537 64.538 65.9177 65.7149 65.9177Z'
        fill='url(#paint27_linear_9690_151951)'
      />
    </g>
    <g filter='url(#filter1_dd_9690_151951)'>
      <path
        d='M155.125 166.308H73.4657C68.7381 166.308 65.085 163.015 65.085 159.174V75.0223C65.085 70.9976 68.953 67.8877 73.4657 67.8877H155.125C159.852 67.8877 163.505 71.1806 163.505 75.0223V159.174C163.505 163.015 159.637 166.308 155.125 166.308Z'
        fill='url(#paint28_linear_9690_151951)'
      />
      <path
        d='M146.59 77.2384C146.902 76.3697 148.131 76.3697 148.443 77.2384L149.786 80.9791C149.922 81.3582 150.276 81.6161 150.678 81.6301L154.633 81.7671C155.549 81.7989 155.928 82.9556 155.208 83.5234L152.071 85.9991C151.758 86.2461 151.625 86.6574 151.734 87.0408L152.829 90.8957C153.081 91.7812 152.088 92.4967 151.328 91.9774L148.071 89.7531C147.737 89.5244 147.296 89.5244 146.961 89.7531L143.705 91.9774C142.945 92.4967 141.952 91.7812 142.203 90.8957L143.299 87.0408C143.408 86.6574 143.275 86.2461 142.962 85.9991L139.824 83.5234C139.105 82.9556 139.484 81.7989 140.4 81.7671L144.354 81.6301C144.757 81.6161 145.11 81.3582 145.247 80.9791L146.59 77.2384Z'
        fill='url(#paint29_radial_9690_151951)'
      />
      <path
        d='M146.59 77.2384C146.902 76.3697 148.131 76.3697 148.443 77.2384L149.786 80.9791C149.922 81.3582 150.276 81.6161 150.678 81.6301L154.633 81.7671C155.549 81.7989 155.928 82.9556 155.208 83.5234L152.071 85.9991C151.758 86.2461 151.625 86.6574 151.734 87.0408L152.829 90.8957C153.081 91.7812 152.088 92.4967 151.328 91.9774L148.071 89.7531C147.737 89.5244 147.296 89.5244 146.961 89.7531L143.705 91.9774C142.945 92.4967 141.952 91.7812 142.203 90.8957L143.299 87.0408C143.408 86.6574 143.275 86.2461 142.962 85.9991L139.824 83.5234C139.105 82.9556 139.484 81.7989 140.4 81.7671L144.354 81.6301C144.757 81.6161 145.11 81.3582 145.247 80.9791L146.59 77.2384Z'
        fill='url(#paint30_radial_9690_151951)'
      />
      <path
        d='M140.639 138.666H88.0056C86.5139 138.666 85.2354 137.374 85.2354 135.867C85.2354 134.359 86.5139 133.067 88.0056 133.067H140.639C142.131 133.067 143.41 134.359 143.41 135.867C143.41 137.374 142.131 138.666 140.639 138.666Z'
        fill='url(#paint31_linear_9690_151951)'
      />
      <path
        d='M140.639 138.666H88.0056C86.5139 138.666 85.2354 137.374 85.2354 135.867C85.2354 134.359 86.5139 133.067 88.0056 133.067H140.639C142.131 133.067 143.41 134.359 143.41 135.867C143.41 137.374 142.131 138.666 140.639 138.666Z'
        fill='url(#paint32_linear_9690_151951)'
      />
      <path
        d='M130.737 149.423H98.3841C96.3063 149.423 94.5254 148.087 94.5254 146.529C94.5254 144.97 96.3063 143.634 98.3841 143.634H130.737C132.815 143.634 134.596 144.97 134.596 146.529C134.299 148.087 132.815 149.423 130.737 149.423Z'
        fill='url(#paint33_linear_9690_151951)'
      />
      <path
        d='M130.737 149.423H98.3841C96.3063 149.423 94.5254 148.087 94.5254 146.529C94.5254 144.97 96.3063 143.634 98.3841 143.634H130.737C132.815 143.634 134.596 144.97 134.596 146.529C134.299 148.087 132.815 149.423 130.737 149.423Z'
        fill='url(#paint34_linear_9690_151951)'
      />
      <path
        d='M144.447 114.44C144.234 114.009 144.66 112.66 144.447 112.229C143.595 110.937 142.206 110.664 140.075 110.018C137.092 109.157 135.22 107.86 132.876 107.645C132.237 107.645 131.598 107.429 131.171 107.429C124.566 106.784 119.025 105.707 106.879 90.6345C105.6 89.1272 104.961 87.62 103.683 86.1127C102.404 84.8208 100.273 86.328 97.503 86.974C96.8638 87.1893 96.4376 87.1893 95.7983 87.1893C93.6674 87.1893 91.1103 86.974 88.7663 86.7587C85.57 86.328 87.4878 84.6055 83.6522 109.367C83.4391 111.305 83.226 113.028 83.0129 114.966C82.7998 116.473 82.7998 118.195 82.7998 119.703C82.7998 120.349 83.0129 121.425 83.6522 121.425C93.8805 122.502 100.486 122.071 116.681 121.856C124.779 121.856 132.876 121.856 140.973 120.349L142.891 120.133C144.596 119.918 146.301 119.272 146.301 118.195C146.301 116.688 144.873 115.947 144.447 114.44Z'
        fill='#8E76D7'
      />
      <path
        d='M132.875 107.864L130.957 113.462C120.516 113.032 109.861 106.357 104.321 97.744C102.403 94.7295 100.912 91.4997 98.7807 88.9158C98.7807 88.9158 98.1414 88.0545 97.2891 87.4086C100.059 86.7626 102.19 85.2554 103.469 86.5473C104.534 87.6239 104.96 88.4852 105.813 89.5618C106.026 89.9924 106.239 90.2077 106.452 90.6384C106.452 90.8537 106.665 90.8537 106.665 91.069C107.304 91.9303 108.157 92.7916 108.796 93.6529C109.009 93.8682 109.222 94.0835 109.435 94.5142C110.288 95.3754 110.927 96.2367 111.779 97.098C111.992 97.3133 112.205 97.5287 112.418 97.9593C113.271 98.8206 113.91 99.6819 114.762 100.328C114.976 100.543 115.402 100.758 115.615 101.189C116.467 101.835 117.106 102.481 117.746 103.127C118.172 103.342 118.385 103.558 118.811 103.988C119.45 104.419 119.877 104.85 120.516 105.065C120.942 105.28 121.368 105.496 121.581 105.711C122.647 106.357 123.712 106.787 124.778 107.218C125.204 107.433 125.63 107.433 126.056 107.649C127.761 108.079 129.253 108.295 130.957 108.51C131.597 107.649 132.236 107.649 132.875 107.864Z'
        fill='#413BBC'
      />
      <path
        d='M146.301 118.404C146.301 119.481 144.383 120.127 142.891 120.342L140.973 120.558C133.089 122.065 124.779 122.065 116.681 122.065C100.486 122.065 94.0936 122.496 83.6522 121.634C82.7998 121.634 82.7998 120.558 82.7998 119.912C82.7998 118.189 82.7998 116.682 83.0129 115.175C88.7663 115.605 113.059 116.897 131.598 114.959C136.712 114.313 141.4 113.667 145.022 112.591C145.235 113.021 145.448 113.452 145.661 113.883C146.088 115.175 146.301 116.682 146.301 118.404Z'
        fill='#8E76D7'
      />
      <path
        d='M146.301 118.404C146.301 119.481 144.383 120.127 142.891 120.342L140.973 120.558C133.089 122.065 124.779 122.065 116.681 122.065C100.486 122.065 94.0936 122.496 83.6522 121.634C82.7998 121.634 82.7998 120.558 82.7998 119.912C82.7998 118.189 82.7998 116.682 83.0129 115.175C88.7663 115.605 113.059 116.897 131.598 114.959C136.712 114.313 141.4 113.667 145.022 112.591C145.235 113.021 145.448 113.452 145.661 113.883C146.088 115.175 146.301 116.682 146.301 118.404Z'
        fill='url(#paint35_radial_9690_151951)'
      />
      <path
        d='M146.301 118.404C146.301 119.481 144.383 120.127 142.891 120.342L140.973 120.558C133.089 122.065 124.779 122.065 116.681 122.065C100.486 122.065 94.0936 122.496 83.6522 121.634C82.7998 121.634 82.7998 120.558 82.7998 119.912C82.7998 118.189 82.7998 116.682 83.0129 115.175C88.7663 115.605 113.059 116.897 131.598 114.959C136.712 114.313 141.4 113.667 145.022 112.591C145.235 113.021 145.448 113.452 145.661 113.883C146.088 115.175 146.301 116.682 146.301 118.404Z'
        fill='url(#paint36_linear_9690_151951)'
        fillOpacity='0.8'
      />
      <path
        d='M145.662 113.676C141.827 114.968 137.991 115.829 133.942 116.044C133.303 116.044 132.664 116.044 132.238 115.829C131.598 115.614 131.598 115.183 131.385 114.753C131.385 114.537 131.385 114.322 131.385 114.107C131.172 111.953 130.959 109.585 130.959 107.432C133.729 107.647 136.712 107.862 140.335 109.154C142.466 109.8 143.957 110.877 144.81 112.384C145.236 112.815 145.449 113.245 145.662 113.676Z'
        fill='url(#paint37_linear_9690_151951)'
      />
      <path
        d='M145.662 113.676C141.827 114.968 137.991 115.829 133.942 116.044C133.303 116.044 132.664 116.044 132.238 115.829C131.598 115.614 131.598 115.183 131.385 114.753C131.385 114.537 131.385 114.322 131.385 114.107C131.172 111.953 130.959 109.585 130.959 107.432C133.729 107.647 136.712 107.862 140.335 109.154C142.466 109.8 143.957 110.877 144.81 112.384C145.236 112.815 145.449 113.245 145.662 113.676Z'
        fill='url(#paint38_linear_9690_151951)'
      />
      <path
        d='M106.455 90.4238C106.455 90.6391 106.455 90.6391 106.455 90.4238L103.685 92.577C103.472 92.577 103.472 92.7923 103.259 92.7923C103.045 92.7923 102.832 92.7923 102.832 92.577C102.619 92.3617 102.619 91.931 103.045 91.7157L105.816 89.5625H106.029C106.029 89.7778 106.242 90.2085 106.455 90.4238Z'
        fill='url(#paint39_linear_9690_151951)'
      />
      <path
        d='M106.455 90.4238C106.455 90.6391 106.455 90.6391 106.455 90.4238L103.685 92.577C103.472 92.577 103.472 92.7923 103.259 92.7923C103.045 92.7923 102.832 92.7923 102.832 92.577C102.619 92.3617 102.619 91.931 103.045 91.7157L105.816 89.5625H106.029C106.029 89.7778 106.242 90.2085 106.455 90.4238Z'
        fill='url(#paint40_linear_9690_151951)'
      />
      <path
        d='M109.648 94.0791C109.648 94.2944 109.648 94.2944 109.435 94.5097C108.583 95.371 107.731 96.2323 106.665 97.0936C106.452 97.0936 106.452 97.3089 106.239 97.3089C106.026 97.3089 105.813 97.3089 105.813 97.0936C105.6 96.8782 105.6 96.4476 106.026 96.2323C106.878 95.5863 107.731 94.725 108.583 93.8638C108.796 93.6484 108.796 93.6484 109.009 93.6484C109.009 93.6484 109.435 93.8638 109.648 94.0791Z'
        fill='url(#paint41_linear_9690_151951)'
      />
      <path
        d='M109.648 94.0791C109.648 94.2944 109.648 94.2944 109.435 94.5097C108.583 95.371 107.731 96.2323 106.665 97.0936C106.452 97.0936 106.452 97.3089 106.239 97.3089C106.026 97.3089 105.813 97.3089 105.813 97.0936C105.6 96.8782 105.6 96.4476 106.026 96.2323C106.878 95.5863 107.731 94.725 108.583 93.8638C108.796 93.6484 108.796 93.6484 109.009 93.6484C109.009 93.6484 109.435 93.8638 109.648 94.0791Z'
        fill='url(#paint42_linear_9690_151951)'
      />
      <path
        d='M112.42 97.5258C112.42 97.7412 112.42 97.7412 112.207 97.9565C111.355 98.8178 110.289 99.8944 109.437 100.756C109.224 100.971 109.224 100.971 109.011 100.971C108.798 100.971 108.585 100.971 108.585 100.756C108.372 100.54 108.372 100.11 108.585 99.8944C109.437 99.0331 110.502 97.9565 111.355 97.0952C111.568 96.8799 111.568 96.8799 111.781 96.8799C111.994 96.8799 112.207 97.3105 112.42 97.5258Z'
        fill='url(#paint43_linear_9690_151951)'
      />
      <path
        d='M112.42 97.5258C112.42 97.7412 112.42 97.7412 112.207 97.9565C111.355 98.8178 110.289 99.8944 109.437 100.756C109.224 100.971 109.224 100.971 109.011 100.971C108.798 100.971 108.585 100.971 108.585 100.756C108.372 100.54 108.372 100.11 108.585 99.8944C109.437 99.0331 110.502 97.9565 111.355 97.0952C111.568 96.8799 111.568 96.8799 111.781 96.8799C111.994 96.8799 112.207 97.3105 112.42 97.5258Z'
        fill='url(#paint44_linear_9690_151951)'
      />
      <path
        d='M115.616 100.54C115.616 100.755 115.616 100.755 115.403 100.971C114.338 101.832 113.272 102.909 112.633 103.985C112.42 104.2 112.42 104.2 112.207 104.2C111.994 104.2 111.994 104.2 111.781 103.985C111.568 103.77 111.355 103.339 111.568 103.124C112.42 102.047 113.486 100.971 114.551 99.894C114.551 99.894 114.764 99.894 114.764 99.6787C115.19 100.109 115.403 100.325 115.616 100.54Z'
        fill='url(#paint45_linear_9690_151951)'
      />
      <path
        d='M115.616 100.54C115.616 100.755 115.616 100.755 115.403 100.971C114.338 101.832 113.272 102.909 112.633 103.985C112.42 104.2 112.42 104.2 112.207 104.2C111.994 104.2 111.994 104.2 111.781 103.985C111.568 103.77 111.355 103.339 111.568 103.124C112.42 102.047 113.486 100.971 114.551 99.894C114.551 99.894 114.764 99.894 114.764 99.6787C115.19 100.109 115.403 100.325 115.616 100.54Z'
        fill='url(#paint46_linear_9690_151951)'
      />
      <path
        d='M118.81 103.12C118.81 103.12 118.81 103.335 118.81 103.12C118.171 104.412 117.531 105.704 116.679 106.996C116.466 107.211 116.253 107.427 116.04 107.427H115.827C115.614 107.211 115.401 106.781 115.614 106.565C116.253 105.273 116.892 103.981 117.531 102.905L117.745 102.689C118.171 102.689 118.384 102.905 118.81 103.12Z'
        fill='url(#paint47_linear_9690_151951)'
      />
      <path
        d='M118.81 103.12C118.81 103.12 118.81 103.335 118.81 103.12C118.171 104.412 117.531 105.704 116.679 106.996C116.466 107.211 116.253 107.427 116.04 107.427H115.827C115.614 107.211 115.401 106.781 115.614 106.565C116.253 105.273 116.892 103.981 117.531 102.905L117.745 102.689C118.171 102.689 118.384 102.905 118.81 103.12Z'
        fill='url(#paint48_linear_9690_151951)'
      />
      <path
        d='M121.583 105.061L120.944 108.936C120.944 109.367 120.517 109.582 120.304 109.582C119.878 109.582 119.665 109.152 119.665 108.721L120.304 104.415C120.304 104.199 120.304 104.199 120.517 104.199C120.944 104.63 121.157 104.845 121.583 105.061Z'
        fill='url(#paint49_linear_9690_151951)'
      />
      <path
        d='M121.583 105.061L120.944 108.936C120.944 109.367 120.517 109.582 120.304 109.582C119.878 109.582 119.665 109.152 119.665 108.721L120.304 104.415C120.304 104.199 120.304 104.199 120.517 104.199C120.944 104.63 121.157 104.845 121.583 105.061Z'
        fill='url(#paint50_linear_9690_151951)'
      />
      <path
        d='M126.056 106.79C125.843 107.866 125.63 109.158 125.417 110.235C125.417 110.45 124.991 110.665 124.778 110.665C124.778 110.665 124.778 110.665 124.564 110.665C124.138 110.665 123.925 110.235 124.138 109.804C124.351 108.727 124.564 107.435 124.778 106.359C124.778 106.359 124.778 106.359 124.778 106.144C125.204 106.574 125.63 106.79 126.056 106.79Z'
        fill='url(#paint51_linear_9690_151951)'
      />
      <path
        d='M126.056 106.79C125.843 107.866 125.63 109.158 125.417 110.235C125.417 110.45 124.991 110.665 124.778 110.665C124.778 110.665 124.778 110.665 124.564 110.665C124.138 110.665 123.925 110.235 124.138 109.804C124.351 108.727 124.564 107.435 124.778 106.359C124.778 106.359 124.778 106.359 124.778 106.144C125.204 106.574 125.63 106.79 126.056 106.79Z'
        fill='url(#paint52_linear_9690_151951)'
      />
      <path
        d='M94.3058 103.34C97.2479 103.34 99.633 100.93 99.633 97.9572C99.633 94.9843 97.2479 92.5742 94.3058 92.5742C91.3636 92.5742 88.9785 94.9843 88.9785 97.9572C88.9785 100.93 91.3636 103.34 94.3058 103.34Z'
        fill='url(#paint53_linear_9690_151951)'
      />
      <path
        d='M94.3057 100.112C95.4826 100.112 96.4366 99.1481 96.4366 97.9589C96.4366 96.7697 95.4826 95.8057 94.3057 95.8057C93.1288 95.8057 92.1748 96.7697 92.1748 97.9589C92.1748 99.1481 93.1288 100.112 94.3057 100.112Z'
        fill='url(#paint54_linear_9690_151951)'
      />
      <path
        d='M94.3057 100.112C95.4826 100.112 96.4366 99.1481 96.4366 97.9589C96.4366 96.7697 95.4826 95.8057 94.3057 95.8057C93.1288 95.8057 92.1748 96.7697 92.1748 97.9589C92.1748 99.1481 93.1288 100.112 94.3057 100.112Z'
        fill='url(#paint55_linear_9690_151951)'
      />
    </g>
    <path
      d='M95.747 166.336V166.336C95.7663 168.16 93.564 169.089 92.2715 167.802L34.9517 110.747C33.5553 109.357 34.5129 106.971 36.4827 106.933V106.933'
      stroke='#C5B8EA'
      strokeWidth='1.67'
    />
    <path
      d='M62.9683 150.271C70.7334 150.271 77.0283 143.976 77.0283 136.21C77.0283 128.445 70.7334 122.15 62.9683 122.15C55.2031 122.15 48.9082 128.445 48.9082 136.21C48.9082 143.976 55.2031 150.271 62.9683 150.271Z'
      fill='#413BBC'
      stroke='#413BBC'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M62.9684 129.624V142.797M56.3818 136.211H69.555'
      stroke='white'
      strokeWidth='1.67'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <filter
        id='filter0_dd_9690_151951'
        x='31.4941'
        y='32.6934'
        width='108.421'
        height='108.421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='2'
          operator='erode'
          in='SourceAlpha'
          result='effect1_dropShadow_9690_151951'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_9690_151951'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='1'
          operator='erode'
          in='SourceAlpha'
          result='effect2_dropShadow_9690_151951'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='3' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_9690_151951'
          result='effect2_dropShadow_9690_151951'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_9690_151951'
          result='shape'
        />
      </filter>
      <filter
        id='filter1_dd_9690_151951'
        x='60.085'
        y='66.8877'
        width='108.421'
        height='108.421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='2'
          operator='erode'
          in='SourceAlpha'
          result='effect1_dropShadow_9690_151951'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='2' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_9690_151951'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='1'
          operator='erode'
          in='SourceAlpha'
          result='effect2_dropShadow_9690_151951'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='3' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_9690_151951'
          result='effect2_dropShadow_9690_151951'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_9690_151951'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_9690_151951'
        x1='85.7044'
        y1='43.3397'
        x2='85.7044'
        y2='132.114'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F6F6F6' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(113.754 46.4861) rotate(40.3645) scale(12.9171 13.3904)'>
        <stop stopColor='#FFCC02' />
        <stop offset='1' stopColor='#FFCC02' stopOpacity='0' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(126.057 43.5334) rotate(130.101) scale(12.2236 12.6714)'>
        <stop offset='0.078125' stopColor='#B28C35' />
        <stop offset='0.801556' stopColor='#FFCC02' />
      </radialGradient>
      <linearGradient
        id='paint3_linear_9690_151951'
        x1='104.65'
        y1='104.7'
        x2='69.6256'
        y2='123.95'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_9690_151951'
        x1='88.2905'
        y1='97.8263'
        x2='88.2559'
        y2='103.564'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_9690_151951'
        x1='99.0007'
        y1='115.466'
        x2='71.3008'
        y2='125.606'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_9690_151951'
        x1='87.7325'
        y1='108.357'
        x2='87.6787'
        y2='114.291'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(113.842 78.9709) rotate(170.891) scale(63.3981 20.4789)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_9690_151951'
        x1='64.5742'
        y1='80.577'
        x2='64.9056'
        y2='88.8241'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_9690_151951'
        x1='117.411'
        y1='67.9899'
        x2='109.953'
        y2='70.3772'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_9690_151951'
        x1='110.367'
        y1='71.6259'
        x2='110.043'
        y2='80.4423'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_9690_151951'
        x1='80.1358'
        y1='54.2734'
        x2='77.5487'
        y2='60.0325'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_9690_151951'
        x1='73.1432'
        y1='57.4423'
        x2='75.8039'
        y2='58.6038'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_9690_151951'
        x1='83.458'
        y1='58.2134'
        x2='80.3906'
        y2='64.5795'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_9690_151951'
        x1='76.0694'
        y1='61.8048'
        x2='78.9409'
        y2='62.9735'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_9690_151951'
        x1='86.2418'
        y1='61.2989'
        x2='82.5921'
        y2='68.1102'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_9690_151951'
        x1='78.8163'
        y1='65.3128'
        x2='81.7828'
        y2='66.3984'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_9690_151951'
        x1='89.5234'
        y1='63.9518'
        x2='85.3474'
        y2='71.2529'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_9690_151951'
        x1='81.8349'
        y1='68.3882'
        x2='84.9516'
        y2='69.4567'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_9690_151951'
        x1='92.2024'
        y1='66.8895'
        x2='87.3213'
        y2='73.3569'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_9690_151951'
        x1='86.0979'
        y1='71.5372'
        x2='88.6884'
        y2='72.2103'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint21_linear_9690_151951'
        x1='94.1499'
        y1='68.1803'
        x2='88.7838'
        y2='71.8336'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint22_linear_9690_151951'
        x1='90.5857'
        y1='73.4618'
        x2='92.1721'
        y2='73.6736'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_9690_151951'
        x1='98.6737'
        y1='70.4166'
        x2='93.8959'
        y2='74.4576'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_9690_151951'
        x1='94.9541'
        y1='74.853'
        x2='96.594'
        y2='75.125'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint25_linear_9690_151951'
        x1='65.715'
        y1='59.4351'
        x2='65.715'
        y2='68.9319'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='paint26_linear_9690_151951'
        x1='67.9008'
        y1='62.3349'
        x2='65.7613'
        y2='66.841'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.377114' stopColor='#413BBC' />
        <stop offset='0.699087' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint27_linear_9690_151951'
        x1='63.8951'
        y1='64.2066'
        x2='65.4881'
        y2='64.7155'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint28_linear_9690_151951'
        x1='114.295'
        y1='77.5341'
        x2='114.295'
        y2='166.308'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F6F6F6' />
      </linearGradient>
      <radialGradient
        id='paint29_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(142.345 80.6804) rotate(40.3645) scale(12.9171 13.3904)'>
        <stop stopColor='#FFCC02' />
        <stop offset='1' stopColor='#FFCC02' stopOpacity='0' />
      </radialGradient>
      <radialGradient
        id='paint30_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(154.648 77.7278) rotate(130.101) scale(12.2236 12.6714)'>
        <stop offset='0.078125' stopColor='#B28C35' />
        <stop offset='0.801556' stopColor='#FFCC02' />
      </radialGradient>
      <linearGradient
        id='paint31_linear_9690_151951'
        x1='133.24'
        y1='138.895'
        x2='98.2164'
        y2='158.144'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint32_linear_9690_151951'
        x1='116.881'
        y1='132.021'
        x2='116.847'
        y2='137.759'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint33_linear_9690_151951'
        x1='127.591'
        y1='149.66'
        x2='99.8916'
        y2='159.801'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint34_linear_9690_151951'
        x1='116.323'
        y1='142.551'
        x2='116.27'
        y2='148.485'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <radialGradient
        id='paint35_radial_9690_151951'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(142.433 113.165) rotate(170.891) scale(63.3981 20.4788)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint36_linear_9690_151951'
        x1='93.1651'
        y1='114.771'
        x2='93.4964'
        y2='123.018'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint37_linear_9690_151951'
        x1='146.002'
        y1='102.185'
        x2='138.544'
        y2='104.573'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='#F0F2FA' />
      </linearGradient>
      <linearGradient
        id='paint38_linear_9690_151951'
        x1='138.957'
        y1='105.821'
        x2='138.634'
        y2='114.638'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#431BBC' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint39_linear_9690_151951'
        x1='108.727'
        y1='88.4678'
        x2='106.14'
        y2='94.2268'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint40_linear_9690_151951'
        x1='101.734'
        y1='91.6366'
        x2='104.395'
        y2='92.7981'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint41_linear_9690_151951'
        x1='112.049'
        y1='92.4077'
        x2='108.981'
        y2='98.7739'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint42_linear_9690_151951'
        x1='104.66'
        y1='95.9991'
        x2='107.532'
        y2='97.1678'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint43_linear_9690_151951'
        x1='114.833'
        y1='95.4932'
        x2='111.183'
        y2='102.304'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint44_linear_9690_151951'
        x1='107.407'
        y1='99.5071'
        x2='110.374'
        y2='100.593'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint45_linear_9690_151951'
        x1='118.114'
        y1='98.1461'
        x2='113.938'
        y2='105.447'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint46_linear_9690_151951'
        x1='110.426'
        y1='102.583'
        x2='113.542'
        y2='103.651'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint47_linear_9690_151951'
        x1='120.793'
        y1='101.084'
        x2='115.912'
        y2='107.551'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint48_linear_9690_151951'
        x1='114.689'
        y1='105.732'
        x2='117.279'
        y2='106.405'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint49_linear_9690_151951'
        x1='122.741'
        y1='102.375'
        x2='117.375'
        y2='106.028'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint50_linear_9690_151951'
        x1='119.177'
        y1='107.656'
        x2='120.763'
        y2='107.868'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint51_linear_9690_151951'
        x1='127.264'
        y1='104.611'
        x2='122.487'
        y2='108.652'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.261161' stopColor='#8E76D7' />
        <stop offset='0.648811' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint52_linear_9690_151951'
        x1='123.545'
        y1='109.047'
        x2='125.185'
        y2='109.319'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#8E76D7' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint53_linear_9690_151951'
        x1='94.3058'
        y1='93.6294'
        x2='94.3058'
        y2='103.126'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#F0EDFA' />
      </linearGradient>
      <linearGradient
        id='paint54_linear_9690_151951'
        x1='96.4916'
        y1='96.5292'
        x2='94.3521'
        y2='101.035'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.377114' stopColor='#413BBC' />
        <stop offset='0.699087' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint55_linear_9690_151951'
        x1='92.4859'
        y1='98.401'
        x2='94.0789'
        y2='98.9098'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);

export const EmptyAssignProductToUserSvg = () => (
  <svg
    width='200'
    height='201'
    viewBox='0 0 200 201'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M100 200.501C155.227 200.501 200 155.816 200 100.501C200 45.186 155.03 0.500916 100 0.500916C44.7732 0.500916 0 45.186 0 100.501C0 155.816 44.7732 200.501 100 200.501Z'
      fill='url(#paint0_linear_12124_362800)'
    />
    <path
      d='M152.789 187.642C155.536 187.642 157.763 185.407 157.763 182.65C157.763 179.893 155.536 177.658 152.789 177.658C150.041 177.658 147.814 179.893 147.814 182.65C147.814 185.407 150.041 187.642 152.789 187.642Z'
      fill='#DCDAE3'
    />
    <path
      d='M157.734 17.8994C159.394 17.8994 160.74 16.5488 160.74 14.8829C160.74 13.2169 159.394 11.8663 157.734 11.8663C156.074 11.8663 154.729 13.2169 154.729 14.8829C154.729 16.5488 156.074 17.8994 157.734 17.8994Z'
      fill='#C5B8EA'
    />
    <path
      d='M147.315 28.3947C150.499 28.3947 153.08 25.8046 153.08 22.6096C153.08 19.4146 150.499 16.8245 147.315 16.8245C144.132 16.8245 141.551 19.4146 141.551 22.6096C141.551 25.8046 144.132 28.3947 147.315 28.3947Z'
      fill='white'
    />
    <path
      d='M39.4346 171.371C42.6183 171.371 45.1993 168.781 45.1993 165.586C45.1993 162.391 42.6183 159.801 39.4346 159.801C36.2508 159.801 33.6699 162.391 33.6699 165.586C33.6699 168.781 36.2508 171.371 39.4346 171.371Z'
      fill='white'
    />
    <path
      d='M162.221 190.054C163.131 190.054 163.868 189.314 163.868 188.401C163.868 187.488 163.131 186.748 162.221 186.748C161.312 186.748 160.574 187.488 160.574 188.401C160.574 189.314 161.312 190.054 162.221 190.054Z'
      fill='#C5B8EA'
    />
    <path
      d='M38.3041 21.4101C40.6466 21.4101 42.5456 19.5043 42.5456 17.1535C42.5456 14.8026 40.6466 12.8969 38.3041 12.8969C35.9615 12.8969 34.0625 14.8026 34.0625 17.1535C34.0625 19.5043 35.9615 21.4101 38.3041 21.4101Z'
      fill='#C5B8EA'
    />
    <path
      d='M24.7155 23.8897C25.9208 23.8897 26.8979 22.9092 26.8979 21.6997C26.8979 20.4901 25.9208 19.5096 24.7155 19.5096C23.5103 19.5096 22.5332 20.4901 22.5332 21.6997C22.5332 22.9092 23.5103 23.8897 24.7155 23.8897Z'
      fill='#DCDAE3'
    />
    <path
      d='M26.673 176.534C28.4923 176.534 29.9671 175.054 29.9671 173.228C29.9671 171.403 28.4923 169.923 26.673 169.923C24.8537 169.923 23.3789 171.403 23.3789 173.228C23.3789 175.054 24.8537 176.534 26.673 176.534Z'
      fill='#C5B8EA'
    />
    <g filter='url(#filter0_i_12124_362800)'>
      <path
        d='M119.272 52.782L143.838 141.089C144.641 144.14 142.874 147.191 139.824 147.993L53.2825 170.953C50.2319 171.756 47.1813 169.99 46.3785 166.939L16.1934 52.9425C15.3906 49.8919 17.1567 46.8413 20.2073 46.0385L82.8253 29.5009L119.272 52.782Z'
        fill='url(#paint1_linear_12124_362800)'
      />
    </g>
    <g filter='url(#filter1_i_12124_362800)'>
      <path
        d='M117.986 108.656L71.2636 121.019L66.1257 122.303L50.5515 126.478C49.9093 126.638 49.4276 127.441 49.7487 128.244C49.9093 129.047 50.7121 129.528 51.3543 129.368L66.9285 125.193L72.0664 123.909L118.789 111.546C119.431 111.385 119.913 110.582 119.592 109.779C119.431 108.977 118.629 108.495 117.986 108.656Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter2_i_12124_362800)'>
      <path
        d='M114.937 97.7377L97.5963 102.233L91.6556 103.839L47.823 115.56C47.1807 115.72 46.6991 116.523 47.0202 117.326C47.1807 118.129 47.9835 118.61 48.6258 118.45L92.6189 106.729L98.5596 105.123L115.9 100.628C116.542 100.467 117.024 99.6644 116.703 98.8616C116.382 98.2194 115.579 97.5772 114.937 97.7377Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter3_i_12124_362800)'>
      <path
        d='M112.368 86.6601L107.872 87.7841L103.376 88.908L44.7722 104.482C44.13 104.643 43.6483 105.446 43.9694 106.248C44.13 107.051 44.9328 107.533 45.575 107.372L104.179 91.798L109.156 90.5136L113.17 89.3897C113.813 89.2291 114.294 88.4263 113.973 87.6235C113.813 86.9813 113.17 86.4996 112.368 86.6601Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter4_i_12124_362800)'>
      <path
        d='M85.2327 143.498L82.0215 144.301C81.3793 144.462 80.5765 143.98 80.4159 143.177C80.2554 142.374 80.5765 141.572 81.2187 141.411L84.4299 140.608C85.0721 140.448 85.8749 140.929 86.0355 141.732C86.196 142.695 85.8749 143.338 85.2327 143.498Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter5_i_12124_362800)'>
      <path
        d='M75.4389 146.067L56.9746 150.883C56.3324 151.044 55.5296 150.562 55.369 149.76C55.2085 148.957 55.5296 148.154 56.1718 147.993L74.6361 143.177C75.2784 143.016 76.0811 143.498 76.2417 144.301C76.5628 145.103 76.2417 145.906 75.4389 146.067Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter6_i_12124_362800)'>
      <path
        d='M110.121 75.5809L95.5098 79.4343L91.9775 80.3977L42.0437 93.5635C41.4014 93.7241 40.9198 94.5269 41.2409 95.3297C41.4014 96.1325 42.2042 96.6142 42.8465 96.4536L92.6198 83.4483L96.152 82.485L110.602 78.6315C111.405 78.471 111.726 77.6682 111.566 76.7048C111.566 76.0626 110.763 75.4204 110.121 75.5809Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter7_i_12124_362800)'>
      <path
        d='M75.5993 51.3366L34.1751 62.2546C33.2118 62.5757 32.2484 61.9335 31.9273 60.9701C31.6062 60.0068 32.2484 59.0434 33.2118 58.7223L74.636 47.8043C75.5993 47.4832 76.5627 48.1254 76.8838 49.0888C77.2049 50.0521 76.5627 51.0155 75.5993 51.3366Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter8_i_12124_362800)'>
      <path
        d='M52.8009 68.0353L36.9056 72.2099C35.9422 72.531 34.9789 71.8887 34.6578 70.9254C34.3366 69.962 34.9789 68.9987 35.9422 68.6776L51.677 64.503C52.6404 64.1819 53.6037 64.8241 53.9248 65.7875C54.2459 66.7509 53.6037 67.7142 52.8009 68.0353Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter9_i_12124_362800)'>
      <path
        d='M82.8262 29.5009L89.2485 53.9059C90.2119 57.2776 93.9047 59.3649 97.2765 58.4015L119.273 52.782'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#filter10_i_12124_362800)'>
      <path
        d='M183.504 77.1428L168.732 167.698C168.25 170.749 165.2 172.836 162.149 172.194L74.1628 156.78C71.1122 156.298 69.0249 153.248 69.5066 150.197L89.8976 34.113C90.3793 31.0623 93.4299 28.9751 96.4805 29.6173L160.383 40.8564L183.504 77.1428Z'
        fill='url(#paint2_linear_12124_362800)'
      />
    </g>
    <g filter='url(#filter11_i_12124_362800)'>
      <path
        d='M159.572 127.923L112.046 119.574L106.909 118.611L91.0133 115.881C90.371 115.721 89.5682 116.363 89.5682 117.166C89.4077 117.968 89.8893 118.771 90.5316 118.932L106.427 121.661L111.565 122.625L159.09 130.974C159.733 131.134 160.535 130.492 160.535 129.689C160.696 128.886 160.375 128.084 159.572 127.923Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter12_i_12124_362800)'>
      <path
        d='M161.499 116.845L143.838 113.794L137.897 112.67L93.1011 104.803C92.4589 104.642 91.6561 105.284 91.6561 106.087C91.4956 106.89 91.9772 107.693 92.6195 107.853L137.415 115.721L143.356 116.845L161.018 119.895C161.66 120.056 162.463 119.414 162.463 118.611C162.623 117.808 162.142 117.005 161.499 116.845Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter13_i_12124_362800)'>
      <path
        d='M163.749 105.605L159.093 104.802L154.437 103.999L94.7086 93.5632C94.0663 93.4026 93.2635 94.0448 93.2635 94.8476C93.103 95.6504 93.5847 96.4532 94.2269 96.6138L153.955 107.05L159.093 108.013L163.107 108.656C163.749 108.816 164.552 108.174 164.552 107.371C164.873 106.568 164.552 105.766 163.749 105.605Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter14_i_12124_362800)'>
      <path
        d='M115.26 145.905L112.049 145.423C111.407 145.263 110.925 144.46 111.086 143.657C111.246 142.854 111.889 142.212 112.531 142.372L115.742 142.854C116.384 143.015 116.866 143.818 116.705 144.62C116.545 145.584 115.903 145.905 115.26 145.905Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter15_i_12124_362800)'>
      <path
        d='M105.465 144.141L86.68 140.93C86.0378 140.769 85.5561 139.966 85.7167 139.163C85.8772 138.361 86.5195 137.718 87.1617 137.879L105.947 141.09C106.589 141.251 107.071 142.054 106.91 142.856C106.75 143.82 106.108 144.301 105.465 144.141Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter16_i_12124_362800)'>
      <path
        d='M166.315 94.6883L151.383 92.1194L147.69 91.4771L96.7926 82.4858C96.1503 82.3253 95.3475 82.9675 95.3475 83.7703C95.187 84.5731 95.6686 85.3759 96.3109 85.5364L147.208 94.5278L150.901 95.17L165.672 97.7389C166.475 97.8995 167.117 97.2572 167.278 96.4545C167.439 95.6517 166.957 94.8489 166.315 94.6883Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter17_i_12124_362800)'>
      <path
        d='M145.283 58.2412L103.056 50.8555C102.092 50.6949 101.45 49.7316 101.611 48.7682C101.771 47.8048 102.734 47.1626 103.698 47.3232L145.925 54.7089C146.888 54.8694 147.53 55.8328 147.37 56.7962C147.209 57.5989 146.246 58.4017 145.283 58.2412Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter18_i_12124_362800)'>
      <path
        d='M117.506 63.6993L101.29 60.8092C100.327 60.6486 99.6843 59.6853 99.8449 58.7219C100.005 57.7586 100.969 57.1163 101.932 57.2769L117.988 60.167C118.951 60.3275 119.594 61.2909 119.433 62.2542C119.273 63.2176 118.309 63.8598 117.506 63.6993Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter19_i_12124_362800)'>
      <path
        d='M160.858 41.3829L156.523 66.2695C155.88 69.8018 158.449 73.1736 161.982 73.8158L184.139 77.6692'
        fill='#F0EDFA'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_12124_362800'
        x='16'
        y='16.5009'
        width='138.031'
        height='154.646'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter1_i_12124_362800'
        x='49.6465'
        y='108.625'
        width='72.0469'
        height='21.7736'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter2_i_12124_362800'
        x='46.918'
        y='97.7128'
        width='71.8867'
        height='21.7678'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter3_i_12124_362800'
        x='43.8672'
        y='86.629'
        width='72.209'
        height='21.774'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter4_i_12124_362800'
        x='80.375'
        y='140.577'
        width='7.70117'
        height='4.75439'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter5_i_12124_362800'
        x='55.3281'
        y='143.146'
        width='23.0371'
        height='8.76837'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter6_i_12124_362800'
        x='41.1387'
        y='75.556'
        width='72.4668'
        height='21.9284'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter7_i_12124_362800'
        x='31.8438'
        y='47.7208'
        width='47.123'
        height='15.6174'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter8_i_12124_362800'
        x='34.5742'
        y='64.4195'
        width='21.4355'
        height='8.8739'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter9_i_12124_362800'
        x='82.8262'
        y='29.5009'
        width='36.4473'
        height='33.1362'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter10_i_12124_362800'
        x='69.4375'
        y='16.5009'
        width='124.066'
        height='155.809'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter11_i_12124_362800'
        x='89.5371'
        y='115.856'
        width='74.0391'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter12_i_12124_362800'
        x='91.625'
        y='104.778'
        width='73.8691'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter13_i_12124_362800'
        x='93.2324'
        y='93.5384'
        width='74.4414'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter14_i_12124_362800'
        x='111.055'
        y='142.348'
        width='8.68164'
        height='5.55707'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter15_i_12124_362800'
        x='85.6855'
        y='137.854'
        width='24.2559'
        height='8.31699'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter16_i_12124_362800'
        x='95.3164'
        y='82.4611'
        width='74.9922'
        height='17.3026'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter17_i_12124_362800'
        x='101.586'
        y='47.2986'
        width='48.8086'
        height='12.9633'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter18_i_12124_362800'
        x='99.8203'
        y='57.2523'
        width='22.6367'
        height='8.47156'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <filter
        id='filter19_i_12124_362800'
        x='156.424'
        y='41.3829'
        width='27.7148'
        height='40.2863'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_12124_362800'
        />
      </filter>
      <linearGradient
        id='paint0_linear_12124_362800'
        x1='66.6666'
        y1='-61.9991'
        x2='250'
        y2='400.501'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F0EDFA' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_12124_362800'
        x1='80.0156'
        y1='29.5009'
        x2='152.09'
        y2='165.46'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_12124_362800'
        x1='126.471'
        y1='29.5009'
        x2='203.935'
        y2='158.627'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);

export const EmptyAssignProductSearchSvg = () => (
  <svg
    width='206'
    height='216'
    viewBox='0 0 206 216'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M100 200.5C155.227 200.5 200 155.815 200 100.5C200 45.1855 155.03 0.500427 100 0.500427C44.7732 0.500427 0 45.1855 0 100.5C0 155.815 44.7732 200.5 100 200.5Z'
      fill='#F0EDFA'
    />
    <path
      d='M152.789 187.641C155.536 187.641 157.763 185.406 157.763 182.649C157.763 179.893 155.536 177.658 152.789 177.658C150.041 177.658 147.814 179.893 147.814 182.649C147.814 185.406 150.041 187.641 152.789 187.641Z'
      fill='#DCDAE3'
    />
    <path
      d='M157.734 17.8989C159.394 17.8989 160.74 16.5484 160.74 14.8824C160.74 13.2164 159.394 11.8658 157.734 11.8658C156.074 11.8658 154.729 13.2164 154.729 14.8824C154.729 16.5484 156.074 17.8989 157.734 17.8989Z'
      fill='#C5B8EA'
    />
    <path
      d='M147.315 28.3942C150.499 28.3942 153.08 25.8041 153.08 22.6091C153.08 19.4141 150.499 16.824 147.315 16.824C144.132 16.824 141.551 19.4141 141.551 22.6091C141.551 25.8041 144.132 28.3942 147.315 28.3942Z'
      fill='white'
    />
    <path
      d='M39.4346 171.37C42.6183 171.37 45.1993 168.78 45.1993 165.585C45.1993 162.39 42.6183 159.8 39.4346 159.8C36.2508 159.8 33.6699 162.39 33.6699 165.585C33.6699 168.78 36.2508 171.37 39.4346 171.37Z'
      fill='white'
    />
    <path
      d='M162.221 190.053C163.131 190.053 163.868 189.313 163.868 188.4C163.868 187.488 163.131 186.748 162.221 186.748C161.312 186.748 160.574 187.488 160.574 188.4C160.574 189.313 161.312 190.053 162.221 190.053Z'
      fill='#C5B8EA'
    />
    <path
      d='M38.3041 21.4096C40.6466 21.4096 42.5456 19.5038 42.5456 17.153C42.5456 14.8021 40.6466 12.8964 38.3041 12.8964C35.9615 12.8964 34.0625 14.8021 34.0625 17.153C34.0625 19.5038 35.9615 21.4096 38.3041 21.4096Z'
      fill='#C5B8EA'
    />
    <path
      d='M24.7155 23.8893C25.9208 23.8893 26.8979 22.9087 26.8979 21.6992C26.8979 20.4896 25.9208 19.5091 24.7155 19.5091C23.5103 19.5091 22.5332 20.4896 22.5332 21.6992C22.5332 22.9087 23.5103 23.8893 24.7155 23.8893Z'
      fill='#DCDAE3'
    />
    <path
      d='M26.673 176.534C28.4923 176.534 29.9671 175.054 29.9671 173.228C29.9671 171.402 28.4923 169.922 26.673 169.922C24.8537 169.922 23.3789 171.402 23.3789 173.228C23.3789 175.054 24.8537 176.534 26.673 176.534Z'
      fill='#C5B8EA'
    />
    <path
      d='M119.659 57.1508L143.109 140.512C143.875 143.369 142.128 146.203 139.271 146.969L57.7099 168.823C54.8527 169.589 51.8886 167.877 51.1578 165.15L22.3435 57.6137C21.5779 54.7565 23.3241 51.9222 26.1813 51.1566L85.2743 35.3227L119.659 57.1508Z'
      fill='url(#paint0_radial_12135_366923)'
    />
    <path
      d='M119.659 57.1508L143.109 140.512C143.875 143.369 142.128 146.203 139.271 146.969L57.7099 168.823C54.8527 169.589 51.8886 167.877 51.1578 165.15L22.3435 57.6137C21.5779 54.7565 23.3241 51.9222 26.1813 51.1566L85.2743 35.3227L119.659 57.1508Z'
      fill='url(#paint1_linear_12135_366923)'
      fill-opacity='0.8'
    />
    <path
      d='M101.057 51.564L41.6753 67.4754C39.7944 67.9794 37.964 67.5967 37.7093 66.6463C37.4546 65.6958 38.8485 64.4492 40.7294 63.9452L100.112 48.0338C101.992 47.5298 103.823 47.9125 104.078 48.8629C104.332 49.8134 102.938 51.06 101.057 51.564Z'
      fill='url(#paint2_linear_12135_366923)'
    />
    <path
      d='M101.057 51.564L41.6753 67.4754C39.7944 67.9794 37.964 67.5967 37.7093 66.6463C37.4546 65.6958 38.8485 64.4492 40.7294 63.9452L100.112 48.0338C101.992 47.5298 103.823 47.9125 104.078 48.8629C104.332 49.8134 102.938 51.06 101.057 51.564Z'
      fill='url(#paint3_linear_12135_366923)'
    />
    <path
      d='M101.74 62.7324L47.1392 77.3627C43.8443 78.2455 40.8019 78.1876 40.5472 77.2372C40.2925 76.2867 42.8984 74.7153 46.1933 73.8324L100.323 59.3283C103.618 58.4455 106.661 58.5034 106.915 59.4538C107.17 60.4043 104.564 61.9757 101.74 62.7324Z'
      fill='url(#paint4_linear_12135_366923)'
    />
    <path
      d='M101.74 62.7324L47.1392 77.3627C43.8443 78.2455 40.8019 78.1876 40.5472 77.2372C40.2925 76.2867 42.8984 74.7153 46.1933 73.8324L100.323 59.3283C103.618 58.4455 106.661 58.5034 106.915 59.4538C107.17 60.4043 104.564 61.9757 101.74 62.7324Z'
      fill='url(#paint5_linear_12135_366923)'
    />
    <path
      d='M106.544 72.0396L47.1617 87.951C45.2808 88.4549 43.4503 88.0722 43.1956 87.1218C42.9409 86.1714 44.3348 84.9247 46.2157 84.4207L105.598 68.5093C107.479 68.0053 109.309 68.388 109.564 69.3385C109.819 70.2889 108.425 71.5356 106.544 72.0396Z'
      fill='url(#paint6_linear_12135_366923)'
    />
    <path
      d='M106.544 72.0396L47.1617 87.951C45.2808 88.4549 43.4503 88.0722 43.1956 87.1218C42.9409 86.1714 44.3348 84.9247 46.2157 84.4207L105.598 68.5093C107.479 68.0053 109.309 68.388 109.564 69.3385C109.819 70.2889 108.425 71.5356 106.544 72.0396Z'
      fill='url(#paint7_linear_12135_366923)'
    />
    <path
      d='M109.382 82.6303L49.9995 98.5416C48.1187 99.0456 46.2882 98.6629 46.0335 97.7125C45.7788 96.7621 47.1727 95.5154 49.0536 95.0114L108.436 79.1C110.317 78.596 112.147 78.9787 112.402 79.9292C112.656 80.8796 111.263 82.1263 109.382 82.6303Z'
      fill='url(#paint8_linear_12135_366923)'
    />
    <path
      d='M109.382 82.6303L49.9995 98.5416C48.1187 99.0456 46.2882 98.6629 46.0335 97.7125C45.7788 96.7621 47.1727 95.5154 49.0536 95.0114L108.436 79.1C110.317 78.596 112.147 78.9787 112.402 79.9292C112.656 80.8796 111.263 82.1263 109.382 82.6303Z'
      fill='url(#paint9_linear_12135_366923)'
    />
    <path
      d='M112.22 93.2209L52.8374 109.132C50.9566 109.636 49.1261 109.254 48.8714 108.303C48.6167 107.353 50.0106 106.106 51.8915 105.602L111.274 89.6907C113.155 89.1867 114.985 89.5694 115.24 90.5199C115.494 91.4703 114.1 92.717 112.22 93.2209Z'
      fill='url(#paint10_linear_12135_366923)'
    />
    <path
      d='M112.22 93.2209L52.8374 109.132C50.9566 109.636 49.1261 109.254 48.8714 108.303C48.6167 107.353 50.0106 106.106 51.8915 105.602L111.274 89.6907C113.155 89.1867 114.985 89.5694 115.24 90.5199C115.494 91.4703 114.1 92.717 112.22 93.2209Z'
      fill='url(#paint11_linear_12135_366923)'
    />
    <path
      d='M115.057 103.812L55.6753 119.723C53.7944 120.227 51.964 119.844 51.7093 118.894C51.4546 117.943 52.8485 116.697 54.7294 116.193L114.112 100.281C115.992 99.7774 117.823 100.16 118.078 101.111C118.332 102.061 116.938 103.308 115.057 103.812Z'
      fill='url(#paint12_linear_12135_366923)'
    />
    <path
      d='M115.057 103.812L55.6753 119.723C53.7944 120.227 51.964 119.844 51.7093 118.894C51.4546 117.943 52.8485 116.697 54.7294 116.193L114.112 100.281C115.992 99.7774 117.823 100.16 118.078 101.111C118.332 102.061 116.938 103.308 115.057 103.812Z'
      fill='url(#paint13_linear_12135_366923)'
    />
    <path
      d='M117.706 113.696L58.3238 129.608C56.4429 130.112 54.6124 129.729 54.3577 128.778C54.1031 127.828 55.497 126.581 57.3778 126.077L116.76 110.166C118.641 109.662 120.471 110.045 120.726 110.995C120.981 111.946 119.587 113.192 117.706 113.696Z'
      fill='url(#paint14_linear_12135_366923)'
    />
    <path
      d='M117.706 113.696L58.3238 129.608C56.4429 130.112 54.6124 129.729 54.3577 128.778C54.1031 127.828 55.497 126.581 57.3778 126.077L116.76 110.166C118.641 109.662 120.471 110.045 120.726 110.995C120.981 111.946 119.587 113.192 117.706 113.696Z'
      fill='url(#paint15_linear_12135_366923)'
    />
    <path
      d='M120.544 124.287L61.1617 140.198C59.2808 140.702 57.4503 140.32 57.1956 139.369C56.9409 138.419 58.3348 137.172 60.2157 136.668L119.598 120.757C121.479 120.253 123.309 120.635 123.564 121.586C123.819 122.536 122.425 123.783 120.544 124.287Z'
      fill='url(#paint16_linear_12135_366923)'
    />
    <path
      d='M120.544 124.287L61.1617 140.198C59.2808 140.702 57.4503 140.32 57.1956 139.369C56.9409 138.419 58.3348 137.172 60.2157 136.668L119.598 120.757C121.479 120.253 123.309 120.635 123.564 121.586C123.819 122.536 122.425 123.783 120.544 124.287Z'
      fill='url(#paint17_linear_12135_366923)'
    />
    <path
      d='M123.382 134.878L63.9995 150.789C62.1187 151.293 60.2882 150.91 60.0335 149.96C59.7788 149.009 61.1727 147.763 63.0536 147.259L122.436 131.347C124.317 130.843 126.147 131.226 126.402 132.177C126.656 133.127 125.263 134.374 123.382 134.878Z'
      fill='url(#paint18_linear_12135_366923)'
    />
    <path
      d='M123.382 134.878L63.9995 150.789C62.1187 151.293 60.2882 150.91 60.0335 149.96C59.7788 149.009 61.1727 147.763 63.0536 147.259L122.436 131.347C124.317 130.843 126.147 131.226 126.402 132.177C126.656 133.127 125.263 134.374 123.382 134.878Z'
      fill='url(#paint19_linear_12135_366923)'
    />
    <path
      d='M85.2754 35.3226L91.4698 58.4403C92.3397 61.6872 95.893 63.5191 99.1398 62.6491L119.66 57.1507'
      fill='url(#paint20_linear_12135_366923)'
    />
    <path
      d='M181.033 86.6024L181.175 86.0461L180.909 85.5374L162.045 49.4414L161.74 48.8577L161.104 48.6873L102.011 32.8534C98.4019 31.8863 94.6144 33.8822 93.6217 37.5872L64.8074 145.123C63.8559 148.675 66.0723 152.444 69.7059 153.418L151.267 175.272C154.876 176.239 158.664 174.243 159.656 170.538L159.659 170.529L159.661 170.52L181.033 86.6024Z'
      fill='#8E76D7'
    />
    <path
      d='M181.033 86.6024L181.175 86.0461L180.909 85.5374L162.045 49.4414L161.74 48.8577L161.104 48.6873L102.011 32.8534C98.4019 31.8863 94.6144 33.8822 93.6217 37.5872L64.8074 145.123C63.8559 148.675 66.0723 152.444 69.7059 153.418L151.267 175.272C154.876 176.239 158.664 174.243 159.656 170.538L159.659 170.529L159.661 170.52L181.033 86.6024Z'
      fill='url(#paint21_radial_12135_366923)'
    />
    <path
      d='M181.033 86.6024L181.175 86.0461L180.909 85.5374L162.045 49.4414L161.74 48.8577L161.104 48.6873L102.011 32.8534C98.4019 31.8863 94.6144 33.8822 93.6217 37.5872L64.8074 145.123C63.8559 148.675 66.0723 152.444 69.7059 153.418L151.267 175.272C154.876 176.239 158.664 174.243 159.656 170.538L159.659 170.529L159.661 170.52L181.033 86.6024Z'
      fill='url(#paint22_linear_12135_366923)'
      fill-opacity='0.8'
    />
    <path
      d='M181.033 86.6024L181.175 86.0461L180.909 85.5374L162.045 49.4414L161.74 48.8577L161.104 48.6873L102.011 32.8534C98.4019 31.8863 94.6144 33.8822 93.6217 37.5872L64.8074 145.123C63.8559 148.675 66.0723 152.444 69.7059 153.418L151.267 175.272C154.876 176.239 158.664 174.243 159.656 170.538L159.659 170.529L159.661 170.52L181.033 86.6024Z'
      stroke='#F0EDFA'
      strokeWidth='3'
    />
    <path
      d='M166.263 72.093L106.881 56.1816C105 55.6777 103.606 54.431 103.861 53.4806C104.116 52.5301 105.946 52.1474 107.827 52.6514L167.209 68.5628C169.09 69.0668 170.484 70.3135 170.229 71.2639C169.975 72.2143 168.144 72.597 166.263 72.093Z'
      fill='url(#paint23_linear_12135_366923)'
    />
    <path
      d='M166.263 72.093L106.881 56.1816C105 55.6777 103.606 54.431 103.861 53.4806C104.116 52.5301 105.946 52.1474 107.827 52.6514L167.209 68.5628C169.09 69.0668 170.484 70.3135 170.229 71.2639C169.975 72.2143 168.144 72.597 166.263 72.093Z'
      fill='url(#paint24_linear_12135_366923)'
    />
    <path
      d='M161.27 82.1063L106.669 67.476C103.374 66.5932 100.768 65.0218 101.023 64.0713C101.278 63.1209 104.32 63.063 107.615 63.9458L161.745 78.4499C165.04 79.3328 167.646 80.9042 167.391 81.8547C167.137 82.8051 164.094 82.863 161.27 82.1063Z'
      fill='url(#paint25_linear_12135_366923)'
    />
    <path
      d='M161.27 82.1063L106.669 67.476C103.374 66.5932 100.768 65.0218 101.023 64.0713C101.278 63.1209 104.32 63.063 107.615 63.9458L161.745 78.4499C165.04 79.3328 167.646 80.9042 167.391 81.8547C167.137 82.8051 164.094 82.863 161.27 82.1063Z'
      fill='url(#paint26_linear_12135_366923)'
    />
    <path
      d='M160.777 92.5685L101.395 76.6571C99.5139 76.1531 98.12 74.9064 98.3747 73.956C98.6294 73.0055 100.46 72.6228 102.341 73.1268L161.723 89.0382C163.604 89.5422 164.998 90.7889 164.743 91.7393C164.488 92.6897 162.658 93.0724 160.777 92.5685Z'
      fill='url(#paint27_linear_12135_366923)'
    />
    <path
      d='M160.777 92.5685L101.395 76.6571C99.5139 76.1531 98.12 74.9064 98.3747 73.956C98.6294 73.0055 100.46 72.6228 102.341 73.1268L161.723 89.0382C163.604 89.5422 164.998 90.7889 164.743 91.7393C164.488 92.6897 162.658 93.0724 160.777 92.5685Z'
      fill='url(#paint28_linear_12135_366923)'
    />
    <path
      d='M157.939 103.159L98.5569 87.2477C96.676 86.7437 95.2821 85.4971 95.5368 84.5466C95.7915 83.5962 97.622 83.2135 99.5028 83.7175L158.885 99.6289C160.766 100.133 162.16 101.379 161.905 102.33C161.65 103.28 159.82 103.663 157.939 103.159Z'
      fill='url(#paint29_linear_12135_366923)'
    />
    <path
      d='M157.939 103.159L98.5569 87.2477C96.676 86.7437 95.2821 85.4971 95.5368 84.5466C95.7915 83.5962 97.622 83.2135 99.5028 83.7175L158.885 99.6289C160.766 100.133 162.16 101.379 161.905 102.33C161.65 103.28 159.82 103.663 157.939 103.159Z'
      fill='url(#paint30_linear_12135_366923)'
    />
    <path
      d='M155.101 113.75L95.719 97.8384C93.8381 97.3344 92.4442 96.0878 92.6989 95.1373C92.9536 94.1869 94.7841 93.8042 96.665 94.3082L156.047 110.22C157.928 110.724 159.322 111.97 159.067 112.921C158.813 113.871 156.982 114.254 155.101 113.75Z'
      fill='url(#paint31_linear_12135_366923)'
    />
    <path
      d='M155.101 113.75L95.719 97.8384C93.8381 97.3344 92.4442 96.0878 92.6989 95.1373C92.9536 94.1869 94.7841 93.8042 96.665 94.3082L156.047 110.22C157.928 110.724 159.322 111.97 159.067 112.921C158.813 113.871 156.982 114.254 155.101 113.75Z'
      fill='url(#paint32_linear_12135_366923)'
    />
    <path
      d='M152.263 124.34L92.8811 108.429C91.0003 107.925 89.6064 106.678 89.861 105.728C90.1157 104.778 91.9462 104.395 93.8271 104.899L153.209 120.81C155.09 121.314 156.484 122.561 156.229 123.511C155.975 124.462 154.144 124.844 152.263 124.34Z'
      fill='url(#paint33_linear_12135_366923)'
    />
    <path
      d='M152.263 124.34L92.8811 108.429C91.0003 107.925 89.6064 106.678 89.861 105.728C90.1157 104.778 91.9462 104.395 93.8271 104.899L153.209 120.81C155.09 121.314 156.484 122.561 156.229 123.511C155.975 124.462 154.144 124.844 152.263 124.34Z'
      fill='url(#paint34_linear_12135_366923)'
    />
    <path
      d='M149.615 134.225L90.2327 118.314C88.3518 117.81 86.9579 116.563 87.2126 115.613C87.4673 114.662 89.2977 114.28 91.1786 114.784L150.561 130.695C152.442 131.199 153.836 132.446 153.581 133.396C153.326 134.346 151.496 134.729 149.615 134.225Z'
      fill='url(#paint35_linear_12135_366923)'
    />
    <path
      d='M149.615 134.225L90.2327 118.314C88.3518 117.81 86.9579 116.563 87.2126 115.613C87.4673 114.662 89.2977 114.28 91.1786 114.784L150.561 130.695C152.442 131.199 153.836 132.446 153.581 133.396C153.326 134.346 151.496 134.729 149.615 134.225Z'
      fill='url(#paint36_linear_12135_366923)'
    />
    <path
      d='M146.777 144.816L87.3948 128.904C85.5139 128.4 84.12 127.154 84.3747 126.203C84.6294 125.253 86.4598 124.87 88.3407 125.374L147.723 141.286C149.604 141.79 150.998 143.036 150.743 143.987C150.488 144.937 148.658 145.32 146.777 144.816Z'
      fill='url(#paint37_linear_12135_366923)'
    />
    <path
      d='M146.777 144.816L87.3948 128.904C85.5139 128.4 84.12 127.154 84.3747 126.203C84.6294 125.253 86.4598 124.87 88.3407 125.374L147.723 141.286C149.604 141.79 150.998 143.036 150.743 143.987C150.488 144.937 148.658 145.32 146.777 144.816Z'
      fill='url(#paint38_linear_12135_366923)'
    />
    <path
      d='M143.939 155.407L84.5569 139.495C82.676 138.991 81.2821 137.744 81.5368 136.794C81.7915 135.844 83.622 135.461 85.5028 135.965L144.885 151.876C146.766 152.38 148.16 153.627 147.905 154.577C147.65 155.528 145.82 155.911 143.939 155.407Z'
      fill='url(#paint39_linear_12135_366923)'
    />
    <path
      d='M143.939 155.407L84.5569 139.495C82.676 138.991 81.2821 137.744 81.5368 136.794C81.7915 135.844 83.622 135.461 85.5028 135.965L144.885 151.876C146.766 152.38 148.16 153.627 147.905 154.577C147.65 155.528 145.82 155.911 143.939 155.407Z'
      fill='url(#paint40_linear_12135_366923)'
    />
    <path
      d='M160.715 50.1362L154.52 73.2539C153.65 76.5008 155.812 79.8639 159.059 80.7339L179.579 86.2322'
      fill='url(#paint41_linear_12135_366923)'
    />
    <path
      d='M110.568 184.721L110.571 184.723C118.947 192.659 130.26 197.221 141.615 197.221C150.691 197.221 159.606 194.359 167.314 188.934L188.998 210.617C190.58 212.365 192.629 213.204 194.704 213.204C198.122 213.204 201.087 210.755 202.5 207.93L202.579 207.772L202.635 207.603C202.885 206.853 203.255 205.554 203.099 203.993C202.936 202.366 202.224 200.651 200.641 199.069L178.743 177.17C187.737 163.366 188.569 146.399 180.936 131.853L180.931 131.845C172.995 116.854 158.249 108 141.476 108C116.886 108 96.8652 128.021 96.8652 152.611C96.8652 164.964 101.728 176.322 110.568 184.721ZM163.709 170.086L163.702 170.094C158.183 177.025 150.415 180.825 141.893 180.825C127.744 180.825 113.4 170.18 113.4 152.611C113.4 137.168 125.908 124.536 141.476 124.536C152.312 124.536 162.013 130.643 166.885 140.503C171.618 150.365 170.447 161.694 163.709 170.086Z'
      fill='#8E76D7'
    />
    <path
      d='M110.568 184.721L110.571 184.723C118.947 192.659 130.26 197.221 141.615 197.221C150.691 197.221 159.606 194.359 167.314 188.934L188.998 210.617C190.58 212.365 192.629 213.204 194.704 213.204C198.122 213.204 201.087 210.755 202.5 207.93L202.579 207.772L202.635 207.603C202.885 206.853 203.255 205.554 203.099 203.993C202.936 202.366 202.224 200.651 200.641 199.069L178.743 177.17C187.737 163.366 188.569 146.399 180.936 131.853L180.931 131.845C172.995 116.854 158.249 108 141.476 108C116.886 108 96.8652 128.021 96.8652 152.611C96.8652 164.964 101.728 176.322 110.568 184.721ZM163.709 170.086L163.702 170.094C158.183 177.025 150.415 180.825 141.893 180.825C127.744 180.825 113.4 170.18 113.4 152.611C113.4 137.168 125.908 124.536 141.476 124.536C152.312 124.536 162.013 130.643 166.885 140.503C171.618 150.365 170.447 161.694 163.709 170.086Z'
      fill='url(#paint42_radial_12135_366923)'
    />
    <path
      d='M110.568 184.721L110.571 184.723C118.947 192.659 130.26 197.221 141.615 197.221C150.691 197.221 159.606 194.359 167.314 188.934L188.998 210.617C190.58 212.365 192.629 213.204 194.704 213.204C198.122 213.204 201.087 210.755 202.5 207.93L202.579 207.772L202.635 207.603C202.885 206.853 203.255 205.554 203.099 203.993C202.936 202.366 202.224 200.651 200.641 199.069L178.743 177.17C187.737 163.366 188.569 146.399 180.936 131.853L180.931 131.845C172.995 116.854 158.249 108 141.476 108C116.886 108 96.8652 128.021 96.8652 152.611C96.8652 164.964 101.728 176.322 110.568 184.721ZM163.709 170.086L163.702 170.094C158.183 177.025 150.415 180.825 141.893 180.825C127.744 180.825 113.4 170.18 113.4 152.611C113.4 137.168 125.908 124.536 141.476 124.536C152.312 124.536 162.013 130.643 166.885 140.503C171.618 150.365 170.447 161.694 163.709 170.086Z'
      fill='url(#paint43_linear_12135_366923)'
      fill-opacity='0.8'
    />
    <path
      d='M110.568 184.721L110.571 184.723C118.947 192.659 130.26 197.221 141.615 197.221C150.691 197.221 159.606 194.359 167.314 188.934L188.998 210.617C190.58 212.365 192.629 213.204 194.704 213.204C198.122 213.204 201.087 210.755 202.5 207.93L202.579 207.772L202.635 207.603C202.885 206.853 203.255 205.554 203.099 203.993C202.936 202.366 202.224 200.651 200.641 199.069L178.743 177.17C187.737 163.366 188.569 146.399 180.936 131.853L180.931 131.845C172.995 116.854 158.249 108 141.476 108C116.886 108 96.8652 128.021 96.8652 152.611C96.8652 164.964 101.728 176.322 110.568 184.721ZM163.709 170.086L163.702 170.094C158.183 177.025 150.415 180.825 141.893 180.825C127.744 180.825 113.4 170.18 113.4 152.611C113.4 137.168 125.908 124.536 141.476 124.536C152.312 124.536 162.013 130.643 166.885 140.503C171.618 150.365 170.447 161.694 163.709 170.086Z'
      stroke='#F0EDFA'
      strokeWidth='5'
    />
    <path
      d='M141 183.5C158.121 183.5 172 169.621 172 152.5C172 135.38 158.121 121.5 141 121.5C123.879 121.5 110 135.38 110 152.5C110 169.621 123.879 183.5 141 183.5Z'
      fill='url(#paint44_radial_12135_366923)'
    />
    <path
      d='M137.817 160.002C137.669 159.409 137.669 158.816 137.669 158.075C137.669 155.555 138.707 153.332 141.375 151.405L143.598 149.774C144.932 148.737 145.525 147.551 145.525 146.069C145.525 143.994 144.043 141.918 140.93 141.918C137.669 141.918 136.187 144.587 136.187 147.106C136.187 147.699 136.187 148.144 136.335 148.589L130.406 148.44C130.258 147.848 130.109 147.106 130.109 146.365C130.109 141.326 133.815 136.582 140.782 136.582C147.897 136.582 151.751 141.177 151.751 145.772C151.751 149.478 149.824 151.998 147.156 153.925L145.229 155.259C143.598 156.445 142.709 157.927 142.709 159.706V160.002H137.817ZM140.337 162.967C142.412 162.967 144.043 164.597 144.043 166.672C144.043 168.748 142.412 170.378 140.337 170.378C138.262 170.378 136.631 168.748 136.631 166.672C136.78 164.746 138.262 162.967 140.337 162.967Z'
      fill='url(#paint45_linear_12135_366923)'
    />
    <path
      d='M137.817 160.002C137.669 159.409 137.669 158.816 137.669 158.075C137.669 155.555 138.707 153.332 141.375 151.405L143.598 149.774C144.932 148.737 145.525 147.551 145.525 146.069C145.525 143.994 144.043 141.918 140.93 141.918C137.669 141.918 136.187 144.587 136.187 147.106C136.187 147.699 136.187 148.144 136.335 148.589L130.406 148.44C130.258 147.848 130.109 147.106 130.109 146.365C130.109 141.326 133.815 136.582 140.782 136.582C147.897 136.582 151.751 141.177 151.751 145.772C151.751 149.478 149.824 151.998 147.156 153.925L145.229 155.259C143.598 156.445 142.709 157.927 142.709 159.706V160.002H137.817ZM140.337 162.967C142.412 162.967 144.043 164.597 144.043 166.672C144.043 168.748 142.412 170.378 140.337 170.378C138.262 170.378 136.631 168.748 136.631 166.672C136.78 164.746 138.262 162.967 140.337 162.967Z'
      fill='url(#paint46_linear_12135_366923)'
    />
    <defs>
      <radialGradient
        id='paint0_radial_12135_366923'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(109.227 36.4652) rotate(111.331) scale(158.396 156.219)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint1_linear_12135_366923'
        x1='43.1705'
        y1='75.3044'
        x2='98.4906'
        y2='157.896'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_12135_366923'
        x1='92.9876'
        y1='53.8811'
        x2='73.7974'
        y2='86.904'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_12135_366923'
        x1='73.1629'
        y1='54.5472'
        x2='74.1204'
        y2='58.1689'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_12135_366923'
        x1='95.8255'
        y1='64.472'
        x2='76.6353'
        y2='97.4949'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_12135_366923'
        x1='76.0007'
        y1='65.1381'
        x2='76.9582'
        y2='68.7598'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_12135_366923'
        x1='98.4739'
        y1='74.3566'
        x2='79.2837'
        y2='107.38'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_12135_366923'
        x1='78.6492'
        y1='75.0228'
        x2='79.6067'
        y2='78.6445'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_12135_366923'
        x1='101.312'
        y1='84.9473'
        x2='82.1216'
        y2='117.97'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_12135_366923'
        x1='81.4871'
        y1='85.6134'
        x2='82.4446'
        y2='89.2352'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_12135_366923'
        x1='104.15'
        y1='95.538'
        x2='84.9595'
        y2='128.561'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_12135_366923'
        x1='84.325'
        y1='96.2041'
        x2='85.2825'
        y2='99.8259'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_12135_366923'
        x1='106.988'
        y1='106.129'
        x2='87.7974'
        y2='139.152'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_12135_366923'
        x1='87.1629'
        y1='106.795'
        x2='88.1204'
        y2='110.417'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_12135_366923'
        x1='109.636'
        y1='116.013'
        x2='90.4459'
        y2='149.036'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_12135_366923'
        x1='89.8113'
        y1='116.679'
        x2='90.7688'
        y2='120.301'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_12135_366923'
        x1='112.474'
        y1='126.604'
        x2='93.2837'
        y2='159.627'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_12135_366923'
        x1='92.6492'
        y1='127.27'
        x2='93.6067'
        y2='130.892'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_12135_366923'
        x1='115.312'
        y1='137.195'
        x2='96.1216'
        y2='170.218'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_12135_366923'
        x1='95.4871'
        y1='137.861'
        x2='96.4446'
        y2='141.483'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_12135_366923'
        x1='87.7766'
        y1='55.0838'
        x2='96.4638'
        y2='36.7489'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='paint21_radial_12135_366923'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(180.888 63.1018) rotate(141.331) scale(158.396 156.219)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint22_linear_12135_366923'
        x1='104.262'
        y1='63.7094'
        x2='110.875'
        y2='162.896'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_12135_366923'
        x1='158.116'
        y1='70.0648'
        x2='124.985'
        y2='89.0684'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_12135_366923'
        x1='140.614'
        y1='60.7293'
        x2='139.633'
        y2='64.3445'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint25_linear_12135_366923'
        x1='155.278'
        y1='80.6555'
        x2='122.147'
        y2='99.6591'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint26_linear_12135_366923'
        x1='137.776'
        y1='71.32'
        x2='136.795'
        y2='74.9353'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint27_linear_12135_366923'
        x1='152.63'
        y1='90.5402'
        x2='119.499'
        y2='109.544'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint28_linear_12135_366923'
        x1='135.128'
        y1='81.2047'
        x2='134.146'
        y2='84.8199'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint29_linear_12135_366923'
        x1='149.792'
        y1='101.131'
        x2='116.661'
        y2='120.134'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint30_linear_12135_366923'
        x1='132.29'
        y1='91.7953'
        x2='131.308'
        y2='95.4105'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint31_linear_12135_366923'
        x1='146.954'
        y1='111.721'
        x2='113.823'
        y2='130.725'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint32_linear_12135_366923'
        x1='129.452'
        y1='102.386'
        x2='128.47'
        y2='106.001'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint33_linear_12135_366923'
        x1='144.116'
        y1='122.312'
        x2='110.985'
        y2='141.316'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint34_linear_12135_366923'
        x1='126.614'
        y1='112.977'
        x2='125.633'
        y2='116.592'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint35_linear_12135_366923'
        x1='141.468'
        y1='132.197'
        x2='108.337'
        y2='151.2'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint36_linear_12135_366923'
        x1='123.966'
        y1='122.861'
        x2='122.984'
        y2='126.477'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint37_linear_12135_366923'
        x1='138.63'
        y1='142.788'
        x2='105.499'
        y2='161.791'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint38_linear_12135_366923'
        x1='121.128'
        y1='133.452'
        x2='120.146'
        y2='137.067'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint39_linear_12135_366923'
        x1='135.792'
        y1='153.378'
        x2='102.661'
        y2='172.382'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint40_linear_12135_366923'
        x1='118.29'
        y1='144.043'
        x2='117.308'
        y2='147.658'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint41_linear_12135_366923'
        x1='153'
        y1='68.5005'
        x2='169.691'
        y2='56.9657'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='paint42_radial_12135_366923'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(194.467 116.508) rotate(133.565) scale(144.857 149.479)'>
        <stop offset='0.104973' stopColor='#413BBC' stopOpacity='0.9' />
        <stop offset='0.601387' stopColor='#8E76D7' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint43_linear_12135_366923'
        x1='115.896'
        y1='133.304'
        x2='137.176'
        y2='214.082'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.505084' stopColor='#413BBC' />
        <stop offset='1' stopColor='#8E76D7' />
      </linearGradient>
      <radialGradient
        id='paint44_radial_12135_366923'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(119.3 121.5) rotate(51.1988) scale(271.714 462.043)'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#8E76D7' />
      </radialGradient>
      <linearGradient
        id='paint45_linear_12135_366923'
        x1='152.03'
        y1='142.261'
        x2='131.361'
        y2='170.429'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.377114' stopColor='#413BBC' />
        <stop offset='0.699087' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint46_linear_12135_366923'
        x1='131.689'
        y1='156.95'
        x2='140.239'
        y2='158.717'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#413BBC' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
export const NoPromotionSvg = () => (
  <svg
    width='200'
    height='201'
    viewBox='0 0 200 201'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M100 200.5C155.227 200.5 200 155.815 200 100.5C200 45.185 155.03 0.5 100 0.5C44.7732 0.5 0 45.185 0 100.5C0 155.815 44.7732 200.5 100 200.5Z'
      fill='url(#paint0_linear_11246_331624)'
    />
    <path
      d='M152.789 187.641C155.536 187.641 157.763 185.406 157.763 182.649C157.763 179.892 155.536 177.657 152.789 177.657C150.042 177.657 147.815 179.892 147.815 182.649C147.815 185.406 150.042 187.641 152.789 187.641Z'
      fill='#DCDAE3'
    />
    <path
      d='M157.734 17.8985C159.394 17.8985 160.74 16.5479 160.74 14.8819C160.74 13.216 159.394 11.8654 157.734 11.8654C156.074 11.8654 154.728 13.216 154.728 14.8819C154.728 16.5479 156.074 17.8985 157.734 17.8985Z'
      fill='#C5B8EA'
    />
    <path
      d='M147.316 28.3938C150.5 28.3938 153.081 25.8037 153.081 22.6087C153.081 19.4136 150.5 16.8235 147.316 16.8235C144.133 16.8235 141.552 19.4136 141.552 22.6087C141.552 25.8037 144.133 28.3938 147.316 28.3938Z'
      fill='white'
    />
    <path
      d='M39.4345 171.37C42.6182 171.37 45.1992 168.78 45.1992 165.585C45.1992 162.39 42.6182 159.8 39.4345 159.8C36.2507 159.8 33.6698 162.39 33.6698 165.585C33.6698 168.78 36.2507 171.37 39.4345 171.37Z'
      fill='white'
    />
    <path
      d='M162.223 190.053C163.132 190.053 163.87 189.313 163.87 188.4C163.87 187.487 163.132 186.747 162.223 186.747C161.313 186.747 160.576 187.487 160.576 188.4C160.576 189.313 161.313 190.053 162.223 190.053Z'
      fill='#C5B8EA'
    />
    <path
      d='M38.3048 21.4092C40.6474 21.4092 42.5464 19.5034 42.5464 17.1526C42.5464 14.8017 40.6474 12.8959 38.3048 12.8959C35.9622 12.8959 34.0632 14.8017 34.0632 17.1526C34.0632 19.5034 35.9622 21.4092 38.3048 21.4092Z'
      fill='#C5B8EA'
    />
    <path
      d='M24.716 23.8888C25.9213 23.8888 26.8984 22.9083 26.8984 21.6988C26.8984 20.4892 25.9213 19.5087 24.716 19.5087C23.5108 19.5087 22.5337 20.4892 22.5337 21.6988C22.5337 22.9083 23.5108 23.8888 24.716 23.8888Z'
      fill='#DCDAE3'
    />
    <path
      d='M26.6744 176.533C28.4936 176.533 29.9685 175.053 29.9685 173.227C29.9685 171.402 28.4936 169.922 26.6744 169.922C24.8551 169.922 23.3802 171.402 23.3802 173.227C23.3802 175.053 24.8551 176.533 26.6744 176.533Z'
      fill='#C5B8EA'
    />
    <g filter='url(#filter0_i_11246_331624)'>
      <path
        d='M119.272 52.7811L143.838 141.089C144.641 144.139 142.874 147.19 139.824 147.993L53.2825 170.952C50.2319 171.755 47.1813 169.989 46.3785 166.939L16.1934 52.9416C15.3906 49.891 17.1567 46.8404 20.2073 46.0376L82.8253 29.5L119.272 52.7811Z'
        fill='url(#paint1_linear_11246_331624)'
      />
    </g>
    <g filter='url(#filter1_i_11246_331624)'>
      <path
        d='M117.987 108.655L71.2643 121.018L66.1264 122.302L50.5522 126.477C49.91 126.637 49.4283 127.44 49.7494 128.243C49.91 129.046 50.7128 129.527 51.355 129.367L66.9292 125.192L72.0671 123.908L118.79 111.545C119.432 111.384 119.914 110.581 119.593 109.778C119.432 108.976 118.629 108.494 117.987 108.655Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter2_i_11246_331624)'>
      <path
        d='M114.936 97.7369L97.5954 102.233L91.6547 103.838L47.8221 115.559C47.1799 115.719 46.6982 116.522 47.0193 117.325C47.1799 118.128 47.9827 118.61 48.6249 118.449L92.6181 106.728L98.5588 105.123L115.899 100.627C116.541 100.466 117.023 99.6636 116.702 98.8608C116.381 98.2185 115.578 97.5763 114.936 97.7369Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter3_i_11246_331624)'>
      <path
        d='M112.368 86.6592L107.872 87.7831L103.376 88.9071L44.7724 104.481C44.1302 104.642 43.6485 105.445 43.9696 106.247C44.1302 107.05 44.933 107.532 45.5752 107.371L104.179 91.7971L109.157 90.5126L113.171 89.3887C113.813 89.2282 114.294 88.4254 113.973 87.6226C113.813 86.9803 113.171 86.4987 112.368 86.6592Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter4_i_11246_331624)'>
      <path
        d='M85.2324 143.497L82.0213 144.3C81.379 144.461 80.5762 143.979 80.4157 143.176C80.2551 142.373 80.5762 141.571 81.2185 141.41L84.4296 140.607C85.0719 140.447 85.8747 140.928 86.0352 141.731C86.1958 142.695 85.8747 143.337 85.2324 143.497Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter5_i_11246_331624)'>
      <path
        d='M75.4396 146.066L56.9754 150.883C56.3331 151.043 55.5303 150.561 55.3698 149.759C55.2092 148.956 55.5303 148.153 56.1726 147.992L74.6369 143.176C75.2791 143.015 76.0819 143.497 76.2424 144.3C76.5636 145.102 76.2424 145.905 75.4396 146.066Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter6_i_11246_331624)'>
      <path
        d='M110.12 75.58L95.509 79.4334L91.9767 80.3968L42.0428 93.5626C41.4006 93.7232 40.9189 94.526 41.24 95.3288C41.4006 96.1316 42.2034 96.6132 42.8456 96.4527L92.6189 83.4474L96.1512 82.484L110.602 78.6306C111.404 78.4701 111.725 77.6673 111.565 76.7039C111.565 76.0617 110.762 75.4194 110.12 75.58Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter7_i_11246_331624)'>
      <path
        d='M75.5987 51.3357L34.1745 62.2537C33.2111 62.5748 32.2478 61.9326 31.9267 60.9692C31.6056 60.0059 32.2478 59.0425 33.2111 58.7214L74.6354 47.8034C75.5987 47.4823 76.5621 48.1245 76.8832 49.0879C77.2043 50.0512 76.5621 51.0146 75.5987 51.3357Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter8_i_11246_331624)'>
      <path
        d='M52.8005 68.0344L36.9052 72.2089C35.9419 72.5301 34.9785 71.8878 34.6574 70.9245C34.3363 69.9611 34.9785 68.9978 35.9419 68.6766L51.6766 64.5021C52.64 64.181 53.6033 64.8232 53.9245 65.7866C54.2456 66.7499 53.6033 67.7133 52.8005 68.0344Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter9_i_11246_331624)'>
      <path
        d='M82.8256 29.5L89.2479 53.905C90.2113 57.2767 93.9041 59.364 97.2759 58.4006L119.272 52.7811'
        fill='#F0EDFA'
      />
    </g>
    <g filter='url(#filter10_i_11246_331624)'>
      <path
        d='M183.503 77.1419L168.732 167.697C168.25 170.748 165.199 172.835 162.149 172.193L74.1623 156.779C71.1117 156.297 69.0245 153.247 69.5061 150.196L89.8971 34.112C90.3788 31.0614 93.4294 28.9742 96.48 29.6164L160.383 40.8555L183.503 77.1419Z'
        fill='url(#paint2_linear_11246_331624)'
      />
    </g>
    <g filter='url(#filter11_i_11246_331624)'>
      <path
        d='M159.572 127.922L112.046 119.573L106.908 118.61L91.0129 115.88C90.3707 115.72 89.5679 116.362 89.5679 117.165C89.4073 117.968 89.889 118.77 90.5312 118.931L106.427 121.66L111.564 122.624L159.09 130.973C159.732 131.133 160.535 130.491 160.535 129.688C160.695 128.886 160.374 128.083 159.572 127.922Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter12_i_11246_331624)'>
      <path
        d='M161.499 116.844L143.837 113.793L137.897 112.669L93.1007 104.802C92.4584 104.641 91.6556 105.283 91.6556 106.086C91.4951 106.889 91.9767 107.692 92.619 107.852L137.415 115.72L143.356 116.844L161.017 119.894C161.659 120.055 162.462 119.413 162.462 118.61C162.623 117.807 162.141 117.004 161.499 116.844Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter13_i_11246_331624)'>
      <path
        d='M163.748 105.604L159.091 104.801L154.435 103.999L94.7072 93.5622C94.065 93.4017 93.2622 94.0439 93.2622 94.8467C93.1016 95.6495 93.5833 96.4523 94.2255 96.6129L153.953 107.049L159.091 108.013L163.105 108.655C163.748 108.815 164.55 108.173 164.55 107.37C164.871 106.568 164.55 105.765 163.748 105.604Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter14_i_11246_331624)'>
      <path
        d='M115.259 145.904L112.048 145.422C111.406 145.262 110.924 144.459 111.085 143.656C111.245 142.853 111.887 142.211 112.53 142.372L115.741 142.853C116.383 143.014 116.865 143.817 116.704 144.619C116.544 145.583 115.901 145.904 115.259 145.904Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter15_i_11246_331624)'>
      <path
        d='M105.464 144.14L86.6786 140.929C86.0363 140.768 85.5546 139.965 85.7152 139.163C85.8758 138.36 86.518 137.718 87.1602 137.878L105.946 141.089C106.588 141.25 107.07 142.053 106.909 142.855C106.748 143.819 106.106 144.3 105.464 144.14Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter16_i_11246_331624)'>
      <path
        d='M166.315 94.6873L151.383 92.1184L147.69 91.4762L96.7928 82.4849C96.1506 82.3243 95.3478 82.9665 95.3478 83.7693C95.1872 84.5721 95.6689 85.3749 96.3111 85.5355L147.208 94.5268L150.901 95.169L165.673 97.738C166.475 97.8985 167.118 97.2563 167.278 96.4535C167.439 95.6507 166.957 94.8479 166.315 94.6873Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter17_i_11246_331624)'>
      <path
        d='M145.282 58.2403L103.055 50.8546C102.091 50.694 101.449 49.7306 101.61 48.7673C101.77 47.8039 102.734 47.1617 103.697 47.3223L145.924 54.708C146.887 54.8685 147.53 55.8319 147.369 56.7952C147.209 57.598 146.245 58.4008 145.282 58.2403Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter18_i_11246_331624)'>
      <path
        d='M117.506 63.6984L101.289 60.8083C100.326 60.6477 99.6839 59.6844 99.8444 58.721C100.005 57.7577 100.968 57.1154 101.932 57.276L117.988 60.1661C118.951 60.3266 119.593 61.29 119.433 62.2533C119.272 63.2167 118.309 63.8589 117.506 63.6984Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter19_i_11246_331624)'>
      <path
        d='M160.858 41.382L156.523 66.2686C155.881 69.8009 158.45 73.1726 161.982 73.8149L184.139 77.6683'
        fill='#F0EDFA'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_11246_331624'
        x='16'
        y='16.5'
        width='138.031'
        height='154.646'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter1_i_11246_331624'
        x='49.6472'
        y='108.624'
        width='72.0476'
        height='21.7736'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter2_i_11246_331624'
        x='46.9171'
        y='97.7119'
        width='71.8871'
        height='21.7678'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter3_i_11246_331624'
        x='43.8674'
        y='86.6281'
        width='72.2081'
        height='21.774'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter4_i_11246_331624'
        x='80.3748'
        y='140.576'
        width='7.70142'
        height='4.75439'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter5_i_11246_331624'
        x='55.3289'
        y='143.145'
        width='23.0366'
        height='8.76837'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter6_i_11246_331624'
        x='41.1378'
        y='75.5551'
        width='72.4672'
        height='21.9284'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter7_i_11246_331624'
        x='31.8431'
        y='47.7198'
        width='47.1235'
        height='15.6174'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter8_i_11246_331624'
        x='34.5739'
        y='64.4186'
        width='21.4351'
        height='8.8739'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter9_i_11246_331624'
        x='82.8256'
        y='29.5'
        width='36.4469'
        height='33.1362'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter10_i_11246_331624'
        x='69.437'
        y='16.5'
        width='124.066'
        height='155.809'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='10' dy='-13' />
        <feGaussianBlur stdDeviation='25' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter11_i_11246_331624'
        x='89.5367'
        y='115.855'
        width='74.0383'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter12_i_11246_331624'
        x='91.6245'
        y='104.777'
        width='73.8687'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter13_i_11246_331624'
        x='93.2311'
        y='93.5375'
        width='74.4424'
        height='17.1421'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter14_i_11246_331624'
        x='111.053'
        y='142.347'
        width='8.68176'
        height='5.55707'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter15_i_11246_331624'
        x='85.6841'
        y='137.853'
        width='24.256'
        height='8.31702'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter16_i_11246_331624'
        x='95.3167'
        y='82.4601'
        width='74.9927'
        height='17.3026'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter17_i_11246_331624'
        x='101.585'
        y='47.2977'
        width='48.8085'
        height='12.9633'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter18_i_11246_331624'
        x='99.8198'
        y='57.2514'
        width='22.6373'
        height='8.47156'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='4' dy='2' />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <filter
        id='filter19_i_11246_331624'
        x='156.424'
        y='41.382'
        width='27.7148'
        height='40.2863'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='6' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_11246_331624'
        />
      </filter>
      <linearGradient
        id='paint0_linear_11246_331624'
        x1='66.6666'
        y1='-62'
        x2='250'
        y2='400.5'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F0EDFA' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_11246_331624'
        x1='80.0156'
        y1='29.5'
        x2='152.09'
        y2='165.459'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_11246_331624'
        x1='126.47'
        y1='29.5'
        x2='203.934'
        y2='158.627'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);
